import { AlButton, AlCodeInput, AlForm, AlCheckbox, AlRadioGroup, AlCarousel, AlCarouselItem, AlList, AlListItem, AlNotify, AlInput, AlDropdown, AlAutocompleteInput, AlCardPreview, AlContactInput, AlStyledContainer, AlLoader, AlBranding, AlActionSheet, AlActionSheetItem, AlFlag, AlSearchableDropdownInput } from '@mc-alberta/alcapone';
import * as i18nData from '@mc-alberta/i18n-data';
import { filter } from 'vue-input-facade';

/**
 * Normalize address by splitting full name into first and last names
 *
 * If names are already split, just remove the joined name property
 *
 * @param {Object} address
 */
function splitAddressNames(address) {
  if (!address) return;
  const {
    name,
    ...splitAddress
  } = address;
  const [firstName = '', lastName = ''] = name?.split(/\s(.+)/) || [];

  // If missing first or last name, replace them both
  if (!splitAddress.firstName || !splitAddress.lastName) {
    splitAddress.firstName = firstName;
    splitAddress.lastName = lastName;
  }
  return splitAddress;
}

/**
 * Convert emvco and non-emvo cards to a common Mastercard non-emvco cards
 * @param {Object} address
 */
function transformEmvcoToMastercard(address) {
  const joinedName = [address.firstName, address.lastName].filter(Boolean).join(' ');
  const isNameAvailable = address.name || joinedName;
  const setName = address.name || joinedName;
  const transfomedAddress = {
    ...address,
    ...(isNameAvailable && {
      fullName: setName
    }),
    ...(address.city && {
      cityTown: address.city
    }),
    ...(address.state && {
      subdivision: address.state
    }),
    ...(address.zip && {
      postalCode: address.zip
    })
  };
  return transfomedAddress;
}

//
var script$n = {
  name: 'TuxAddressLabel',
  props: {
    address: {
      type: Object,
      required: true
    }
  },
  computed: {
    addressConfig() {
      const {
        fullName,
        ...addressConfig
      } = this.$i18nData.getCountryConfig(this.address.countryCode, false)?.address;
      return addressConfig;
    },
    comma() {
      return !this.transformedAddress.subdivision || !this.transformedAddress.cityTown ? '' : ',';
    },
    country() {
      const countryList = this.$i18nData.getTranslatedCountries(this.$i18n.locale);
      return countryList.filter(_ref => {
        let {
          value
        } = _ref;
        return value === this.address.countryCode;
      })[0]?.label;
    },
    isFullView() {
      return this.requiredFields.every(field => Boolean(this.transformedAddress[field]));
    },
    isPartialView() {
      const validPostalCode = this.transformedAddress.postalCode || !this.addressConfig.postalCode.required;
      return validPostalCode && this.transformedAddress.countryCode;
    },
    partialView() {
      return this.isPartialView && !this.transformedAddress.postalCode ? this.country : `${this.country}, ${this.transformedAddress.postalCode}`;
    },
    requiredFields() {
      return Object.keys(this.addressConfig).filter(field => {
        return Boolean(this.addressConfig[field].required);
      });
    },
    transformedAddress() {
      return transformEmvcoToMastercard(this.address);
    }
  }
};

function normalizeComponent(template, style, script, scopeId, isFunctionalTemplate, moduleIdentifier /* server only */, shadowMode, createInjector, createInjectorSSR, createInjectorShadow) {
    if (typeof shadowMode !== 'boolean') {
        createInjectorSSR = createInjector;
        createInjector = shadowMode;
        shadowMode = false;
    }
    // Vue.extend constructor export interop.
    const options = typeof script === 'function' ? script.options : script;
    // render functions
    if (template && template.render) {
        options.render = template.render;
        options.staticRenderFns = template.staticRenderFns;
        options._compiled = true;
        // functional template
        if (isFunctionalTemplate) {
            options.functional = true;
        }
    }
    // scopedId
    if (scopeId) {
        options._scopeId = scopeId;
    }
    let hook;
    if (moduleIdentifier) {
        // server build
        hook = function (context) {
            // 2.3 injection
            context =
                context || // cached call
                    (this.$vnode && this.$vnode.ssrContext) || // stateful
                    (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext); // functional
            // 2.2 with runInNewContext: true
            if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
                context = __VUE_SSR_CONTEXT__;
            }
            // inject component styles
            if (style) {
                style.call(this, createInjectorSSR(context));
            }
            // register component module identifier for async chunk inference
            if (context && context._registeredComponents) {
                context._registeredComponents.add(moduleIdentifier);
            }
        };
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        options._ssrRegister = hook;
    }
    else if (style) {
        hook = shadowMode
            ? function (context) {
                style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot));
            }
            : function (context) {
                style.call(this, createInjector(context));
            };
    }
    if (hook) {
        if (options.functional) {
            // register for functional component in vue file
            const originalRender = options.render;
            options.render = function renderWithStyleInjection(h, context) {
                hook.call(context);
                return originalRender(h, context);
            };
        }
        else {
            // inject component registration as beforeCreate hook
            const existing = options.beforeCreate;
            options.beforeCreate = existing ? [].concat(existing, hook) : [hook];
        }
    }
    return script;
}

/* script */
const __vue_script__$n = script$n;

/* template */
var __vue_render__$n = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("address", [_vm.transformedAddress.fullName ? _c("span", [_vm._v(_vm._s(_vm.transformedAddress.fullName)), _c("br")]) : _vm._e(), _vm._v(" "), _vm.isFullView ? [_vm.transformedAddress.line1 ? _c("span", [_vm._v(" " + _vm._s(_vm.transformedAddress.line1)), _c("br")]) : _vm._e(), _vm._v(" "), _vm.address.line2 ? _c("span", [_vm._v(_vm._s(_vm.address.line2)), _c("br")]) : _vm._e(), _vm._v(" "), _vm.address.line3 ? _c("span", [_vm._v(_vm._s(_vm.address.line3)), _c("br")]) : _vm._e(), _vm._v(" "), _c("span", [_vm._v(_vm._s(_vm.transformedAddress.cityTown) + _vm._s(_vm.comma) + " " + _vm._s(_vm.transformedAddress.subdivision) + "\n      " + _vm._s(_vm.transformedAddress.postalCode))])] : _vm.isPartialView ? [_c("span", [_vm._v(_vm._s(_vm.partialView))])] : _vm._e()], 2);
};
var __vue_staticRenderFns__$n = [];
__vue_render__$n._withStripped = true;

/* style */
const __vue_inject_styles__$n = undefined;
/* scoped */
const __vue_scope_id__$n = undefined;
/* module identifier */
const __vue_module_identifier__$n = undefined;
/* functional template */
const __vue_is_functional_template__$n = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$y = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$n,
  staticRenderFns: __vue_staticRenderFns__$n
}, __vue_inject_styles__$n, __vue_script__$n, __vue_scope_id__$n, __vue_is_functional_template__$n, __vue_module_identifier__$n, false, undefined, undefined, undefined);
var TuxAddressLabel = __vue_component__$y;

//
var script$m = {
  name: 'TuxVerification',
  components: {
    AlButton,
    AlCodeInput,
    AlForm
  },
  props: {
    /**
     * Should the form auto submit when the CVC field is filled
     */
    autoSubmit: {
      type: Boolean,
      default: false
    },
    /**
     * The heading text, only add it if you wish to override the default.
     */
    heading: {
      type: String,
      default: ''
    },
    /**
     * The subheading text, only send it if you wish to override the default.
     */
    subheading: {
      type: String,
      default: ''
    },
    /**
     * The primary cta, only send it if you wish to override the default.
     */
    primaryCta: {
      type: String,
      default: ''
    },
    /**
     * The secondary cta text, pass content to show secondary cta.
     */
    secondaryCta: {
      type: String,
      default: ''
    },
    /**
     * Set to true when the CVC code has been successfully accepted.
     */
    isSuccessful: {
      type: Boolean,
      default: false
    },
    /**
     * PAN Las Four.
     */
    panLastFour: {
      type: String,
      default: ''
    },
    /**
     * Mark the CVC field in an error state, and show this message.
     */
    manualErrorToken: {
      type: String,
      default: ''
    },
    /**
     * Modal to toggle from secondary CTA
     */
    modalName: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      code: ''
    };
  },
  computed: {
    disableContinueButton() {
      const validationError = this.hasValidationErrors !== undefined ? this.hasValidationErrors : this.errors?.any();
      return validationError;
    },
    manualError: {
      get() {
        return this.$t(this.manualErrorToken);
      },
      set(value) {
        this.$emit('update:manual-error-token', value);
      }
    }
  },
  async mounted() {
    await this.$validator.validateAll();
  },
  methods: {
    filled() {
      if (this.autoSubmit) {
        this.submit();
      }
    },
    submit() {
      this.$emit('submit', this.code);
    },
    cancel() {
      this.$emit('cancel');
      this.clearForm();
    },
    clearForm() {
      this.code = '';
      this.manualError = '';
    }
  }
};

const isOldIE = typeof navigator !== 'undefined' &&
    /msie [6-9]\\b/.test(navigator.userAgent.toLowerCase());
function createInjector(context) {
    return (id, style) => addStyle(id, style);
}
let HEAD;
const styles = {};
function addStyle(id, css) {
    const group = isOldIE ? css.media || 'default' : id;
    const style = styles[group] || (styles[group] = { ids: new Set(), styles: [] });
    if (!style.ids.has(id)) {
        style.ids.add(id);
        let code = css.source;
        if (css.map) {
            // https://developer.chrome.com/devtools/docs/javascript-debugging
            // this makes source maps inside style tags work properly in Chrome
            code += '\n/*# sourceURL=' + css.map.sources[0] + ' */';
            // http://stackoverflow.com/a/26603875
            code +=
                '\n/*# sourceMappingURL=data:application/json;base64,' +
                    btoa(unescape(encodeURIComponent(JSON.stringify(css.map)))) +
                    ' */';
        }
        if (!style.element) {
            style.element = document.createElement('style');
            style.element.type = 'text/css';
            if (css.media)
                style.element.setAttribute('media', css.media);
            if (HEAD === undefined) {
                HEAD = document.head || document.getElementsByTagName('head')[0];
            }
            HEAD.appendChild(style.element);
        }
        if ('styleSheet' in style.element) {
            style.styles.push(code);
            style.element.styleSheet.cssText = style.styles
                .filter(Boolean)
                .join('\n');
        }
        else {
            const index = style.ids.size - 1;
            const textNode = document.createTextNode(code);
            const nodes = style.element.childNodes;
            if (nodes[index])
                style.element.removeChild(nodes[index]);
            if (nodes.length)
                style.element.insertBefore(textNode, nodes[index]);
            else
                style.element.appendChild(textNode);
        }
    }
}

/* script */
const __vue_script__$m = script$m;

/* template */
var __vue_render__$m = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("al-form", {
    staticClass: "container text-align-left",
    on: {
      cta: function ($event) {
        return _vm.submit();
      }
    }
  }, [_c("div", {
    staticClass: "row-vertical-align-center"
  }, [_c("div", {
    staticClass: "col-full",
    attrs: {
      "data-test": "cvc-headings"
    }
  }, [_c("h1", {
    staticClass: "margin-bottom-sm"
  }, [_vm._v("\n        " + _vm._s(_vm.$t(_vm.heading || "cvc.heading")) + "\n      ")]), _vm._v(" "), _c("p", [_vm._v("\n        " + _vm._s(_vm.$t(_vm.subheading || "cvc.subheading", [_vm.panLastFour])) + "\n      ")])]), _vm._v(" "), _c("div", {
    staticClass: "row margin-left-none"
  }, [_c("div", {
    staticClass: "col flex-grow-zero"
  }, [_c("i", {
    staticClass: "icon-cvc"
  })]), _vm._v(" "), _c("div", {
    staticClass: "col flex-grow-zero"
  }, [_c("al-code-input", {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: "required|numeric|length:3",
      expression: "'required|numeric|length:3'"
    }, {
      name: "autofocus",
      rawName: "v-autofocus"
    }],
    staticClass: "margin-bottom-none margin-top-xs",
    attrs: {
      name: "cvc-input",
      "data-test": "cvc-input",
      length: 3,
      "manual-error": _vm.manualError,
      label: _vm.$t("cvc.label"),
      "is-successful": _vm.isSuccessful
    },
    on: {
      "update:manualError": function ($event) {
        _vm.manualError = $event;
      },
      "update:manual-error": function ($event) {
        _vm.manualError = $event;
      },
      filled: function ($event) {
        return _vm.filled();
      }
    },
    model: {
      value: _vm.code,
      callback: function ($$v) {
        _vm.code = $$v;
      },
      expression: "code"
    }
  })], 1)])]), _vm._v(" "), _c("div", {
    staticClass: "row row-vertical-align-bottom margin-top-sm"
  }, [_vm.$slots && _vm.$slots["consent"] ? _c("div", {
    staticClass: "margin-bottom-sm"
  }, [_vm._t("consent")], 2) : _vm._e(), _vm._v(" "), _c("div", {
    staticClass: "col-full"
  }, [!_vm.autoSubmit ? _c("al-button", {
    attrs: {
      type: "submit",
      disabled: _vm.disableContinueButton,
      label: _vm.$t(_vm.primaryCta || "cvc.primaryCTA"),
      name: "btn-continue",
      uppercase: ""
    }
  }) : _vm._e()], 1), _vm._v(" "), _vm.secondaryCta ? _c("div", {
    staticClass: "col-full align-center"
  }, [_c("button", {
    directives: [{
      name: "toggle",
      rawName: "v-toggle:al-modal",
      value: _vm.modalName,
      expression: "modalName",
      arg: "al-modal"
    }],
    staticClass: "btn--secondary",
    attrs: {
      type: "button",
      "data-test": "cancel-cvc"
    },
    on: {
      click: _vm.cancel
    }
  }, [_vm._v("\n        " + _vm._s(_vm.$t(_vm.secondaryCta)) + "\n      ")])]) : _vm._e()])]);
};
var __vue_staticRenderFns__$m = [];
__vue_render__$m._withStripped = true;

/* style */
const __vue_inject_styles__$m = function (inject) {
  if (!inject) return;
  inject("data-v-f8581828_0", {
    source: "\n.flex-grow-zero[data-v-f8581828] {\n  flex-grow: 0;\n}\n",
    map: {
      "version": 3,
      "sources": ["/vol_01/sys_apps_01/jenkins/workspace/Alberta_BERT_tuxedo_master/src/components/TuxCvcVerification.vue"],
      "names": [],
      "mappings": ";AAgLA;EACA,YAAA;AACA",
      "file": "TuxCvcVerification.vue",
      "sourcesContent": ["<template>\n  <al-form class=\"container text-align-left\" @cta=\"submit()\">\n    <div class=\"row-vertical-align-center\">\n      <div class=\"col-full\" data-test=\"cvc-headings\">\n        <h1 class=\"margin-bottom-sm\">\n          {{ $t(heading || 'cvc.heading') }}\n        </h1>\n        <p>\n          {{ $t(subheading || 'cvc.subheading', [panLastFour]) }}\n        </p>\n      </div>\n\n      <div class=\"row margin-left-none\">\n        <div class=\"col flex-grow-zero\">\n          <i class=\"icon-cvc\" />\n        </div>\n        <div class=\"col flex-grow-zero\">\n          <al-code-input\n            v-model=\"code\"\n            v-validate=\"'required|numeric|length:3'\"\n            v-autofocus\n            name=\"cvc-input\"\n            class=\"margin-bottom-none margin-top-xs\"\n            data-test=\"cvc-input\"\n            :length=\"3\"\n            :manual-error.sync=\"manualError\"\n            :label=\"$t('cvc.label')\"\n            :is-successful=\"isSuccessful\"\n            @filled=\"filled()\" />\n        </div>\n      </div>\n    </div>\n\n    <div class=\"row row-vertical-align-bottom margin-top-sm\">\n      <div v-if=\"$slots && $slots['consent']\" class=\"margin-bottom-sm\">\n        <slot name=\"consent\" />\n      </div>\n      <div class=\"col-full\">\n        <al-button\n          v-if=\"!autoSubmit\"\n          type=\"submit\"\n          :disabled=\"disableContinueButton\"\n          :label=\"$t(primaryCta || 'cvc.primaryCTA')\"\n          name=\"btn-continue\"\n          uppercase />\n      </div>\n      <div v-if=\"secondaryCta\" class=\"col-full align-center\">\n        <button\n          v-toggle:al-modal=\"modalName\"\n          class=\"btn--secondary\"\n          type=\"button\"\n          data-test=\"cancel-cvc\"\n          @click=\"cancel\">\n          {{ $t(secondaryCta) }}\n        </button>\n      </div>\n    </div>\n  </al-form>\n</template>\n\n<script>\nimport { AlButton, AlCodeInput, AlForm } from '@mc-alberta/alcapone'\n\nexport default {\n  name: 'TuxVerification',\n  components: { AlButton, AlCodeInput, AlForm },\n  props: {\n    /**\n     * Should the form auto submit when the CVC field is filled\n     */\n    autoSubmit: {\n      type: Boolean,\n      default: false\n    },\n    /**\n     * The heading text, only add it if you wish to override the default.\n     */\n    heading: {\n      type: String,\n      default: ''\n    },\n    /**\n     * The subheading text, only send it if you wish to override the default.\n     */\n    subheading: {\n      type: String,\n      default: ''\n    },\n    /**\n     * The primary cta, only send it if you wish to override the default.\n     */\n    primaryCta: {\n      type: String,\n      default: ''\n    },\n    /**\n     * The secondary cta text, pass content to show secondary cta.\n     */\n    secondaryCta: {\n      type: String,\n      default: ''\n    },\n    /**\n     * Set to true when the CVC code has been successfully accepted.\n     */\n    isSuccessful: {\n      type: Boolean,\n      default: false\n    },\n    /**\n     * PAN Las Four.\n     */\n    panLastFour: {\n      type: String,\n      default: ''\n    },\n    /**\n     * Mark the CVC field in an error state, and show this message.\n     */\n    manualErrorToken: {\n      type: String,\n      default: ''\n    },\n    /**\n     * Modal to toggle from secondary CTA\n     */\n    modalName: {\n      type: String,\n      default: ''\n    }\n  },\n  data() {\n    return {\n      code: ''\n    }\n  },\n  computed: {\n    disableContinueButton() {\n      const validationError =\n        this.hasValidationErrors !== undefined ? this.hasValidationErrors : this.errors?.any()\n      return validationError\n    },\n    manualError: {\n      get() {\n        return this.$t(this.manualErrorToken)\n      },\n      set(value) {\n        this.$emit('update:manual-error-token', value)\n      }\n    }\n  },\n  async mounted() {\n    await this.$validator.validateAll()\n  },\n  methods: {\n    filled() {\n      if (this.autoSubmit) {\n        this.submit()\n      }\n    },\n    submit() {\n      this.$emit('submit', this.code)\n    },\n    cancel() {\n      this.$emit('cancel')\n      this.clearForm()\n    },\n    clearForm() {\n      this.code = ''\n      this.manualError = ''\n    }\n  }\n}\n</script>\n\n<style scoped>\n.flex-grow-zero {\n  flex-grow: 0;\n}\n</style>\n"]
    },
    media: undefined
  });
};
/* scoped */
const __vue_scope_id__$m = "data-v-f8581828";
/* module identifier */
const __vue_module_identifier__$m = undefined;
/* functional template */
const __vue_is_functional_template__$m = false;
/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$w = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$m,
  staticRenderFns: __vue_staticRenderFns__$m
}, __vue_inject_styles__$m, __vue_script__$m, __vue_scope_id__$m, __vue_is_functional_template__$m, __vue_module_identifier__$m, false, createInjector, undefined, undefined);
var __vue_component__$x = __vue_component__$w;

var commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

function getDefaultExportFromCjs (x) {
	return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, 'default') ? x['default'] : x;
}

var constants = {
  ADDRESS_FORMAT: {
    FULL: 'FULL',
    NONE: 'NONE',
    POSTAL_CODE: 'POSTAL_CODE'
  },
  COUNTRY_FEATURES: {
    ENABLE_ADDRESS_AUTOCOMPLETE: 'ENABLE_ADDRESS_AUTOCOMPLETE',
    EXPLICIT_FRAUD_PROTECTION_CONSENT: 'EXPLICIT_FRAUD_PROTECTION_CONSENT',
    EXPLICIT_TERMS_CONSENT: 'EXPLICIT_TERMS_CONSENT',
    EXPLICIT_PRIVACY_CONSENT: 'EXPLICIT_PRIVACY_CONSENT'
  },
  PROMOTIONAL_MERCHANTS: {
    PRICELESS_PLANET: 'priceless-planet'
  },
  ACTION_SHEET: {
    DISPLAY_LOCALE: 'locale-action-sheet-display-locale',
    SELECT_COUNTRY: 'locale-action-sheet-select-country',
    SELECT_LANGUAGE: 'locale-action-sheet-select-language',
    SELECT_LANGUAGE_UNSUPPORTED: 'locale-action-sheet-select-language-unsupported',
    CONFIRM_COUNTRY: 'locale-action-sheet-confirm-country',
    CONFIRM_COUNTRY_AND_LANGUAGE: 'locale-action-sheet-confirm-country-and-language',
    CONFIRM_LANGUAGE: 'locale-action-sheet-confirm-language'
  },
  DATA_TEST: {
    ERROR: 'error-page',
    SUCCESS: 'success-page'
  },
  ROUTES: {
    ERROR: 'Error'
  },
  TIMEOUTS: {
    COPY: 4000
  },
  FEATURES: {}
};

//
var script$l = {
  name: 'TuxFraudProtection',
  components: {
    AlCheckbox
  },
  inject: ['$validator'],
  props: {
    /**
     * The name of the component, used to label the data-test element.
     */
    name: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      isChecked: false,
      showExplicitFraudProtection: false
    };
  },
  watch: {
    '$i18n.locale': {
      immediate: true,
      handler() {
        this.showExplicitFraudProtection = this.$i18nData.isCountryFeatureEnabled(constants.COUNTRY_FEATURES.EXPLICIT_FRAUD_PROTECTION_CONSENT, this.$i18n.locale);
      }
    }
  }
};

/* script */
const __vue_script__$l = script$l;

/* template */
var __vue_render__$l = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _vm.showExplicitFraudProtection ? _c("div", {
    staticClass: "row"
  }, [_c("div", {
    staticClass: "col-full"
  }, [_c("al-checkbox", {
    directives: [{
      name: "validate",
      rawName: "v-validate.immediate",
      value: "required:true",
      expression: "'required:true'",
      modifiers: {
        immediate: true
      }
    }],
    attrs: {
      name: _vm.name + "-fraud-protection-checkbox",
      label: _vm.$t("fraudConsent.explicit")
    },
    model: {
      value: _vm.isChecked,
      callback: function ($$v) {
        _vm.isChecked = $$v;
      },
      expression: "isChecked"
    }
  })], 1)]) : _vm._e();
};
var __vue_staticRenderFns__$l = [];
__vue_render__$l._withStripped = true;

/* style */
const __vue_inject_styles__$l = undefined;
/* scoped */
const __vue_scope_id__$l = undefined;
/* module identifier */
const __vue_module_identifier__$l = undefined;
/* functional template */
const __vue_is_functional_template__$l = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$v = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$l,
  staticRenderFns: __vue_staticRenderFns__$l
}, __vue_inject_styles__$l, __vue_script__$l, __vue_scope_id__$l, __vue_is_functional_template__$l, __vue_module_identifier__$l, false, undefined, undefined, undefined);
var TuxFraudProtection = __vue_component__$v;

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var script$k = {
  name: 'TuxGoogleConsent',
  props: {
    /**
     * Privacy Notice Url
     */
    privacyUrl: {
      type: String,
      required: true
    },
    /**
     * Terms & Conditions Url
     */
    termsUrl: {
      type: String,
      required: true
    }
  },
  computed: {
    localizedPrivacyURL() {
      const url = new URL(this.privacyUrl);
      url.searchParams.set('hl', this.$i18n.locale);
      return url.toString();
    },
    localizedTermsURL() {
      const url = new URL(this.termsUrl);
      url.searchParams.set('hl', this.$i18n.locale);
      return url.toString();
    }
  },
  methods: {
    handlePrivacyClick(event) {
      this.$emit('privacy-click', event);
    },
    handleTermsClick(event) {
      this.$emit('terms-click', event);
    }
  }
};

/* script */
const __vue_script__$k = script$k;

/* template */
var __vue_render__$k = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("div", {
    staticClass: "row"
  }, [_c("div", {
    staticClass: "col-full"
  }, [_c("i18n", {
    staticClass: "legal",
    attrs: {
      path: "google.consent",
      "data-test": "google-consent",
      tag: "p"
    }
  }, [_c("a", {
    attrs: {
      href: _vm.localizedTermsURL,
      target: "_blank",
      "data-test": "terms-and-conditions",
      place: "terms"
    },
    on: {
      click: _vm.handleTermsClick
    }
  }, [_vm._v(_vm._s(_vm.$t("google.terms")))]), _vm._v(" "), _c("a", {
    attrs: {
      href: _vm.localizedPrivacyURL,
      target: "_blank",
      "data-test": "privacy-policy",
      place: "privacy"
    },
    on: {
      click: _vm.handlePrivacyClick
    }
  }, [_vm._v(_vm._s(_vm.$t("google.privacy")))])])], 1)]);
};
var __vue_staticRenderFns__$k = [];
__vue_render__$k._withStripped = true;

/* style */
const __vue_inject_styles__$k = undefined;
/* scoped */
const __vue_scope_id__$k = undefined;
/* module identifier */
const __vue_module_identifier__$k = undefined;
/* functional template */
const __vue_is_functional_template__$k = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$u = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$k,
  staticRenderFns: __vue_staticRenderFns__$k
}, __vue_inject_styles__$k, __vue_script__$k, __vue_scope_id__$k, __vue_is_functional_template__$k, __vue_module_identifier__$k, false, undefined, undefined, undefined);
var TuxGoogleConsent = __vue_component__$u;

//
var script$j = {
  name: 'TuxVerificationOptions',
  components: {
    AlButton,
    AlRadioGroup
  },
  props: {
    /**
     * The issuer name to be displayed in the subheading
     */
    issuerName: {
      type: String,
      default: ''
    },
    /**
     * Mark the primary cta as loading
     */
    loading: {
      type: Boolean,
      default: false
    },
    /**
     * The merchant name to be displayed in the subheading
     */
    merchantName: {
      type: String,
      default: ''
    },
    /**
     * Shows the cancel button. Emits `cancel` when clicked
     */
    showCancelButton: {
      type: Boolean,
      default: false
    },
    /**
     * The initial credential reference to be selected by default when the page loads
     */
    selectedCredentialReference: {
      type: String,
      default: ''
    },
    /**
     * The heading to be displayed on the page. The heading in the props takes precedence
     */
    heading: {
      type: String,
      default: ''
    },
    /**
     * The subheading to be displayed on the page. The subheading in the props takes precedence
     */
    subheading: {
      type: String,
      default: ''
    },
    /**
     * The list of options such as phone numbers, emails, etc.
     * @type {{ new (): Array<{ value: string, label: string, subtext: string }> }}
     */
    options: {
      type: Array,
      required: true
    }
  },
  data() {
    return {
      value: this.selectedCredentialReference
    };
  },
  computed: {
    content() {
      const heading = this.heading || 'verificationOptions.heading';
      const subheading = this.issuerName ? this.subheading || 'verificationOptions.subheading' : '';
      return {
        heading,
        subheading
      };
    }
  },
  methods: {
    submit() {
      this.$emit('submit', this.value);
    },
    onCancel() {
      this.$emit('cancel');
    }
  }
};

/* script */
const __vue_script__$j = script$j;

/* template */
var __vue_render__$j = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("main", [_c("div", {
    staticClass: "container"
  }, [_c("div", {
    staticClass: "row"
  }, [_c("div", {
    staticClass: "col-full"
  }, [_c("h1", {
    staticClass: "heading-xl",
    attrs: {
      "data-test": "heading"
    }
  }, [_vm._v("\n          " + _vm._s(_vm.$t(_vm.content.heading)) + "\n        ")])]), _vm._v(" "), _vm.$t(_vm.content.subheading) ? _c("div", {
    staticClass: "col-full"
  }, [_c("h2", {
    staticClass: "heading-md weight-regular",
    attrs: {
      "data-test": "subheading"
    }
  }, [_vm._v("\n          " + _vm._s(_vm.$t(_vm.content.subheading, {
    issuer: _vm.issuerName,
    merchant: _vm.merchantName
  })) + "\n        ")])]) : _vm._e(), _vm._v(" "), _vm.options.length ? _c("div", {
    staticClass: "col-full"
  }, [_c("al-radio-group", {
    attrs: {
      items: _vm.options,
      "card-view": "",
      name: "verification-options"
    },
    model: {
      value: _vm.value,
      callback: function ($$v) {
        _vm.value = $$v;
      },
      expression: "value"
    }
  })], 1) : _vm._e()]), _vm._v(" "), _c("div", {
    staticClass: "row-vertical-align-bottom"
  }, [_c("div", {
    staticClass: "col-full"
  }, [_c("al-button", {
    attrs: {
      name: "form-submit-button",
      loading: _vm.loading,
      "aria-label": _vm.$t("button.continue"),
      label: _vm.$t("button.continue"),
      uppercase: ""
    },
    on: {
      click: function ($event) {
        return _vm.submit();
      }
    }
  })], 1), _vm._v(" "), _vm.showCancelButton ? _c("div", {
    staticClass: "col-full col-vertical-align-center"
  }, [_c("button", {
    staticClass: "btn--transparent btn--underlined color-gray-dark",
    attrs: {
      "data-test": "form-cancel-button",
      type: "button"
    },
    on: {
      click: _vm.onCancel
    }
  }, [_vm._v("\n          " + _vm._s(_vm.$t("button.cancel")) + "\n        ")])]) : _vm._e()])])]);
};
var __vue_staticRenderFns__$j = [];
__vue_render__$j._withStripped = true;

/* style */
const __vue_inject_styles__$j = undefined;
/* scoped */
const __vue_scope_id__$j = undefined;
/* module identifier */
const __vue_module_identifier__$j = undefined;
/* functional template */
const __vue_is_functional_template__$j = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$t = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$j,
  staticRenderFns: __vue_staticRenderFns__$j
}, __vue_inject_styles__$j, __vue_script__$j, __vue_scope_id__$j, __vue_is_functional_template__$j, __vue_module_identifier__$j, false, undefined, undefined, undefined);
var TuxVerificationOptions = __vue_component__$t;

//
const AuthenticationMethodType = {
  SMS_OTP: 'SMS_OTP',
  EMAIL_OTP: 'EMAIL_OTP',
  APP_AUTHENTICATON: 'APP_AUTHENTICATON'
};
const GUEST_VALUE = 'guest';
var script$i = {
  name: 'TuxMdesVerificationOptions',
  components: {
    TuxVerificationOptions
  },
  props: {
    /**
     * Allows the checkout as guest to be a option. This also allows guest to be emited
     */
    allowGuest: {
      type: Boolean,
      default: false
    },
    /**
     * Mark the primary cta as loading
     */
    loading: {
      type: Boolean,
      default: false
    },
    /**
     * The merchant name to be displayed in the subheading
     */
    merchantName: {
      type: String,
      default: ''
    },
    /**
     * The issuer name to be displayed in the subheading
     */
    issuerName: {
      type: String,
      default: ''
    },
    /**
     * Shows the cancel button. Emits Canceled when clicked
     */
    showCancelButton: {
      type: Boolean,
      default: false
    },
    /**
     * The initial credential reference to be selected by default when the page loads
     */
    selectedCredentialReference: {
      type: String,
      default: ''
    },
    /**
     *  See https://scm.mastercard.int/stash/projects/BERT/repos/types/browse/src/types/AuthenticationMethod.ts.
     *
     * TODO: When this is converted to TypeScript, we need to make sure the method is enforced
     */
    options: {
      type: Array,
      required: true
    }
  },
  computed: {
    content() {
      if (!this.selectedCredentialReference) {
        return {
          heading: 'authenticationMethod.primaryHeading',
          subheading: 'authenticationMethod.primarySubheading'
        };
      }
      return {
        heading: 'authenticationMethod.secondaryHeading',
        subheading: 'authenticationMethod.secondarySubheading'
      };
    },
    displayOptions() {
      const GUEST_CHECKOUT = {
        label: this.$t('authenticationMethod.guestCheckout'),
        value: GUEST_VALUE
      };
      const options = this.options.map(this.formatDisplayOptions);
      const selectedOptionIndex = options.findIndex(_ref => {
        let {
          isSelected
        } = _ref;
        return isSelected;
      });
      const hasPreselectedMethod = selectedOptionIndex >= 0;
      if (hasPreselectedMethod) {
        options.unshift(options.splice(selectedOptionIndex, 1).pop());
      }
      if (this.allowGuest) {
        options.push(GUEST_CHECKOUT);
      }
      return options;
    },
    selectedValue() {
      return this.selectedCredentialReference || this.displayOptions[0]?.value || '';
    }
  },
  methods: {
    formatDisplayOptions(method) {
      const {
        authenticationMethodType,
        authenticationCredentialReference
      } = method;
      return {
        isSelected: this.selectedCredentialReference === authenticationCredentialReference,
        value: authenticationCredentialReference,
        label: this.getLabelPath(authenticationCredentialReference, authenticationMethodType),
        subtext: authenticationMethodType === AuthenticationMethodType.APP_AUTHENTICATON ? '' : authenticationCredentialReference?.replace(/\*/g, '•')
      };
    },
    getLabelPath(authenticationCredentialReference, authenticationMethodType) {
      const prefix = this.selectedCredentialReference === authenticationCredentialReference ? 'resend' : 'send';
      const isCode = [AuthenticationMethodType.SMS_OTP, AuthenticationMethodType.EMAIL_OTP].includes(authenticationMethodType);
      const methodType = isCode ? 'Code' : 'PushNotification';
      return this.$t(`authenticationMethod.${prefix}${methodType}`);
    },
    submit(incomingValue) {
      let value = incomingValue;
      const emit = incomingValue === GUEST_VALUE ? GUEST_VALUE : 'submit';
      if (emit !== GUEST_VALUE) {
        value = this.options.find(_ref2 => {
          let {
            authenticationCredentialReference
          } = _ref2;
          return authenticationCredentialReference === incomingValue;
        });
      }
      this.$emit(emit, value);
    },
    onCancel() {
      this.$emit('cancel');
    }
  }
};

/* script */
const __vue_script__$i = script$i;

/* template */
var __vue_render__$i = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("tux-verification-options", {
    attrs: {
      heading: _vm.content.heading,
      subheading: _vm.content.subheading,
      "issuer-name": _vm.issuerName,
      "merchant-name": _vm.merchantName,
      options: _vm.displayOptions,
      "selected-credential-reference": _vm.selectedValue,
      "show-cancel-button": _vm.showCancelButton,
      loading: _vm.loading
    },
    on: {
      submit: _vm.submit,
      cancel: _vm.onCancel
    }
  });
};
var __vue_staticRenderFns__$i = [];
__vue_render__$i._withStripped = true;

/* style */
const __vue_inject_styles__$i = undefined;
/* scoped */
const __vue_scope_id__$i = undefined;
/* module identifier */
const __vue_module_identifier__$i = undefined;
/* functional template */
const __vue_is_functional_template__$i = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$r = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$i,
  staticRenderFns: __vue_staticRenderFns__$i
}, __vue_inject_styles__$i, __vue_script__$i, __vue_scope_id__$i, __vue_is_functional_template__$i, __vue_module_identifier__$i, false, undefined, undefined, undefined);
var __vue_component__$s = __vue_component__$r;

//
var script$h = {
  name: constants.ROUTES.ERROR,
  components: {
    AlButton
  },
  props: {
    /**
     * Button text
     */
    buttonText: {
      type: String,
      default: ''
    },
    /**
     * Header text
     */
    header: {
      type: String,
      required: true
    },
    /**
     * Message page text
     */
    message: {
      type: String,
      default: ''
    },
    /**
     * Classes for icon element
     */
    iconClass: {
      type: String,
      default: ''
    },
    /**
     * The name of the component, used to label the data-test element.
     */
    name: {
      type: String,
      required: true
    },
    /**
     * Secondary button text
     */
    secondaryButtonText: {
      type: String,
      default: ''
    },
    /**
     * Displays the sessionId only when a value is passed
     */
    sessionIdText: {
      type: String,
      default: ''
    },
    /**
     * Removes <main> tag so that this page can be used within another page
     */
    noMain: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      isCopyButtonEnabled: true
    };
  },
  computed: {
    customerServiceContact() {
      const {
        countryCode
      } = this.$i18nData.getLocaleParts(this.$i18n.locale) || {};
      const countryConfig = this.$i18nData.getCountryConfig(countryCode);
      const phoneNumber = countryConfig?.customerSupportPhoneNumber || '';
      const email = countryConfig?.customerSupportEmail || '';
      if (email) {
        return {
          href: `mailto:${email}`,
          val: email
        };
      } else {
        return {
          href: `tel:${phoneNumber}`,
          val: phoneNumber
        };
      }
    }
  },
  methods: {
    ctaAction(event) {
      this.$emit('cta-click', event);
    },
    secondaryCtaAction(event) {
      this.$emit('secondary-cta-click', event);
    },
    async copySessionId() {
      this.isCopyButtonEnabled = false;
      await navigator.clipboard.writeText(this.sessionIdText);
      setTimeout(() => {
        this.isCopyButtonEnabled = true;
      }, constants.TIMEOUTS.COPY);
    }
  }
};

/* script */
const __vue_script__$h = script$h;

/* template */
var __vue_render__$h = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c(_vm.noMain ? "div" : "main", {
    tag: "component",
    staticClass: "container",
    class: {
      "margin-bottom-md": !_vm.noMain
    },
    attrs: {
      "data-test": "tux-message-container-" + _vm.name
    }
  }, [_c("div", {
    staticClass: "row row-vertical-align-center"
  }, [_c("div", {
    staticClass: "col-vertical-align-center align-center",
    attrs: {
      "data-test": _vm.name,
      role: "alert"
    }
  }, [_vm.iconClass ? _c("i", {
    class: "h3 " + _vm.iconClass
  }) : _vm._e(), _vm._v(" "), _c("h1", {
    staticClass: "heading-xl"
  }, [_vm._v("\n        " + _vm._s(_vm.$t(_vm.header)) + "\n      ")]), _vm._v(" "), _vm.message ? _c("i18n", {
    attrs: {
      path: _vm.message,
      tag: "p"
    }
  }, [_c("a", {
    staticClass: "no-wrap",
    attrs: {
      href: _vm.customerServiceContact.href,
      place: "customerServiceNumber"
    }
  }, [_vm._v(_vm._s(_vm.customerServiceContact.val))])]) : _vm._e()], 1), _vm._v(" "), _vm.sessionIdText ? _c("div", {
    staticClass: "row fill margin-left-none margin-right-none align-center"
  }, [_c("div", {
    staticClass: "col"
  }, [_c("p", {
    staticClass: "heading-xs session-id-text"
  }, [_c("span", {
    attrs: {
      id: "sessionIdLabel"
    }
  }, [_vm._v(_vm._s(_vm.$t("sessionId.errorHeading")))]), _vm._v("\n          " + _vm._s(_vm.$t(_vm.sessionIdText)) + "\n        ")])]), _vm._v(" "), _c("div", {
    staticClass: "col-full col-vertical-align-center"
  }, [_c("al-button", {
    attrs: {
      name: "copy-button",
      label: _vm.isCopyButtonEnabled ? _vm.$t("sessionId.copy") : _vm.$t("sessionId.copied"),
      disabled: _vm.isCopyButtonEnabled ? false : true,
      icon: _vm.isCopyButtonEnabled ? "icon-copy" : "icon-copied",
      "tertiary-button": "",
      "aria-describedby": "sessionIdLabel",
      type: "button"
    },
    on: {
      click: _vm.copySessionId
    }
  })], 1)]) : _vm._e()]), _vm._v(" "), _vm.buttonText || _vm.secondaryButtonText ? _c("div", {
    staticClass: "row row-vertical-align-bottom"
  }, [_vm.buttonText ? _c("div", {
    staticClass: "col-full"
  }, [_c("button", {
    staticClass: "uppercase fill",
    attrs: {
      type: "button",
      "data-test": "action-button",
      "aria-label": _vm.$t(_vm.buttonText)
    },
    on: {
      click: function ($event) {
        $event.preventDefault();
        return _vm.ctaAction.apply(null, arguments);
      }
    }
  }, [_vm._v("\n        " + _vm._s(_vm.$t(_vm.buttonText)) + "\n      ")])]) : _vm._e(), _vm._v(" "), _vm.secondaryButtonText ? _c("div", {
    staticClass: "col-full align-center"
  }, [_c("button", {
    staticClass: "btn--secondary",
    attrs: {
      "data-test": "secondary-cta"
    },
    on: {
      click: function ($event) {
        $event.preventDefault();
        return _vm.secondaryCtaAction.apply(null, arguments);
      }
    }
  }, [_vm._v("\n        " + _vm._s(_vm.$t(_vm.secondaryButtonText)) + "\n      ")])]) : _vm._e()]) : _vm._e()]);
};
var __vue_staticRenderFns__$h = [];
__vue_render__$h._withStripped = true;

/* style */
const __vue_inject_styles__$h = function (inject) {
  if (!inject) return;
  inject("data-v-37c2e0d2_0", {
    source: "\n.session-id-text[data-v-37c2e0d2] {\n  color: var(--src-color-gray-highest);\n}\n.fade-enter-active[data-v-37c2e0d2],\n.fade-leave-active[data-v-37c2e0d2] {\n  transition: opacity 0.5s cubic-bezier(0.175, 0.885, 0.32, 1.275);\n}\n.fade-enter[data-v-37c2e0d2],\n.fade-leave[data-v-37c2e0d2] {\n  opacity: 0;\n}\n",
    map: {
      "version": 3,
      "sources": ["/vol_01/sys_apps_01/jenkins/workspace/Alberta_BERT_tuxedo_master/src/components/TuxMessage.vue"],
      "names": [],
      "mappings": ";AA6KA;EACA,oCAAA;AACA;AACA;;EAEA,gEAAA;AACA;AACA;;EAEA,UAAA;AACA",
      "file": "TuxMessage.vue",
      "sourcesContent": ["<template>\n  <component\n    :is=\"noMain ? 'div' : 'main'\"\n    :data-test=\"`tux-message-container-${name}`\"\n    class=\"container\"\n    :class=\"{ 'margin-bottom-md': !noMain }\">\n    <div class=\"row row-vertical-align-center\">\n      <div :data-test=\"name\" class=\"col-vertical-align-center align-center\" role=\"alert\">\n        <i v-if=\"iconClass\" :class=\"`h3 ${iconClass}`\" />\n        <h1 class=\"heading-xl\">\n          {{ $t(header) }}\n        </h1>\n        <i18n v-if=\"message\" :path=\"message\" tag=\"p\">\n          <a :href=\"customerServiceContact.href\" place=\"customerServiceNumber\" class=\"no-wrap\">{{\n            customerServiceContact.val\n          }}</a>\n        </i18n>\n      </div>\n      <div v-if=\"sessionIdText\" class=\"row fill margin-left-none margin-right-none align-center\">\n        <div class=\"col\">\n          <p class=\"heading-xs session-id-text\">\n            <span id=\"sessionIdLabel\">{{ $t('sessionId.errorHeading') }}</span>\n            {{ $t(sessionIdText) }}\n          </p>\n        </div>\n        <div class=\"col-full col-vertical-align-center\">\n          <al-button\n            name=\"copy-button\"\n            :label=\"isCopyButtonEnabled ? $t('sessionId.copy') : $t('sessionId.copied')\"\n            :disabled=\"isCopyButtonEnabled ? false : true\"\n            :icon=\"isCopyButtonEnabled ? 'icon-copy' : 'icon-copied'\"\n            tertiary-button\n            aria-describedby=\"sessionIdLabel\"\n            type=\"button\"\n            @click=\"copySessionId\">\n          </al-button>\n        </div>\n      </div>\n    </div>\n    <div v-if=\"buttonText || secondaryButtonText\" class=\"row row-vertical-align-bottom\">\n      <div v-if=\"buttonText\" class=\"col-full\">\n        <button\n          type=\"button\"\n          class=\"uppercase fill\"\n          data-test=\"action-button\"\n          :aria-label=\"$t(buttonText)\"\n          @click.prevent=\"ctaAction\">\n          {{ $t(buttonText) }}\n        </button>\n      </div>\n      <div v-if=\"secondaryButtonText\" class=\"col-full align-center\">\n        <button\n          class=\"btn--secondary\"\n          data-test=\"secondary-cta\"\n          @click.prevent=\"secondaryCtaAction\">\n          {{ $t(secondaryButtonText) }}\n        </button>\n      </div>\n    </div>\n  </component>\n</template>\n\n<script>\nimport { AlButton } from '@mc-alberta/alcapone'\nimport { ROUTES, TIMEOUTS } from '@/constants'\n\nexport default {\n  name: ROUTES.ERROR,\n  components: { AlButton },\n  props: {\n    /**\n     * Button text\n     */\n    buttonText: {\n      type: String,\n      default: ''\n    },\n    /**\n     * Header text\n     */\n    header: {\n      type: String,\n      required: true\n    },\n    /**\n     * Message page text\n     */\n    message: {\n      type: String,\n      default: ''\n    },\n    /**\n     * Classes for icon element\n     */\n    iconClass: {\n      type: String,\n      default: ''\n    },\n    /**\n     * The name of the component, used to label the data-test element.\n     */\n    name: {\n      type: String,\n      required: true\n    },\n    /**\n     * Secondary button text\n     */\n    secondaryButtonText: {\n      type: String,\n      default: ''\n    },\n    /**\n     * Displays the sessionId only when a value is passed\n     */\n    sessionIdText: {\n      type: String,\n      default: ''\n    },\n    /**\n     * Removes <main> tag so that this page can be used within another page\n     */\n    noMain: {\n      type: Boolean,\n      default: false\n    }\n  },\n  data() {\n    return {\n      isCopyButtonEnabled: true\n    }\n  },\n  computed: {\n    customerServiceContact() {\n      const { countryCode } = this.$i18nData.getLocaleParts(this.$i18n.locale) || {}\n\n      const countryConfig = this.$i18nData.getCountryConfig(countryCode)\n      const phoneNumber = countryConfig?.customerSupportPhoneNumber || ''\n      const email = countryConfig?.customerSupportEmail || ''\n\n      if (email) {\n        return {\n          href: `mailto:${email}`,\n          val: email\n        }\n      } else {\n        return {\n          href: `tel:${phoneNumber}`,\n          val: phoneNumber\n        }\n      }\n    }\n  },\n  methods: {\n    ctaAction(event) {\n      this.$emit('cta-click', event)\n    },\n    secondaryCtaAction(event) {\n      this.$emit('secondary-cta-click', event)\n    },\n    async copySessionId() {\n      this.isCopyButtonEnabled = false\n      await navigator.clipboard.writeText(this.sessionIdText)\n\n      setTimeout(() => {\n        this.isCopyButtonEnabled = true\n      }, TIMEOUTS.COPY)\n    }\n  }\n}\n</script>\n\n<style scoped>\n.session-id-text {\n  color: var(--src-color-gray-highest);\n}\n.fade-enter-active,\n.fade-leave-active {\n  transition: opacity 0.5s cubic-bezier(0.175, 0.885, 0.32, 1.275);\n}\n.fade-enter,\n.fade-leave {\n  opacity: 0;\n}\n</style>\n"]
    },
    media: undefined
  });
};
/* scoped */
const __vue_scope_id__$h = "data-v-37c2e0d2";
/* module identifier */
const __vue_module_identifier__$h = undefined;
/* functional template */
const __vue_is_functional_template__$h = false;
/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$p = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$h,
  staticRenderFns: __vue_staticRenderFns__$h
}, __vue_inject_styles__$h, __vue_script__$h, __vue_scope_id__$h, __vue_is_functional_template__$h, __vue_module_identifier__$h, false, createInjector, undefined, undefined);
var __vue_component__$q = __vue_component__$p;

/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0,
    MAX_SAFE_INTEGER = 9007199254740991,
    MAX_INTEGER = 1.7976931348623157e+308,
    NAN = 0 / 0;

/** Used as references for the maximum length and index of an array. */
var MAX_ARRAY_LENGTH = 4294967295;

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    mapTag = '[object Map]',
    objectTag = '[object Object]',
    promiseTag = '[object Promise]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    symbolTag = '[object Symbol]',
    weakMapTag = '[object WeakMap]';

var dataViewTag = '[object DataView]';

/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;

/** Used to match leading and trailing whitespace. */
var reTrim = /^\s+|\s+$/g;

/** Used to detect bad signed hexadecimal string values. */
var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

/** Used to detect binary string values. */
var reIsBinary = /^0b[01]+$/i;

/** Used to detect host constructors (Safari). */
var reIsHostCtor = /^\[object .+?Constructor\]$/;

/** Used to detect octal string values. */
var reIsOctal = /^0o[0-7]+$/i;

/** Used to detect unsigned integer values. */
var reIsUint = /^(?:0|[1-9]\d*)$/;

/** Used to compose unicode character classes. */
var rsAstralRange = '\\ud800-\\udfff',
    rsComboMarksRange = '\\u0300-\\u036f\\ufe20-\\ufe23',
    rsComboSymbolsRange = '\\u20d0-\\u20f0',
    rsVarRange = '\\ufe0e\\ufe0f';

/** Used to compose unicode capture groups. */
var rsAstral = '[' + rsAstralRange + ']',
    rsCombo = '[' + rsComboMarksRange + rsComboSymbolsRange + ']',
    rsFitz = '\\ud83c[\\udffb-\\udfff]',
    rsModifier = '(?:' + rsCombo + '|' + rsFitz + ')',
    rsNonAstral = '[^' + rsAstralRange + ']',
    rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}',
    rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]',
    rsZWJ = '\\u200d';

/** Used to compose unicode regexes. */
var reOptMod = rsModifier + '?',
    rsOptVar = '[' + rsVarRange + ']?',
    rsOptJoin = '(?:' + rsZWJ + '(?:' + [rsNonAstral, rsRegional, rsSurrPair].join('|') + ')' + rsOptVar + reOptMod + ')*',
    rsSeq = rsOptVar + reOptMod + rsOptJoin,
    rsSymbol = '(?:' + [rsNonAstral + rsCombo + '?', rsCombo, rsRegional, rsSurrPair, rsAstral].join('|') + ')';

/** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */
var reUnicode = RegExp(rsFitz + '(?=' + rsFitz + ')|' + rsSymbol + rsSeq, 'g');

/** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */
var reHasUnicode = RegExp('[' + rsZWJ + rsAstralRange  + rsComboMarksRange + rsComboSymbolsRange + rsVarRange + ']');

/** Built-in method references without a dependency on `root`. */
var freeParseInt = parseInt;

/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof commonjsGlobal == 'object' && commonjsGlobal && commonjsGlobal.Object === Object && commonjsGlobal;

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */
function arrayMap(array, iteratee) {
  var index = -1,
      length = array ? array.length : 0,
      result = Array(length);

  while (++index < length) {
    result[index] = iteratee(array[index], index, array);
  }
  return result;
}

/**
 * Converts an ASCII `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */
function asciiToArray(string) {
  return string.split('');
}

/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */
function baseTimes(n, iteratee) {
  var index = -1,
      result = Array(n);

  while (++index < n) {
    result[index] = iteratee(index);
  }
  return result;
}

/**
 * The base implementation of `_.values` and `_.valuesIn` which creates an
 * array of `object` property values corresponding to the property names
 * of `props`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array} props The property names to get values for.
 * @returns {Object} Returns the array of property values.
 */
function baseValues(object, props) {
  return arrayMap(props, function(key) {
    return object[key];
  });
}

/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function getValue(object, key) {
  return object == null ? undefined : object[key];
}

/**
 * Checks if `string` contains Unicode symbols.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {boolean} Returns `true` if a symbol is found, else `false`.
 */
function hasUnicode(string) {
  return reHasUnicode.test(string);
}

/**
 * Checks if `value` is a host object in IE < 9.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a host object, else `false`.
 */
function isHostObject(value) {
  // Many host objects are `Object` objects that can coerce to strings
  // despite having improperly defined `toString` methods.
  var result = false;
  if (value != null && typeof value.toString != 'function') {
    try {
      result = !!(value + '');
    } catch (e) {}
  }
  return result;
}

/**
 * Converts `iterator` to an array.
 *
 * @private
 * @param {Object} iterator The iterator to convert.
 * @returns {Array} Returns the converted array.
 */
function iteratorToArray(iterator) {
  var data,
      result = [];

  while (!(data = iterator.next()).done) {
    result.push(data.value);
  }
  return result;
}

/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */
function mapToArray(map) {
  var index = -1,
      result = Array(map.size);

  map.forEach(function(value, key) {
    result[++index] = [key, value];
  });
  return result;
}

/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}

/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */
function setToArray(set) {
  var index = -1,
      result = Array(set.size);

  set.forEach(function(value) {
    result[++index] = value;
  });
  return result;
}

/**
 * Converts `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */
function stringToArray(string) {
  return hasUnicode(string)
    ? unicodeToArray(string)
    : asciiToArray(string);
}

/**
 * Converts a Unicode `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */
function unicodeToArray(string) {
  return string.match(reUnicode) || [];
}

/** Used for built-in method references. */
var funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to detect overreaching core-js shims. */
var coreJsData = root['__core-js_shared__'];

/** Used to detect methods masquerading as native. */
var maskSrcKey = (function() {
  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
  return uid ? ('Symbol(src)_1.' + uid) : '';
}());

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString = objectProto.toString;

/** Used to detect if a method is native. */
var reIsNative = RegExp('^' +
  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
);

/** Built-in value references. */
var Symbol = root.Symbol,
    iteratorSymbol = Symbol ? Symbol.iterator : undefined,
    propertyIsEnumerable = objectProto.propertyIsEnumerable;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeFloor = Math.floor,
    nativeKeys = overArg(Object.keys, Object),
    nativeRandom = Math.random;

/* Built-in method references that are verified to be native. */
var DataView = getNative(root, 'DataView'),
    Map = getNative(root, 'Map'),
    Promise$1 = getNative(root, 'Promise'),
    Set$1 = getNative(root, 'Set'),
    WeakMap = getNative(root, 'WeakMap');

/** Used to detect maps, sets, and weakmaps. */
var dataViewCtorString = toSource(DataView),
    mapCtorString = toSource(Map),
    promiseCtorString = toSource(Promise$1),
    setCtorString = toSource(Set$1),
    weakMapCtorString = toSource(WeakMap);

/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */
function arrayLikeKeys(value, inherited) {
  // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
  // Safari 9 makes `arguments.length` enumerable in strict mode.
  var result = (isArray(value) || isArguments(value))
    ? baseTimes(value.length, String)
    : [];

  var length = result.length,
      skipIndexes = !!length;

  for (var key in value) {
    if ((inherited || hasOwnProperty.call(value, key)) &&
        !(skipIndexes && (key == 'length' || isIndex(key, length)))) {
      result.push(key);
    }
  }
  return result;
}

/**
 * The base implementation of `_.clamp` which doesn't coerce arguments.
 *
 * @private
 * @param {number} number The number to clamp.
 * @param {number} [lower] The lower bound.
 * @param {number} upper The upper bound.
 * @returns {number} Returns the clamped number.
 */
function baseClamp(number, lower, upper) {
  if (number === number) {
    if (upper !== undefined) {
      number = number <= upper ? number : upper;
    }
    if (lower !== undefined) {
      number = number >= lower ? number : lower;
    }
  }
  return number;
}

/**
 * The base implementation of `getTag`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
  return objectToString.call(value);
}

/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */
function baseIsNative(value) {
  if (!isObject(value) || isMasked(value)) {
    return false;
  }
  var pattern = (isFunction(value) || isHostObject(value)) ? reIsNative : reIsHostCtor;
  return pattern.test(toSource(value));
}

/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeys(object) {
  if (!isPrototype(object)) {
    return nativeKeys(object);
  }
  var result = [];
  for (var key in Object(object)) {
    if (hasOwnProperty.call(object, key) && key != 'constructor') {
      result.push(key);
    }
  }
  return result;
}

/**
 * The base implementation of `_.random` without support for returning
 * floating-point numbers.
 *
 * @private
 * @param {number} lower The lower bound.
 * @param {number} upper The upper bound.
 * @returns {number} Returns the random number.
 */
function baseRandom(lower, upper) {
  return lower + nativeFloor(nativeRandom() * (upper - lower + 1));
}

/**
 * Copies the values of `source` to `array`.
 *
 * @private
 * @param {Array} source The array to copy values from.
 * @param {Array} [array=[]] The array to copy values to.
 * @returns {Array} Returns `array`.
 */
function copyArray(source, array) {
  var index = -1,
      length = source.length;

  array || (array = Array(length));
  while (++index < length) {
    array[index] = source[index];
  }
  return array;
}

/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative(object, key) {
  var value = getValue(object, key);
  return baseIsNative(value) ? value : undefined;
}

/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
var getTag = baseGetTag;

// Fallback for data views, maps, sets, and weak maps in IE 11,
// for data views in Edge < 14, and promises in Node.js.
if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
    (Map && getTag(new Map) != mapTag) ||
    (Promise$1 && getTag(Promise$1.resolve()) != promiseTag) ||
    (Set$1 && getTag(new Set$1) != setTag) ||
    (WeakMap && getTag(new WeakMap) != weakMapTag)) {
  getTag = function(value) {
    var result = objectToString.call(value),
        Ctor = result == objectTag ? value.constructor : undefined,
        ctorString = Ctor ? toSource(Ctor) : undefined;

    if (ctorString) {
      switch (ctorString) {
        case dataViewCtorString: return dataViewTag;
        case mapCtorString: return mapTag;
        case promiseCtorString: return promiseTag;
        case setCtorString: return setTag;
        case weakMapCtorString: return weakMapTag;
      }
    }
    return result;
  };
}

/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */
function isIndex(value, length) {
  length = length == null ? MAX_SAFE_INTEGER : length;
  return !!length &&
    (typeof value == 'number' || reIsUint.test(value)) &&
    (value > -1 && value % 1 == 0 && value < length);
}

/**
 * Checks if the given arguments are from an iteratee call.
 *
 * @private
 * @param {*} value The potential iteratee value argument.
 * @param {*} index The potential iteratee index or key argument.
 * @param {*} object The potential iteratee object argument.
 * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
 *  else `false`.
 */
function isIterateeCall(value, index, object) {
  if (!isObject(object)) {
    return false;
  }
  var type = typeof index;
  if (type == 'number'
        ? (isArrayLike(object) && isIndex(index, object.length))
        : (type == 'string' && index in object)
      ) {
    return eq(object[index], value);
  }
  return false;
}

/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */
function isMasked(func) {
  return !!maskSrcKey && (maskSrcKey in func);
}

/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */
function isPrototype(value) {
  var Ctor = value && value.constructor,
      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;

  return value === proto;
}

/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to process.
 * @returns {string} Returns the source code.
 */
function toSource(func) {
  if (func != null) {
    try {
      return funcToString.call(func);
    } catch (e) {}
    try {
      return (func + '');
    } catch (e) {}
  }
  return '';
}

/**
 * Gets `n` random elements at unique keys from `collection` up to the
 * size of `collection`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Collection
 * @param {Array|Object} collection The collection to sample.
 * @param {number} [n=1] The number of elements to sample.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {Array} Returns the random elements.
 * @example
 *
 * _.sampleSize([1, 2, 3], 2);
 * // => [3, 1]
 *
 * _.sampleSize([1, 2, 3], 4);
 * // => [2, 3, 1]
 */
function sampleSize(collection, n, guard) {
  var index = -1,
      result = toArray(collection),
      length = result.length,
      lastIndex = length - 1;

  if ((guard ? isIterateeCall(collection, n, guard) : n === undefined)) {
    n = 1;
  } else {
    n = baseClamp(toInteger(n), 0, length);
  }
  while (++index < n) {
    var rand = baseRandom(index, lastIndex),
        value = result[rand];

    result[rand] = result[index];
    result[index] = value;
  }
  result.length = n;
  return result;
}

/**
 * Creates an array of shuffled values, using a version of the
 * [Fisher-Yates shuffle](https://en.wikipedia.org/wiki/Fisher-Yates_shuffle).
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to shuffle.
 * @returns {Array} Returns the new shuffled array.
 * @example
 *
 * _.shuffle([1, 2, 3, 4]);
 * // => [4, 1, 3, 2]
 */
function shuffle(collection) {
  return sampleSize(collection, MAX_ARRAY_LENGTH);
}

/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */
function eq(value, other) {
  return value === other || (value !== value && other !== other);
}

/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */
function isArguments(value) {
  // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
  return isArrayLikeObject(value) && hasOwnProperty.call(value, 'callee') &&
    (!propertyIsEnumerable.call(value, 'callee') || objectToString.call(value) == argsTag);
}

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */
function isArrayLike(value) {
  return value != null && isLength(value.length) && !isFunction(value);
}

/**
 * This method is like `_.isArrayLike` except that it also checks if `value`
 * is an object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array-like object,
 *  else `false`.
 * @example
 *
 * _.isArrayLikeObject([1, 2, 3]);
 * // => true
 *
 * _.isArrayLikeObject(document.body.children);
 * // => true
 *
 * _.isArrayLikeObject('abc');
 * // => false
 *
 * _.isArrayLikeObject(_.noop);
 * // => false
 */
function isArrayLikeObject(value) {
  return isObjectLike(value) && isArrayLike(value);
}

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 8-9 which returns 'object' for typed array and other constructors.
  var tag = isObject(value) ? objectToString.call(value) : '';
  return tag == funcTag || tag == genTag;
}

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength(value) {
  return typeof value == 'number' &&
    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return !!value && typeof value == 'object';
}

/**
 * Checks if `value` is classified as a `String` primitive or object.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a string, else `false`.
 * @example
 *
 * _.isString('abc');
 * // => true
 *
 * _.isString(1);
 * // => false
 */
function isString(value) {
  return typeof value == 'string' ||
    (!isArray(value) && isObjectLike(value) && objectToString.call(value) == stringTag);
}

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (isObjectLike(value) && objectToString.call(value) == symbolTag);
}

/**
 * Converts `value` to an array.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {Array} Returns the converted array.
 * @example
 *
 * _.toArray({ 'a': 1, 'b': 2 });
 * // => [1, 2]
 *
 * _.toArray('abc');
 * // => ['a', 'b', 'c']
 *
 * _.toArray(1);
 * // => []
 *
 * _.toArray(null);
 * // => []
 */
function toArray(value) {
  if (!value) {
    return [];
  }
  if (isArrayLike(value)) {
    return isString(value) ? stringToArray(value) : copyArray(value);
  }
  if (iteratorSymbol && value[iteratorSymbol]) {
    return iteratorToArray(value[iteratorSymbol]());
  }
  var tag = getTag(value),
      func = tag == mapTag ? mapToArray : (tag == setTag ? setToArray : values);

  return func(value);
}

/**
 * Converts `value` to a finite number.
 *
 * @static
 * @memberOf _
 * @since 4.12.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted number.
 * @example
 *
 * _.toFinite(3.2);
 * // => 3.2
 *
 * _.toFinite(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toFinite(Infinity);
 * // => 1.7976931348623157e+308
 *
 * _.toFinite('3.2');
 * // => 3.2
 */
function toFinite(value) {
  if (!value) {
    return value === 0 ? value : 0;
  }
  value = toNumber(value);
  if (value === INFINITY || value === -INFINITY) {
    var sign = (value < 0 ? -1 : 1);
    return sign * MAX_INTEGER;
  }
  return value === value ? value : 0;
}

/**
 * Converts `value` to an integer.
 *
 * **Note:** This method is loosely based on
 * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted integer.
 * @example
 *
 * _.toInteger(3.2);
 * // => 3
 *
 * _.toInteger(Number.MIN_VALUE);
 * // => 0
 *
 * _.toInteger(Infinity);
 * // => 1.7976931348623157e+308
 *
 * _.toInteger('3.2');
 * // => 3
 */
function toInteger(value) {
  var result = toFinite(value),
      remainder = result % 1;

  return result === result ? (remainder ? result - remainder : result) : 0;
}

/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */
function toNumber(value) {
  if (typeof value == 'number') {
    return value;
  }
  if (isSymbol(value)) {
    return NAN;
  }
  if (isObject(value)) {
    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
    value = isObject(other) ? (other + '') : other;
  }
  if (typeof value != 'string') {
    return value === 0 ? value : +value;
  }
  value = value.replace(reTrim, '');
  var isBinary = reIsBinary.test(value);
  return (isBinary || reIsOctal.test(value))
    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
    : (reIsBadHex.test(value) ? NAN : +value);
}

/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */
function keys(object) {
  return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
}

/**
 * Creates an array of the own enumerable string keyed property values of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property values.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.values(new Foo);
 * // => [1, 2] (iteration order is not guaranteed)
 *
 * _.values('hi');
 * // => ['h', 'i']
 */
function values(object) {
  return object ? baseValues(object, keys(object)) : [];
}

var lodash_shuffle = shuffle;

var shuffle$1 = /*@__PURE__*/getDefaultExportFromCjs(lodash_shuffle);

//
var script$g = {
  name: 'TuxProfileConfirmation',
  components: {
    AlCarousel,
    AlCarouselItem,
    AlList,
    AlListItem,
    AlNotify
  },
  props: {
    heading: {
      type: String,
      default: 'profileConfirmation.heading'
    },
    ctaLabel: {
      type: String,
      default: ''
    }
  },
  computed: {
    hasPromotionalMerchants() {
      return !!this.promotionalMerchants?.length;
    },
    countryCode() {
      return this.$i18nData.getLocaleParts(this.$i18n.locale).countryCode;
    },
    pricelessPlanetMerchant() {
      const countryConfig = this.$i18nData.getCountryConfig(this.countryCode);
      const promotionalMerchants = countryConfig?.promotionalMerchants;
      return promotionalMerchants?.find(merchants => merchants.name === constants.PROMOTIONAL_MERCHANTS.PRICELESS_PLANET);
    },
    pricelessPlanetUrl() {
      return this.pricelessPlanetMerchant?.url;
    },
    promotionalMerchants() {
      const countryConfig = this.$i18nData.getCountryConfig(this.countryCode);
      const promotionalMerchants = countryConfig?.promotionalMerchants?.filter(merchant => merchant.name !== constants.PROMOTIONAL_MERCHANTS.PRICELESS_PLANET);
      return promotionalMerchants ? shuffle$1(promotionalMerchants) : null;
    }
  },
  methods: {
    emitMerchantClick(merchant) {
      this.$emit('merchant-click', merchant);
    },
    emitCtaClick(event) {
      this.$emit('cta-click', event);
    },
    emitDonateClick() {
      this.$emit('donate-click', this.pricelessPlanetMerchant);
    },
    emitLearnMore(event) {
      this.$emit('learn-more-click', event);
    }
  }
};

/* script */
const __vue_script__$g = script$g;

/* template */
var __vue_render__$g = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("div", {
    staticClass: "container"
  }, [_vm._t("notification", function () {
    return [_c("al-notify", {
      attrs: {
        name: "page-notification",
        success: ""
      }
    }, [_vm._v(_vm._s(_vm.$t("profileConfirmation.defaultNotification")))])];
  }), _vm._v(" "), _c("div", {
    staticClass: "row margin-bottom-md"
  }, [_c("div", {
    staticClass: "col-full"
  }, [_c("h1", {
    staticClass: "display-xl"
  }, [_vm._v("\n        " + _vm._s(_vm.$t(_vm.heading)) + "\n      ")])])]), _vm._v(" "), _c("div", {
    staticClass: "row margin-bottom-sm"
  }, [_c("div", {
    staticClass: "col-full"
  }, [_vm.pricelessPlanetUrl ? _c("al-list", {
    attrs: {
      card: ""
    }
  }, [_c("al-list-item", {
    attrs: {
      wrap: "",
      name: "item1",
      "cta-icon": "",
      "no-fade": "",
      "data-test": "donate-card"
    }
  }, [_c("div", {
    staticClass: "row-vertical-align-center margin-left-none margin-right-none"
  }, [_c("div", {
    staticClass: "col-sm"
  }, [_c("i", {
    staticClass: "icon-gift"
  })]), _vm._v(" "), _c("div", {
    staticClass: "col padding-left-none"
  }, [_c("p", {
    staticClass: "heading-sm"
  }, [_vm._v("\n                " + _vm._s(_vm.$t("profileConfirmation.item1")) + "\n                "), _c("span", [_c("a", {
    attrs: {
      href: _vm.pricelessPlanetUrl,
      target: "_blank"
    },
    on: {
      click: function ($event) {
        return _vm.emitDonateClick();
      }
    }
  }, [_vm._v("\n                    " + _vm._s(_vm.$t("profileConfirmation.donateNow")) + "\n                  ")])])])])])])], 1) : _vm._e(), _vm._v(" "), _c("al-list", {
    attrs: {
      card: ""
    }
  }, [_c("al-list-item", {
    attrs: {
      wrap: "",
      name: "item2",
      "cta-icon": "",
      "no-fade": ""
    }
  }, [_c("div", {
    staticClass: "row-vertical-align-center margin-left-none margin-right-none"
  }, [_c("div", {
    staticClass: "col-sm"
  }, [_c("i", {
    staticClass: "icon-src"
  })]), _vm._v(" "), _c("div", {
    staticClass: "col padding-left-none"
  }, [_c("p", {
    staticClass: "heading-sm"
  }, [_vm._v(_vm._s(_vm.$t("profileConfirmation.item2")))])])])])], 1), _vm._v(" "), !_vm.hasPromotionalMerchants ? _c("al-list", {
    attrs: {
      card: ""
    }
  }, [_c("al-list-item", {
    attrs: {
      wrap: "",
      name: "item3",
      "cta-icon": "",
      "no-fade": ""
    }
  }, [_c("div", {
    staticClass: "row-vertical-align-center margin-left-none margin-right-none"
  }, [_c("div", {
    staticClass: "col-sm"
  }, [_c("i", {
    staticClass: "icon-security"
  })]), _vm._v(" "), _c("div", {
    staticClass: "col padding-left-none"
  }, [_c("p", {
    staticClass: "heading-sm"
  }, [_c("i18n", {
    attrs: {
      path: "profileConfirmation.item3"
    }
  }, [_c("span", {
    attrs: {
      place: "link"
    }
  }, [_c("a", {
    attrs: {
      href: _vm.$t("profileConfirmation.item3Link"),
      target: "_blank"
    },
    on: {
      click: function ($event) {
        return _vm.emitLearnMore();
      }
    }
  }, [_vm._v("\n                      " + _vm._s(_vm.$t("profileConfirmation.item3LinkText")) + "\n                    ")])])])], 1)])])])], 1) : _vm._e()], 1)]), _vm._v(" "), _vm.hasPromotionalMerchants ? _c("div", {
    staticClass: "row",
    attrs: {
      "data-test": "merchant-description"
    }
  }, [_c("div", {
    staticClass: "col-full"
  }, [_c("p", {
    staticClass: "heading-sm weight-semibold margin-bottom-none"
  }, [_vm._v("\n        " + _vm._s(_vm.$t("profileConfirmation.description")) + "\n      ")])])]) : _vm._e(), _vm._v(" "), _c("div", {
    staticClass: "row"
  }, [_c("div", {
    staticClass: "col-full"
  }, [_vm.hasPromotionalMerchants ? _c("al-carousel", {
    attrs: {
      name: "merchant-carousel"
    }
  }, _vm._l(_vm.promotionalMerchants, function (merchant) {
    return _c("al-carousel-item", {
      key: merchant.name,
      attrs: {
        "image-url": "./assets/img/" + merchant.name + ".png",
        "cta-url": merchant.url,
        name: merchant.name
      },
      nativeOn: {
        click: function ($event) {
          return _vm.emitMerchantClick(merchant);
        }
      }
    });
  }), 1) : _vm._e()], 1)]), _vm._v(" "), _vm.ctaLabel ? _c("div", {
    staticClass: "row-vertical-align-bottom",
    attrs: {
      "data-test": "primary-cta-container"
    }
  }, [_c("div", {
    staticClass: "col-full align-center"
  }, [_c("button", {
    staticClass: "uppercase fill",
    attrs: {
      type: "button",
      "data-test": "primary-cta",
      "aria-label": _vm.ctaLabel
    },
    on: {
      click: _vm.emitCtaClick
    }
  }, [_vm._v("\n        " + _vm._s(_vm.ctaLabel) + "\n      ")])])]) : _vm._e()], 2);
};
var __vue_staticRenderFns__$g = [];
__vue_render__$g._withStripped = true;

/* style */
const __vue_inject_styles__$g = undefined;
/* scoped */
const __vue_scope_id__$g = undefined;
/* module identifier */
const __vue_module_identifier__$g = undefined;
/* functional template */
const __vue_is_functional_template__$g = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$n = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$g,
  staticRenderFns: __vue_staticRenderFns__$g
}, __vue_inject_styles__$g, __vue_script__$g, __vue_scope_id__$g, __vue_is_functional_template__$g, __vue_module_identifier__$g, false, undefined, undefined, undefined);
var __vue_component__$o = __vue_component__$n;

var lodash_merge = {exports: {}};

/**
 * Lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright OpenJS Foundation and other contributors <https://openjsf.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */
lodash_merge.exports;

(function (module, exports) {
	/** Used as the size to enable large array optimizations. */
	var LARGE_ARRAY_SIZE = 200;

	/** Used to stand-in for `undefined` hash values. */
	var HASH_UNDEFINED = '__lodash_hash_undefined__';

	/** Used to detect hot functions by number of calls within a span of milliseconds. */
	var HOT_COUNT = 800,
	    HOT_SPAN = 16;

	/** Used as references for various `Number` constants. */
	var MAX_SAFE_INTEGER = 9007199254740991;

	/** `Object#toString` result references. */
	var argsTag = '[object Arguments]',
	    arrayTag = '[object Array]',
	    asyncTag = '[object AsyncFunction]',
	    boolTag = '[object Boolean]',
	    dateTag = '[object Date]',
	    errorTag = '[object Error]',
	    funcTag = '[object Function]',
	    genTag = '[object GeneratorFunction]',
	    mapTag = '[object Map]',
	    numberTag = '[object Number]',
	    nullTag = '[object Null]',
	    objectTag = '[object Object]',
	    proxyTag = '[object Proxy]',
	    regexpTag = '[object RegExp]',
	    setTag = '[object Set]',
	    stringTag = '[object String]',
	    undefinedTag = '[object Undefined]',
	    weakMapTag = '[object WeakMap]';

	var arrayBufferTag = '[object ArrayBuffer]',
	    dataViewTag = '[object DataView]',
	    float32Tag = '[object Float32Array]',
	    float64Tag = '[object Float64Array]',
	    int8Tag = '[object Int8Array]',
	    int16Tag = '[object Int16Array]',
	    int32Tag = '[object Int32Array]',
	    uint8Tag = '[object Uint8Array]',
	    uint8ClampedTag = '[object Uint8ClampedArray]',
	    uint16Tag = '[object Uint16Array]',
	    uint32Tag = '[object Uint32Array]';

	/**
	 * Used to match `RegExp`
	 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
	 */
	var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;

	/** Used to detect host constructors (Safari). */
	var reIsHostCtor = /^\[object .+?Constructor\]$/;

	/** Used to detect unsigned integer values. */
	var reIsUint = /^(?:0|[1-9]\d*)$/;

	/** Used to identify `toStringTag` values of typed arrays. */
	var typedArrayTags = {};
	typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
	typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
	typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
	typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
	typedArrayTags[uint32Tag] = true;
	typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
	typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
	typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
	typedArrayTags[errorTag] = typedArrayTags[funcTag] =
	typedArrayTags[mapTag] = typedArrayTags[numberTag] =
	typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
	typedArrayTags[setTag] = typedArrayTags[stringTag] =
	typedArrayTags[weakMapTag] = false;

	/** Detect free variable `global` from Node.js. */
	var freeGlobal = typeof commonjsGlobal == 'object' && commonjsGlobal && commonjsGlobal.Object === Object && commonjsGlobal;

	/** Detect free variable `self`. */
	var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

	/** Used as a reference to the global object. */
	var root = freeGlobal || freeSelf || Function('return this')();

	/** Detect free variable `exports`. */
	var freeExports = exports && !exports.nodeType && exports;

	/** Detect free variable `module`. */
	var freeModule = freeExports && 'object' == 'object' && module && !module.nodeType && module;

	/** Detect the popular CommonJS extension `module.exports`. */
	var moduleExports = freeModule && freeModule.exports === freeExports;

	/** Detect free variable `process` from Node.js. */
	var freeProcess = moduleExports && freeGlobal.process;

	/** Used to access faster Node.js helpers. */
	var nodeUtil = (function() {
	  try {
	    // Use `util.types` for Node.js 10+.
	    var types = freeModule && freeModule.require && freeModule.require('util').types;

	    if (types) {
	      return types;
	    }

	    // Legacy `process.binding('util')` for Node.js < 10.
	    return freeProcess && freeProcess.binding && freeProcess.binding('util');
	  } catch (e) {}
	}());

	/* Node.js helper references. */
	var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;

	/**
	 * A faster alternative to `Function#apply`, this function invokes `func`
	 * with the `this` binding of `thisArg` and the arguments of `args`.
	 *
	 * @private
	 * @param {Function} func The function to invoke.
	 * @param {*} thisArg The `this` binding of `func`.
	 * @param {Array} args The arguments to invoke `func` with.
	 * @returns {*} Returns the result of `func`.
	 */
	function apply(func, thisArg, args) {
	  switch (args.length) {
	    case 0: return func.call(thisArg);
	    case 1: return func.call(thisArg, args[0]);
	    case 2: return func.call(thisArg, args[0], args[1]);
	    case 3: return func.call(thisArg, args[0], args[1], args[2]);
	  }
	  return func.apply(thisArg, args);
	}

	/**
	 * The base implementation of `_.times` without support for iteratee shorthands
	 * or max array length checks.
	 *
	 * @private
	 * @param {number} n The number of times to invoke `iteratee`.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array} Returns the array of results.
	 */
	function baseTimes(n, iteratee) {
	  var index = -1,
	      result = Array(n);

	  while (++index < n) {
	    result[index] = iteratee(index);
	  }
	  return result;
	}

	/**
	 * The base implementation of `_.unary` without support for storing metadata.
	 *
	 * @private
	 * @param {Function} func The function to cap arguments for.
	 * @returns {Function} Returns the new capped function.
	 */
	function baseUnary(func) {
	  return function(value) {
	    return func(value);
	  };
	}

	/**
	 * Gets the value at `key` of `object`.
	 *
	 * @private
	 * @param {Object} [object] The object to query.
	 * @param {string} key The key of the property to get.
	 * @returns {*} Returns the property value.
	 */
	function getValue(object, key) {
	  return object == null ? undefined : object[key];
	}

	/**
	 * Creates a unary function that invokes `func` with its argument transformed.
	 *
	 * @private
	 * @param {Function} func The function to wrap.
	 * @param {Function} transform The argument transform.
	 * @returns {Function} Returns the new function.
	 */
	function overArg(func, transform) {
	  return function(arg) {
	    return func(transform(arg));
	  };
	}

	/** Used for built-in method references. */
	var arrayProto = Array.prototype,
	    funcProto = Function.prototype,
	    objectProto = Object.prototype;

	/** Used to detect overreaching core-js shims. */
	var coreJsData = root['__core-js_shared__'];

	/** Used to resolve the decompiled source of functions. */
	var funcToString = funcProto.toString;

	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;

	/** Used to detect methods masquerading as native. */
	var maskSrcKey = (function() {
	  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
	  return uid ? ('Symbol(src)_1.' + uid) : '';
	}());

	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var nativeObjectToString = objectProto.toString;

	/** Used to infer the `Object` constructor. */
	var objectCtorString = funcToString.call(Object);

	/** Used to detect if a method is native. */
	var reIsNative = RegExp('^' +
	  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
	  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
	);

	/** Built-in value references. */
	var Buffer = moduleExports ? root.Buffer : undefined,
	    Symbol = root.Symbol,
	    Uint8Array = root.Uint8Array,
	    allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined,
	    getPrototype = overArg(Object.getPrototypeOf, Object),
	    objectCreate = Object.create,
	    propertyIsEnumerable = objectProto.propertyIsEnumerable,
	    splice = arrayProto.splice,
	    symToStringTag = Symbol ? Symbol.toStringTag : undefined;

	var defineProperty = (function() {
	  try {
	    var func = getNative(Object, 'defineProperty');
	    func({}, '', {});
	    return func;
	  } catch (e) {}
	}());

	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined,
	    nativeMax = Math.max,
	    nativeNow = Date.now;

	/* Built-in method references that are verified to be native. */
	var Map = getNative(root, 'Map'),
	    nativeCreate = getNative(Object, 'create');

	/**
	 * The base implementation of `_.create` without support for assigning
	 * properties to the created object.
	 *
	 * @private
	 * @param {Object} proto The object to inherit from.
	 * @returns {Object} Returns the new object.
	 */
	var baseCreate = (function() {
	  function object() {}
	  return function(proto) {
	    if (!isObject(proto)) {
	      return {};
	    }
	    if (objectCreate) {
	      return objectCreate(proto);
	    }
	    object.prototype = proto;
	    var result = new object;
	    object.prototype = undefined;
	    return result;
	  };
	}());

	/**
	 * Creates a hash object.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function Hash(entries) {
	  var index = -1,
	      length = entries == null ? 0 : entries.length;

	  this.clear();
	  while (++index < length) {
	    var entry = entries[index];
	    this.set(entry[0], entry[1]);
	  }
	}

	/**
	 * Removes all key-value entries from the hash.
	 *
	 * @private
	 * @name clear
	 * @memberOf Hash
	 */
	function hashClear() {
	  this.__data__ = nativeCreate ? nativeCreate(null) : {};
	  this.size = 0;
	}

	/**
	 * Removes `key` and its value from the hash.
	 *
	 * @private
	 * @name delete
	 * @memberOf Hash
	 * @param {Object} hash The hash to modify.
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function hashDelete(key) {
	  var result = this.has(key) && delete this.__data__[key];
	  this.size -= result ? 1 : 0;
	  return result;
	}

	/**
	 * Gets the hash value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf Hash
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function hashGet(key) {
	  var data = this.__data__;
	  if (nativeCreate) {
	    var result = data[key];
	    return result === HASH_UNDEFINED ? undefined : result;
	  }
	  return hasOwnProperty.call(data, key) ? data[key] : undefined;
	}

	/**
	 * Checks if a hash value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf Hash
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function hashHas(key) {
	  var data = this.__data__;
	  return nativeCreate ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
	}

	/**
	 * Sets the hash `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf Hash
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the hash instance.
	 */
	function hashSet(key, value) {
	  var data = this.__data__;
	  this.size += this.has(key) ? 0 : 1;
	  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
	  return this;
	}

	// Add methods to `Hash`.
	Hash.prototype.clear = hashClear;
	Hash.prototype['delete'] = hashDelete;
	Hash.prototype.get = hashGet;
	Hash.prototype.has = hashHas;
	Hash.prototype.set = hashSet;

	/**
	 * Creates an list cache object.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function ListCache(entries) {
	  var index = -1,
	      length = entries == null ? 0 : entries.length;

	  this.clear();
	  while (++index < length) {
	    var entry = entries[index];
	    this.set(entry[0], entry[1]);
	  }
	}

	/**
	 * Removes all key-value entries from the list cache.
	 *
	 * @private
	 * @name clear
	 * @memberOf ListCache
	 */
	function listCacheClear() {
	  this.__data__ = [];
	  this.size = 0;
	}

	/**
	 * Removes `key` and its value from the list cache.
	 *
	 * @private
	 * @name delete
	 * @memberOf ListCache
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function listCacheDelete(key) {
	  var data = this.__data__,
	      index = assocIndexOf(data, key);

	  if (index < 0) {
	    return false;
	  }
	  var lastIndex = data.length - 1;
	  if (index == lastIndex) {
	    data.pop();
	  } else {
	    splice.call(data, index, 1);
	  }
	  --this.size;
	  return true;
	}

	/**
	 * Gets the list cache value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf ListCache
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function listCacheGet(key) {
	  var data = this.__data__,
	      index = assocIndexOf(data, key);

	  return index < 0 ? undefined : data[index][1];
	}

	/**
	 * Checks if a list cache value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf ListCache
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function listCacheHas(key) {
	  return assocIndexOf(this.__data__, key) > -1;
	}

	/**
	 * Sets the list cache `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf ListCache
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the list cache instance.
	 */
	function listCacheSet(key, value) {
	  var data = this.__data__,
	      index = assocIndexOf(data, key);

	  if (index < 0) {
	    ++this.size;
	    data.push([key, value]);
	  } else {
	    data[index][1] = value;
	  }
	  return this;
	}

	// Add methods to `ListCache`.
	ListCache.prototype.clear = listCacheClear;
	ListCache.prototype['delete'] = listCacheDelete;
	ListCache.prototype.get = listCacheGet;
	ListCache.prototype.has = listCacheHas;
	ListCache.prototype.set = listCacheSet;

	/**
	 * Creates a map cache object to store key-value pairs.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function MapCache(entries) {
	  var index = -1,
	      length = entries == null ? 0 : entries.length;

	  this.clear();
	  while (++index < length) {
	    var entry = entries[index];
	    this.set(entry[0], entry[1]);
	  }
	}

	/**
	 * Removes all key-value entries from the map.
	 *
	 * @private
	 * @name clear
	 * @memberOf MapCache
	 */
	function mapCacheClear() {
	  this.size = 0;
	  this.__data__ = {
	    'hash': new Hash,
	    'map': new (Map || ListCache),
	    'string': new Hash
	  };
	}

	/**
	 * Removes `key` and its value from the map.
	 *
	 * @private
	 * @name delete
	 * @memberOf MapCache
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function mapCacheDelete(key) {
	  var result = getMapData(this, key)['delete'](key);
	  this.size -= result ? 1 : 0;
	  return result;
	}

	/**
	 * Gets the map value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf MapCache
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function mapCacheGet(key) {
	  return getMapData(this, key).get(key);
	}

	/**
	 * Checks if a map value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf MapCache
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function mapCacheHas(key) {
	  return getMapData(this, key).has(key);
	}

	/**
	 * Sets the map `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf MapCache
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the map cache instance.
	 */
	function mapCacheSet(key, value) {
	  var data = getMapData(this, key),
	      size = data.size;

	  data.set(key, value);
	  this.size += data.size == size ? 0 : 1;
	  return this;
	}

	// Add methods to `MapCache`.
	MapCache.prototype.clear = mapCacheClear;
	MapCache.prototype['delete'] = mapCacheDelete;
	MapCache.prototype.get = mapCacheGet;
	MapCache.prototype.has = mapCacheHas;
	MapCache.prototype.set = mapCacheSet;

	/**
	 * Creates a stack cache object to store key-value pairs.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function Stack(entries) {
	  var data = this.__data__ = new ListCache(entries);
	  this.size = data.size;
	}

	/**
	 * Removes all key-value entries from the stack.
	 *
	 * @private
	 * @name clear
	 * @memberOf Stack
	 */
	function stackClear() {
	  this.__data__ = new ListCache;
	  this.size = 0;
	}

	/**
	 * Removes `key` and its value from the stack.
	 *
	 * @private
	 * @name delete
	 * @memberOf Stack
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function stackDelete(key) {
	  var data = this.__data__,
	      result = data['delete'](key);

	  this.size = data.size;
	  return result;
	}

	/**
	 * Gets the stack value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf Stack
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function stackGet(key) {
	  return this.__data__.get(key);
	}

	/**
	 * Checks if a stack value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf Stack
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function stackHas(key) {
	  return this.__data__.has(key);
	}

	/**
	 * Sets the stack `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf Stack
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the stack cache instance.
	 */
	function stackSet(key, value) {
	  var data = this.__data__;
	  if (data instanceof ListCache) {
	    var pairs = data.__data__;
	    if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
	      pairs.push([key, value]);
	      this.size = ++data.size;
	      return this;
	    }
	    data = this.__data__ = new MapCache(pairs);
	  }
	  data.set(key, value);
	  this.size = data.size;
	  return this;
	}

	// Add methods to `Stack`.
	Stack.prototype.clear = stackClear;
	Stack.prototype['delete'] = stackDelete;
	Stack.prototype.get = stackGet;
	Stack.prototype.has = stackHas;
	Stack.prototype.set = stackSet;

	/**
	 * Creates an array of the enumerable property names of the array-like `value`.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @param {boolean} inherited Specify returning inherited property names.
	 * @returns {Array} Returns the array of property names.
	 */
	function arrayLikeKeys(value, inherited) {
	  var isArr = isArray(value),
	      isArg = !isArr && isArguments(value),
	      isBuff = !isArr && !isArg && isBuffer(value),
	      isType = !isArr && !isArg && !isBuff && isTypedArray(value),
	      skipIndexes = isArr || isArg || isBuff || isType,
	      result = skipIndexes ? baseTimes(value.length, String) : [],
	      length = result.length;

	  for (var key in value) {
	    if ((inherited || hasOwnProperty.call(value, key)) &&
	        !(skipIndexes && (
	           // Safari 9 has enumerable `arguments.length` in strict mode.
	           key == 'length' ||
	           // Node.js 0.10 has enumerable non-index properties on buffers.
	           (isBuff && (key == 'offset' || key == 'parent')) ||
	           // PhantomJS 2 has enumerable non-index properties on typed arrays.
	           (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
	           // Skip index properties.
	           isIndex(key, length)
	        ))) {
	      result.push(key);
	    }
	  }
	  return result;
	}

	/**
	 * This function is like `assignValue` except that it doesn't assign
	 * `undefined` values.
	 *
	 * @private
	 * @param {Object} object The object to modify.
	 * @param {string} key The key of the property to assign.
	 * @param {*} value The value to assign.
	 */
	function assignMergeValue(object, key, value) {
	  if ((value !== undefined && !eq(object[key], value)) ||
	      (value === undefined && !(key in object))) {
	    baseAssignValue(object, key, value);
	  }
	}

	/**
	 * Assigns `value` to `key` of `object` if the existing value is not equivalent
	 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	 * for equality comparisons.
	 *
	 * @private
	 * @param {Object} object The object to modify.
	 * @param {string} key The key of the property to assign.
	 * @param {*} value The value to assign.
	 */
	function assignValue(object, key, value) {
	  var objValue = object[key];
	  if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
	      (value === undefined && !(key in object))) {
	    baseAssignValue(object, key, value);
	  }
	}

	/**
	 * Gets the index at which the `key` is found in `array` of key-value pairs.
	 *
	 * @private
	 * @param {Array} array The array to inspect.
	 * @param {*} key The key to search for.
	 * @returns {number} Returns the index of the matched value, else `-1`.
	 */
	function assocIndexOf(array, key) {
	  var length = array.length;
	  while (length--) {
	    if (eq(array[length][0], key)) {
	      return length;
	    }
	  }
	  return -1;
	}

	/**
	 * The base implementation of `assignValue` and `assignMergeValue` without
	 * value checks.
	 *
	 * @private
	 * @param {Object} object The object to modify.
	 * @param {string} key The key of the property to assign.
	 * @param {*} value The value to assign.
	 */
	function baseAssignValue(object, key, value) {
	  if (key == '__proto__' && defineProperty) {
	    defineProperty(object, key, {
	      'configurable': true,
	      'enumerable': true,
	      'value': value,
	      'writable': true
	    });
	  } else {
	    object[key] = value;
	  }
	}

	/**
	 * The base implementation of `baseForOwn` which iterates over `object`
	 * properties returned by `keysFunc` and invokes `iteratee` for each property.
	 * Iteratee functions may exit iteration early by explicitly returning `false`.
	 *
	 * @private
	 * @param {Object} object The object to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @param {Function} keysFunc The function to get the keys of `object`.
	 * @returns {Object} Returns `object`.
	 */
	var baseFor = createBaseFor();

	/**
	 * The base implementation of `getTag` without fallbacks for buggy environments.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @returns {string} Returns the `toStringTag`.
	 */
	function baseGetTag(value) {
	  if (value == null) {
	    return value === undefined ? undefinedTag : nullTag;
	  }
	  return (symToStringTag && symToStringTag in Object(value))
	    ? getRawTag(value)
	    : objectToString(value);
	}

	/**
	 * The base implementation of `_.isArguments`.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
	 */
	function baseIsArguments(value) {
	  return isObjectLike(value) && baseGetTag(value) == argsTag;
	}

	/**
	 * The base implementation of `_.isNative` without bad shim checks.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a native function,
	 *  else `false`.
	 */
	function baseIsNative(value) {
	  if (!isObject(value) || isMasked(value)) {
	    return false;
	  }
	  var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
	  return pattern.test(toSource(value));
	}

	/**
	 * The base implementation of `_.isTypedArray` without Node.js optimizations.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
	 */
	function baseIsTypedArray(value) {
	  return isObjectLike(value) &&
	    isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
	}

	/**
	 * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 */
	function baseKeysIn(object) {
	  if (!isObject(object)) {
	    return nativeKeysIn(object);
	  }
	  var isProto = isPrototype(object),
	      result = [];

	  for (var key in object) {
	    if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
	      result.push(key);
	    }
	  }
	  return result;
	}

	/**
	 * The base implementation of `_.merge` without support for multiple sources.
	 *
	 * @private
	 * @param {Object} object The destination object.
	 * @param {Object} source The source object.
	 * @param {number} srcIndex The index of `source`.
	 * @param {Function} [customizer] The function to customize merged values.
	 * @param {Object} [stack] Tracks traversed source values and their merged
	 *  counterparts.
	 */
	function baseMerge(object, source, srcIndex, customizer, stack) {
	  if (object === source) {
	    return;
	  }
	  baseFor(source, function(srcValue, key) {
	    stack || (stack = new Stack);
	    if (isObject(srcValue)) {
	      baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
	    }
	    else {
	      var newValue = customizer
	        ? customizer(safeGet(object, key), srcValue, (key + ''), object, source, stack)
	        : undefined;

	      if (newValue === undefined) {
	        newValue = srcValue;
	      }
	      assignMergeValue(object, key, newValue);
	    }
	  }, keysIn);
	}

	/**
	 * A specialized version of `baseMerge` for arrays and objects which performs
	 * deep merges and tracks traversed objects enabling objects with circular
	 * references to be merged.
	 *
	 * @private
	 * @param {Object} object The destination object.
	 * @param {Object} source The source object.
	 * @param {string} key The key of the value to merge.
	 * @param {number} srcIndex The index of `source`.
	 * @param {Function} mergeFunc The function to merge values.
	 * @param {Function} [customizer] The function to customize assigned values.
	 * @param {Object} [stack] Tracks traversed source values and their merged
	 *  counterparts.
	 */
	function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
	  var objValue = safeGet(object, key),
	      srcValue = safeGet(source, key),
	      stacked = stack.get(srcValue);

	  if (stacked) {
	    assignMergeValue(object, key, stacked);
	    return;
	  }
	  var newValue = customizer
	    ? customizer(objValue, srcValue, (key + ''), object, source, stack)
	    : undefined;

	  var isCommon = newValue === undefined;

	  if (isCommon) {
	    var isArr = isArray(srcValue),
	        isBuff = !isArr && isBuffer(srcValue),
	        isTyped = !isArr && !isBuff && isTypedArray(srcValue);

	    newValue = srcValue;
	    if (isArr || isBuff || isTyped) {
	      if (isArray(objValue)) {
	        newValue = objValue;
	      }
	      else if (isArrayLikeObject(objValue)) {
	        newValue = copyArray(objValue);
	      }
	      else if (isBuff) {
	        isCommon = false;
	        newValue = cloneBuffer(srcValue, true);
	      }
	      else if (isTyped) {
	        isCommon = false;
	        newValue = cloneTypedArray(srcValue, true);
	      }
	      else {
	        newValue = [];
	      }
	    }
	    else if (isPlainObject(srcValue) || isArguments(srcValue)) {
	      newValue = objValue;
	      if (isArguments(objValue)) {
	        newValue = toPlainObject(objValue);
	      }
	      else if (!isObject(objValue) || isFunction(objValue)) {
	        newValue = initCloneObject(srcValue);
	      }
	    }
	    else {
	      isCommon = false;
	    }
	  }
	  if (isCommon) {
	    // Recursively merge objects and arrays (susceptible to call stack limits).
	    stack.set(srcValue, newValue);
	    mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
	    stack['delete'](srcValue);
	  }
	  assignMergeValue(object, key, newValue);
	}

	/**
	 * The base implementation of `_.rest` which doesn't validate or coerce arguments.
	 *
	 * @private
	 * @param {Function} func The function to apply a rest parameter to.
	 * @param {number} [start=func.length-1] The start position of the rest parameter.
	 * @returns {Function} Returns the new function.
	 */
	function baseRest(func, start) {
	  return setToString(overRest(func, start, identity), func + '');
	}

	/**
	 * The base implementation of `setToString` without support for hot loop shorting.
	 *
	 * @private
	 * @param {Function} func The function to modify.
	 * @param {Function} string The `toString` result.
	 * @returns {Function} Returns `func`.
	 */
	var baseSetToString = !defineProperty ? identity : function(func, string) {
	  return defineProperty(func, 'toString', {
	    'configurable': true,
	    'enumerable': false,
	    'value': constant(string),
	    'writable': true
	  });
	};

	/**
	 * Creates a clone of  `buffer`.
	 *
	 * @private
	 * @param {Buffer} buffer The buffer to clone.
	 * @param {boolean} [isDeep] Specify a deep clone.
	 * @returns {Buffer} Returns the cloned buffer.
	 */
	function cloneBuffer(buffer, isDeep) {
	  if (isDeep) {
	    return buffer.slice();
	  }
	  var length = buffer.length,
	      result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);

	  buffer.copy(result);
	  return result;
	}

	/**
	 * Creates a clone of `arrayBuffer`.
	 *
	 * @private
	 * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
	 * @returns {ArrayBuffer} Returns the cloned array buffer.
	 */
	function cloneArrayBuffer(arrayBuffer) {
	  var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
	  new Uint8Array(result).set(new Uint8Array(arrayBuffer));
	  return result;
	}

	/**
	 * Creates a clone of `typedArray`.
	 *
	 * @private
	 * @param {Object} typedArray The typed array to clone.
	 * @param {boolean} [isDeep] Specify a deep clone.
	 * @returns {Object} Returns the cloned typed array.
	 */
	function cloneTypedArray(typedArray, isDeep) {
	  var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
	  return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
	}

	/**
	 * Copies the values of `source` to `array`.
	 *
	 * @private
	 * @param {Array} source The array to copy values from.
	 * @param {Array} [array=[]] The array to copy values to.
	 * @returns {Array} Returns `array`.
	 */
	function copyArray(source, array) {
	  var index = -1,
	      length = source.length;

	  array || (array = Array(length));
	  while (++index < length) {
	    array[index] = source[index];
	  }
	  return array;
	}

	/**
	 * Copies properties of `source` to `object`.
	 *
	 * @private
	 * @param {Object} source The object to copy properties from.
	 * @param {Array} props The property identifiers to copy.
	 * @param {Object} [object={}] The object to copy properties to.
	 * @param {Function} [customizer] The function to customize copied values.
	 * @returns {Object} Returns `object`.
	 */
	function copyObject(source, props, object, customizer) {
	  var isNew = !object;
	  object || (object = {});

	  var index = -1,
	      length = props.length;

	  while (++index < length) {
	    var key = props[index];

	    var newValue = customizer
	      ? customizer(object[key], source[key], key, object, source)
	      : undefined;

	    if (newValue === undefined) {
	      newValue = source[key];
	    }
	    if (isNew) {
	      baseAssignValue(object, key, newValue);
	    } else {
	      assignValue(object, key, newValue);
	    }
	  }
	  return object;
	}

	/**
	 * Creates a function like `_.assign`.
	 *
	 * @private
	 * @param {Function} assigner The function to assign values.
	 * @returns {Function} Returns the new assigner function.
	 */
	function createAssigner(assigner) {
	  return baseRest(function(object, sources) {
	    var index = -1,
	        length = sources.length,
	        customizer = length > 1 ? sources[length - 1] : undefined,
	        guard = length > 2 ? sources[2] : undefined;

	    customizer = (assigner.length > 3 && typeof customizer == 'function')
	      ? (length--, customizer)
	      : undefined;

	    if (guard && isIterateeCall(sources[0], sources[1], guard)) {
	      customizer = length < 3 ? undefined : customizer;
	      length = 1;
	    }
	    object = Object(object);
	    while (++index < length) {
	      var source = sources[index];
	      if (source) {
	        assigner(object, source, index, customizer);
	      }
	    }
	    return object;
	  });
	}

	/**
	 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
	 *
	 * @private
	 * @param {boolean} [fromRight] Specify iterating from right to left.
	 * @returns {Function} Returns the new base function.
	 */
	function createBaseFor(fromRight) {
	  return function(object, iteratee, keysFunc) {
	    var index = -1,
	        iterable = Object(object),
	        props = keysFunc(object),
	        length = props.length;

	    while (length--) {
	      var key = props[fromRight ? length : ++index];
	      if (iteratee(iterable[key], key, iterable) === false) {
	        break;
	      }
	    }
	    return object;
	  };
	}

	/**
	 * Gets the data for `map`.
	 *
	 * @private
	 * @param {Object} map The map to query.
	 * @param {string} key The reference key.
	 * @returns {*} Returns the map data.
	 */
	function getMapData(map, key) {
	  var data = map.__data__;
	  return isKeyable(key)
	    ? data[typeof key == 'string' ? 'string' : 'hash']
	    : data.map;
	}

	/**
	 * Gets the native function at `key` of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {string} key The key of the method to get.
	 * @returns {*} Returns the function if it's native, else `undefined`.
	 */
	function getNative(object, key) {
	  var value = getValue(object, key);
	  return baseIsNative(value) ? value : undefined;
	}

	/**
	 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @returns {string} Returns the raw `toStringTag`.
	 */
	function getRawTag(value) {
	  var isOwn = hasOwnProperty.call(value, symToStringTag),
	      tag = value[symToStringTag];

	  try {
	    value[symToStringTag] = undefined;
	    var unmasked = true;
	  } catch (e) {}

	  var result = nativeObjectToString.call(value);
	  if (unmasked) {
	    if (isOwn) {
	      value[symToStringTag] = tag;
	    } else {
	      delete value[symToStringTag];
	    }
	  }
	  return result;
	}

	/**
	 * Initializes an object clone.
	 *
	 * @private
	 * @param {Object} object The object to clone.
	 * @returns {Object} Returns the initialized clone.
	 */
	function initCloneObject(object) {
	  return (typeof object.constructor == 'function' && !isPrototype(object))
	    ? baseCreate(getPrototype(object))
	    : {};
	}

	/**
	 * Checks if `value` is a valid array-like index.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
	 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
	 */
	function isIndex(value, length) {
	  var type = typeof value;
	  length = length == null ? MAX_SAFE_INTEGER : length;

	  return !!length &&
	    (type == 'number' ||
	      (type != 'symbol' && reIsUint.test(value))) &&
	        (value > -1 && value % 1 == 0 && value < length);
	}

	/**
	 * Checks if the given arguments are from an iteratee call.
	 *
	 * @private
	 * @param {*} value The potential iteratee value argument.
	 * @param {*} index The potential iteratee index or key argument.
	 * @param {*} object The potential iteratee object argument.
	 * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
	 *  else `false`.
	 */
	function isIterateeCall(value, index, object) {
	  if (!isObject(object)) {
	    return false;
	  }
	  var type = typeof index;
	  if (type == 'number'
	        ? (isArrayLike(object) && isIndex(index, object.length))
	        : (type == 'string' && index in object)
	      ) {
	    return eq(object[index], value);
	  }
	  return false;
	}

	/**
	 * Checks if `value` is suitable for use as unique object key.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
	 */
	function isKeyable(value) {
	  var type = typeof value;
	  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
	    ? (value !== '__proto__')
	    : (value === null);
	}

	/**
	 * Checks if `func` has its source masked.
	 *
	 * @private
	 * @param {Function} func The function to check.
	 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
	 */
	function isMasked(func) {
	  return !!maskSrcKey && (maskSrcKey in func);
	}

	/**
	 * Checks if `value` is likely a prototype object.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
	 */
	function isPrototype(value) {
	  var Ctor = value && value.constructor,
	      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;

	  return value === proto;
	}

	/**
	 * This function is like
	 * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
	 * except that it includes inherited enumerable properties.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 */
	function nativeKeysIn(object) {
	  var result = [];
	  if (object != null) {
	    for (var key in Object(object)) {
	      result.push(key);
	    }
	  }
	  return result;
	}

	/**
	 * Converts `value` to a string using `Object.prototype.toString`.
	 *
	 * @private
	 * @param {*} value The value to convert.
	 * @returns {string} Returns the converted string.
	 */
	function objectToString(value) {
	  return nativeObjectToString.call(value);
	}

	/**
	 * A specialized version of `baseRest` which transforms the rest array.
	 *
	 * @private
	 * @param {Function} func The function to apply a rest parameter to.
	 * @param {number} [start=func.length-1] The start position of the rest parameter.
	 * @param {Function} transform The rest array transform.
	 * @returns {Function} Returns the new function.
	 */
	function overRest(func, start, transform) {
	  start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
	  return function() {
	    var args = arguments,
	        index = -1,
	        length = nativeMax(args.length - start, 0),
	        array = Array(length);

	    while (++index < length) {
	      array[index] = args[start + index];
	    }
	    index = -1;
	    var otherArgs = Array(start + 1);
	    while (++index < start) {
	      otherArgs[index] = args[index];
	    }
	    otherArgs[start] = transform(array);
	    return apply(func, this, otherArgs);
	  };
	}

	/**
	 * Gets the value at `key`, unless `key` is "__proto__" or "constructor".
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {string} key The key of the property to get.
	 * @returns {*} Returns the property value.
	 */
	function safeGet(object, key) {
	  if (key === 'constructor' && typeof object[key] === 'function') {
	    return;
	  }

	  if (key == '__proto__') {
	    return;
	  }

	  return object[key];
	}

	/**
	 * Sets the `toString` method of `func` to return `string`.
	 *
	 * @private
	 * @param {Function} func The function to modify.
	 * @param {Function} string The `toString` result.
	 * @returns {Function} Returns `func`.
	 */
	var setToString = shortOut(baseSetToString);

	/**
	 * Creates a function that'll short out and invoke `identity` instead
	 * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
	 * milliseconds.
	 *
	 * @private
	 * @param {Function} func The function to restrict.
	 * @returns {Function} Returns the new shortable function.
	 */
	function shortOut(func) {
	  var count = 0,
	      lastCalled = 0;

	  return function() {
	    var stamp = nativeNow(),
	        remaining = HOT_SPAN - (stamp - lastCalled);

	    lastCalled = stamp;
	    if (remaining > 0) {
	      if (++count >= HOT_COUNT) {
	        return arguments[0];
	      }
	    } else {
	      count = 0;
	    }
	    return func.apply(undefined, arguments);
	  };
	}

	/**
	 * Converts `func` to its source code.
	 *
	 * @private
	 * @param {Function} func The function to convert.
	 * @returns {string} Returns the source code.
	 */
	function toSource(func) {
	  if (func != null) {
	    try {
	      return funcToString.call(func);
	    } catch (e) {}
	    try {
	      return (func + '');
	    } catch (e) {}
	  }
	  return '';
	}

	/**
	 * Performs a
	 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	 * comparison between two values to determine if they are equivalent.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to compare.
	 * @param {*} other The other value to compare.
	 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	 * @example
	 *
	 * var object = { 'a': 1 };
	 * var other = { 'a': 1 };
	 *
	 * _.eq(object, object);
	 * // => true
	 *
	 * _.eq(object, other);
	 * // => false
	 *
	 * _.eq('a', 'a');
	 * // => true
	 *
	 * _.eq('a', Object('a'));
	 * // => false
	 *
	 * _.eq(NaN, NaN);
	 * // => true
	 */
	function eq(value, other) {
	  return value === other || (value !== value && other !== other);
	}

	/**
	 * Checks if `value` is likely an `arguments` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
	 *  else `false`.
	 * @example
	 *
	 * _.isArguments(function() { return arguments; }());
	 * // => true
	 *
	 * _.isArguments([1, 2, 3]);
	 * // => false
	 */
	var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
	  return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
	    !propertyIsEnumerable.call(value, 'callee');
	};

	/**
	 * Checks if `value` is classified as an `Array` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
	 * @example
	 *
	 * _.isArray([1, 2, 3]);
	 * // => true
	 *
	 * _.isArray(document.body.children);
	 * // => false
	 *
	 * _.isArray('abc');
	 * // => false
	 *
	 * _.isArray(_.noop);
	 * // => false
	 */
	var isArray = Array.isArray;

	/**
	 * Checks if `value` is array-like. A value is considered array-like if it's
	 * not a function and has a `value.length` that's an integer greater than or
	 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
	 * @example
	 *
	 * _.isArrayLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isArrayLike(document.body.children);
	 * // => true
	 *
	 * _.isArrayLike('abc');
	 * // => true
	 *
	 * _.isArrayLike(_.noop);
	 * // => false
	 */
	function isArrayLike(value) {
	  return value != null && isLength(value.length) && !isFunction(value);
	}

	/**
	 * This method is like `_.isArrayLike` except that it also checks if `value`
	 * is an object.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an array-like object,
	 *  else `false`.
	 * @example
	 *
	 * _.isArrayLikeObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isArrayLikeObject(document.body.children);
	 * // => true
	 *
	 * _.isArrayLikeObject('abc');
	 * // => false
	 *
	 * _.isArrayLikeObject(_.noop);
	 * // => false
	 */
	function isArrayLikeObject(value) {
	  return isObjectLike(value) && isArrayLike(value);
	}

	/**
	 * Checks if `value` is a buffer.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.3.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
	 * @example
	 *
	 * _.isBuffer(new Buffer(2));
	 * // => true
	 *
	 * _.isBuffer(new Uint8Array(2));
	 * // => false
	 */
	var isBuffer = nativeIsBuffer || stubFalse;

	/**
	 * Checks if `value` is classified as a `Function` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
	 * @example
	 *
	 * _.isFunction(_);
	 * // => true
	 *
	 * _.isFunction(/abc/);
	 * // => false
	 */
	function isFunction(value) {
	  if (!isObject(value)) {
	    return false;
	  }
	  // The use of `Object#toString` avoids issues with the `typeof` operator
	  // in Safari 9 which returns 'object' for typed arrays and other constructors.
	  var tag = baseGetTag(value);
	  return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
	}

	/**
	 * Checks if `value` is a valid array-like length.
	 *
	 * **Note:** This method is loosely based on
	 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
	 * @example
	 *
	 * _.isLength(3);
	 * // => true
	 *
	 * _.isLength(Number.MIN_VALUE);
	 * // => false
	 *
	 * _.isLength(Infinity);
	 * // => false
	 *
	 * _.isLength('3');
	 * // => false
	 */
	function isLength(value) {
	  return typeof value == 'number' &&
	    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
	}

	/**
	 * Checks if `value` is the
	 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
	 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	 * @example
	 *
	 * _.isObject({});
	 * // => true
	 *
	 * _.isObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isObject(_.noop);
	 * // => true
	 *
	 * _.isObject(null);
	 * // => false
	 */
	function isObject(value) {
	  var type = typeof value;
	  return value != null && (type == 'object' || type == 'function');
	}

	/**
	 * Checks if `value` is object-like. A value is object-like if it's not `null`
	 * and has a `typeof` result of "object".
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	 * @example
	 *
	 * _.isObjectLike({});
	 * // => true
	 *
	 * _.isObjectLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isObjectLike(_.noop);
	 * // => false
	 *
	 * _.isObjectLike(null);
	 * // => false
	 */
	function isObjectLike(value) {
	  return value != null && typeof value == 'object';
	}

	/**
	 * Checks if `value` is a plain object, that is, an object created by the
	 * `Object` constructor or one with a `[[Prototype]]` of `null`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.8.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 * }
	 *
	 * _.isPlainObject(new Foo);
	 * // => false
	 *
	 * _.isPlainObject([1, 2, 3]);
	 * // => false
	 *
	 * _.isPlainObject({ 'x': 0, 'y': 0 });
	 * // => true
	 *
	 * _.isPlainObject(Object.create(null));
	 * // => true
	 */
	function isPlainObject(value) {
	  if (!isObjectLike(value) || baseGetTag(value) != objectTag) {
	    return false;
	  }
	  var proto = getPrototype(value);
	  if (proto === null) {
	    return true;
	  }
	  var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
	  return typeof Ctor == 'function' && Ctor instanceof Ctor &&
	    funcToString.call(Ctor) == objectCtorString;
	}

	/**
	 * Checks if `value` is classified as a typed array.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
	 * @example
	 *
	 * _.isTypedArray(new Uint8Array);
	 * // => true
	 *
	 * _.isTypedArray([]);
	 * // => false
	 */
	var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;

	/**
	 * Converts `value` to a plain object flattening inherited enumerable string
	 * keyed properties of `value` to own properties of the plain object.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.0.0
	 * @category Lang
	 * @param {*} value The value to convert.
	 * @returns {Object} Returns the converted plain object.
	 * @example
	 *
	 * function Foo() {
	 *   this.b = 2;
	 * }
	 *
	 * Foo.prototype.c = 3;
	 *
	 * _.assign({ 'a': 1 }, new Foo);
	 * // => { 'a': 1, 'b': 2 }
	 *
	 * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
	 * // => { 'a': 1, 'b': 2, 'c': 3 }
	 */
	function toPlainObject(value) {
	  return copyObject(value, keysIn(value));
	}

	/**
	 * Creates an array of the own and inherited enumerable property names of `object`.
	 *
	 * **Note:** Non-object values are coerced to objects.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.0.0
	 * @category Object
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 *   this.b = 2;
	 * }
	 *
	 * Foo.prototype.c = 3;
	 *
	 * _.keysIn(new Foo);
	 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
	 */
	function keysIn(object) {
	  return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
	}

	/**
	 * This method is like `_.assign` except that it recursively merges own and
	 * inherited enumerable string keyed properties of source objects into the
	 * destination object. Source properties that resolve to `undefined` are
	 * skipped if a destination value exists. Array and plain object properties
	 * are merged recursively. Other objects and value types are overridden by
	 * assignment. Source objects are applied from left to right. Subsequent
	 * sources overwrite property assignments of previous sources.
	 *
	 * **Note:** This method mutates `object`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.5.0
	 * @category Object
	 * @param {Object} object The destination object.
	 * @param {...Object} [sources] The source objects.
	 * @returns {Object} Returns `object`.
	 * @example
	 *
	 * var object = {
	 *   'a': [{ 'b': 2 }, { 'd': 4 }]
	 * };
	 *
	 * var other = {
	 *   'a': [{ 'c': 3 }, { 'e': 5 }]
	 * };
	 *
	 * _.merge(object, other);
	 * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
	 */
	var merge = createAssigner(function(object, source, srcIndex) {
	  baseMerge(object, source, srcIndex);
	});

	/**
	 * Creates a function that returns `value`.
	 *
	 * @static
	 * @memberOf _
	 * @since 2.4.0
	 * @category Util
	 * @param {*} value The value to return from the new function.
	 * @returns {Function} Returns the new constant function.
	 * @example
	 *
	 * var objects = _.times(2, _.constant({ 'a': 1 }));
	 *
	 * console.log(objects);
	 * // => [{ 'a': 1 }, { 'a': 1 }]
	 *
	 * console.log(objects[0] === objects[1]);
	 * // => true
	 */
	function constant(value) {
	  return function() {
	    return value;
	  };
	}

	/**
	 * This method returns the first argument it receives.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Util
	 * @param {*} value Any value.
	 * @returns {*} Returns `value`.
	 * @example
	 *
	 * var object = { 'a': 1 };
	 *
	 * console.log(_.identity(object) === object);
	 * // => true
	 */
	function identity(value) {
	  return value;
	}

	/**
	 * This method returns `false`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.13.0
	 * @category Util
	 * @returns {boolean} Returns `false`.
	 * @example
	 *
	 * _.times(2, _.stubFalse);
	 * // => [false, false]
	 */
	function stubFalse() {
	  return false;
	}

	module.exports = merge; 
} (lodash_merge, lodash_merge.exports));

var lodash_mergeExports = lodash_merge.exports;
var merge = /*@__PURE__*/getDefaultExportFromCjs(lodash_mergeExports);

//
var script$f = {
  name: 'TuxTermsConsent',
  components: {
    AlCheckbox
  },
  inject: ['$validator'],
  props: {
    /**
     * Whether or not to allow a heading with divider above the explict terms consent checkbox
     */
    allowHeading: {
      type: Boolean,
      default: false
    },
    /**
     * If you would like to override the default text been displayed, you may passed a content text
     * token to be used instead.
     */
    customText: {
      type: String,
      default: ''
    },
    /**
     * Do not show the explicit consent checkbox even if it's required in a particular country.
     */
    disableExplicitConsent: {
      type: Boolean,
      default: false
    },
    /**
     * The name of the component, used to label the data-test element.
     */
    name: {
      type: String,
      required: true
    },
    /**
     * Privacy Notice Url
     */
    privacyUrl: {
      type: String,
      required: true
    },
    /**
     * Show the reacceptance verbiage instead of the default
     */
    reacceptance: {
      type: Boolean,
      default: false
    },
    /**
     * Terms & Conditions Url
     */
    termsUrl: {
      type: String,
      required: true
    },
    /**
     * Whether or not to hide divider above the explict terms consent checkbox
     */
    hideDivider: {
      type: Boolean,
      default: false
    },
    /**
     * Whether or not flex-grow should be set to 1
     */
    flexGrow: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      isExplicitTermsRequired: false,
      isExplicitPrivacyRequired: false,
      isExplicitTermsPrivacyChecked: false,
      isExplicitTermsChecked: false,
      isExplicitPrivacyChecked: false,
      consentClass: 'col-vertical-align-bottom'
    };
  },
  computed: {
    consentTextPath() {
      let textPath;
      if (this.customText) {
        textPath = this.customText;
      } else if (this.reacceptance) {
        textPath = this.reacceptanceText;
      } else if (!this.disableExplicitConsent) {
        const childText = this.getChildText();
        textPath = `termsConsent.default.${childText}`;
      } else {
        textPath = `termsConsent.default.consent`;
      }
      return textPath;
    },
    implicitConsentText() {
      return this.isExplicitTermsRequired ? 'termsConsent.default.implicitPrivacy' : 'termsConsent.default.implicitTerms';
    },
    showExplicitTermsPrivacy() {
      return this.showExplicitTerms && this.showExplicitPrivacy;
    },
    showExplicitTerms() {
      return this.isExplicitTermsRequired && !this.disableExplicitConsent;
    },
    showExplicitPrivacy() {
      return this.isExplicitPrivacyRequired && !this.disableExplicitConsent;
    },
    reacceptanceText() {
      return 'termsConsent.reacceptance.consent';
    }
  },
  watch: {
    '$i18n.locale': {
      immediate: true,
      handler() {
        this.isExplicitTermsRequired = this.$i18nData.isCountryFeatureEnabled(constants.COUNTRY_FEATURES.EXPLICIT_TERMS_CONSENT, this.$i18n.locale);
        this.isExplicitPrivacyRequired = this.$i18nData.isCountryFeatureEnabled(constants.COUNTRY_FEATURES.EXPLICIT_PRIVACY_CONSENT, this.$i18n.locale);
      }
    }
  },
  methods: {
    getChildText() {
      let childText;
      if (this.isExplicitTermsRequired && this.isExplicitPrivacyRequired) {
        childText = 'explicitConsent';
        this.consentClass = 'col-vertical-align-top';
      } else if (this.isExplicitTermsRequired) {
        childText = 'explicitTerms';
        this.consentClass = 'col-vertical-space-between';
      } else if (this.isExplicitPrivacyRequired) {
        childText = 'explicitPrivacy';
        this.consentClass = 'col-vertical-space-between';
      } else {
        childText = 'consent';
        this.consentClass = 'col-vertical-align-bottom';
      }
      return childText;
    },
    handlePrivacyClick(event) {
      this.$emit('privacy-click', event);
    },
    handleTermsClick(event) {
      this.$emit('terms-click', event);
    },
    handleConsentChecked(checked) {
      this.$emit('consent-checked', checked);
    },
    handleTermsChecked(checked) {
      this.$emit('terms-checked', checked);
    },
    handlePrivacyChecked(checked) {
      this.$emit('privacy-checked', checked);
    }
  }
};

/* script */
const __vue_script__$f = script$f;

/* template */
var __vue_render__$f = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("div", {
    staticClass: "row",
    class: {
      "tux-terms-consent": _vm.flexGrow
    }
  }, [_c("div", {
    staticClass: "col-full",
    class: _vm.consentClass
  }, [_vm.showExplicitTermsPrivacy ? [_vm.allowHeading ? [!_vm.hideDivider ? _c("section", {
    attrs: {
      "data-test": "terms-consent-divider"
    }
  }) : _vm._e(), _vm._v(" "), _c("h2", {
    staticClass: "heading-md"
  }, [_vm._v("\n          " + _vm._s(_vm.$t("termsConsent.termsHeading")) + "\n        ")])] : _vm._e(), _vm._v(" "), _c("al-checkbox", {
    directives: [{
      name: "validate",
      rawName: "v-validate.immediate",
      value: "required:true",
      expression: "'required:true'",
      modifiers: {
        immediate: true
      }
    }],
    attrs: {
      name: _vm.name + "-terms-consent-checkbox"
    },
    on: {
      input: _vm.handleConsentChecked
    },
    model: {
      value: _vm.isExplicitTermsPrivacyChecked,
      callback: function ($$v) {
        _vm.isExplicitTermsPrivacyChecked = $$v;
      },
      expression: "isExplicitTermsPrivacyChecked"
    }
  }, [_c("i18n", {
    attrs: {
      slot: "label",
      path: _vm.consentTextPath
    },
    slot: "label"
  }, [_c("a", {
    attrs: {
      href: _vm.termsUrl,
      "data-test": _vm.name + "-terms-button",
      target: "_blank",
      place: "termsAndConditions"
    },
    on: {
      click: _vm.handleTermsClick
    }
  }, [_vm._v(_vm._s(_vm.$t("termsConsent.terms")))]), _vm._v(" "), _c("a", {
    attrs: {
      href: _vm.privacyUrl,
      "data-test": _vm.name + "-privacy-button",
      target: "_blank",
      place: "privacyPolicy"
    },
    on: {
      click: _vm.handlePrivacyClick
    }
  }, [_vm._v(_vm._s(_vm.$t("termsConsent.privacyNotice")))])])], 1)] : _vm.showExplicitTerms ? [_c("al-checkbox", {
    directives: [{
      name: "validate",
      rawName: "v-validate.immediate",
      value: "required:true",
      expression: "'required:true'",
      modifiers: {
        immediate: true
      }
    }],
    attrs: {
      name: _vm.name + "-terms-consent-checkbox"
    },
    on: {
      input: _vm.handleTermsChecked
    },
    model: {
      value: _vm.isExplicitTermsChecked,
      callback: function ($$v) {
        _vm.isExplicitTermsChecked = $$v;
      },
      expression: "isExplicitTermsChecked"
    }
  }, [_c("i18n", {
    attrs: {
      slot: "label",
      path: _vm.consentTextPath
    },
    slot: "label"
  }, [_c("a", {
    attrs: {
      href: _vm.termsUrl,
      "data-test": _vm.name + "-terms-button",
      target: "_blank",
      place: "termsAndConditions"
    },
    on: {
      click: _vm.handleTermsClick
    }
  }, [_vm._v(_vm._s(_vm.$t("termsConsent.terms")))])])], 1), _vm._v(" "), _c("i18n", {
    staticClass: "legal align-center",
    attrs: {
      path: _vm.implicitConsentText,
      tag: "p",
      "data-test": "legal-footnote"
    }
  }, [_c("a", {
    attrs: {
      href: _vm.privacyUrl,
      "data-test": _vm.name + "-privacy-button",
      target: "_blank",
      place: "privacyPolicy"
    },
    on: {
      click: _vm.handlePrivacyClick
    }
  }, [_vm._v(_vm._s(_vm.$t("termsConsent.privacyNotice")))])])] : _vm.showExplicitPrivacy ? [_c("al-checkbox", {
    directives: [{
      name: "validate",
      rawName: "v-validate.immediate",
      value: "required:true",
      expression: "'required:true'",
      modifiers: {
        immediate: true
      }
    }],
    attrs: {
      name: _vm.name + "-privacy-consent-checkbox"
    },
    on: {
      input: _vm.handlePrivacyChecked
    },
    model: {
      value: _vm.isExplicitPrivacyChecked,
      callback: function ($$v) {
        _vm.isExplicitPrivacyChecked = $$v;
      },
      expression: "isExplicitPrivacyChecked"
    }
  }, [_c("i18n", {
    attrs: {
      slot: "label",
      path: _vm.consentTextPath
    },
    slot: "label"
  }, [_c("a", {
    attrs: {
      href: _vm.privacyUrl,
      "data-test": _vm.name + "-privacy-button",
      target: "_blank",
      place: "privacyPolicy"
    },
    on: {
      click: _vm.handlePrivacyClick
    }
  }, [_vm._v(_vm._s(_vm.$t("termsConsent.privacyNotice")))])])], 1), _vm._v(" "), _c("i18n", {
    staticClass: "legal align-center",
    attrs: {
      path: _vm.implicitConsentText,
      tag: "p",
      "data-test": "legal-footnote"
    }
  }, [_c("a", {
    attrs: {
      href: _vm.termsUrl,
      "data-test": _vm.name + "-terms-button",
      target: "_blank",
      place: "termsAndConditions"
    },
    on: {
      click: _vm.handleTermsClick
    }
  }, [_vm._v(_vm._s(_vm.$t("termsConsent.terms")))])])] : [_c("i18n", {
    staticClass: "legal align-center",
    attrs: {
      path: _vm.consentTextPath,
      tag: "p",
      "data-test": "legal-footnote"
    }
  }, [_c("a", {
    attrs: {
      href: _vm.termsUrl,
      "data-test": _vm.name + "-terms-button",
      target: "_blank",
      place: "termsAndConditions"
    },
    on: {
      click: _vm.handleTermsClick
    }
  }, [_vm._v(_vm._s(_vm.$t("termsConsent.terms")))]), _vm._v(" "), _c("a", {
    attrs: {
      href: _vm.privacyUrl,
      "data-test": _vm.name + "-privacy-button",
      target: "_blank",
      place: "privacyPolicy"
    },
    on: {
      click: _vm.handlePrivacyClick
    }
  }, [_vm._v(_vm._s(_vm.$t("termsConsent.privacyNotice")))])])]], 2)]);
};
var __vue_staticRenderFns__$f = [];
__vue_render__$f._withStripped = true;

/* style */
const __vue_inject_styles__$f = function (inject) {
  if (!inject) return;
  inject("data-v-2f183168_0", {
    source: "\n.tux-terms-consent[data-v-2f183168] {\n  flex-grow: 1;\n}\n",
    map: {
      "version": 3,
      "sources": ["/vol_01/sys_apps_01/jenkins/workspace/Alberta_BERT_tuxedo_master/src/components/TuxTermsConsent.vue"],
      "names": [],
      "mappings": ";AAuSA;EACA,YAAA;AACA",
      "file": "TuxTermsConsent.vue",
      "sourcesContent": ["<template>\n  <div class=\"row\" :class=\"{ 'tux-terms-consent': flexGrow }\">\n    <div class=\"col-full\" :class=\"consentClass\">\n      <template v-if=\"showExplicitTermsPrivacy\">\n        <template v-if=\"allowHeading\">\n          <section v-if=\"!hideDivider\" data-test=\"terms-consent-divider\" />\n          <h2 class=\"heading-md\">\n            {{ $t('termsConsent.termsHeading') }}\n          </h2>\n        </template>\n        <al-checkbox\n          v-model=\"isExplicitTermsPrivacyChecked\"\n          v-validate.immediate=\"'required:true'\"\n          :name=\"`${name}-terms-consent-checkbox`\"\n          @input=\"handleConsentChecked\">\n          <i18n slot=\"label\" :path=\"consentTextPath\">\n            <a\n              :href=\"termsUrl\"\n              :data-test=\"`${name}-terms-button`\"\n              target=\"_blank\"\n              place=\"termsAndConditions\"\n              @click=\"handleTermsClick\"\n              >{{ $t('termsConsent.terms') }}</a\n            >\n            <a\n              :href=\"privacyUrl\"\n              :data-test=\"`${name}-privacy-button`\"\n              target=\"_blank\"\n              place=\"privacyPolicy\"\n              @click=\"handlePrivacyClick\"\n              >{{ $t('termsConsent.privacyNotice') }}</a\n            >\n          </i18n>\n        </al-checkbox>\n      </template>\n      <template v-else-if=\"showExplicitTerms\">\n        <al-checkbox\n          v-model=\"isExplicitTermsChecked\"\n          v-validate.immediate=\"'required:true'\"\n          :name=\"`${name}-terms-consent-checkbox`\"\n          @input=\"handleTermsChecked\">\n          <i18n slot=\"label\" :path=\"consentTextPath\">\n            <a\n              :href=\"termsUrl\"\n              :data-test=\"`${name}-terms-button`\"\n              target=\"_blank\"\n              place=\"termsAndConditions\"\n              @click=\"handleTermsClick\"\n              >{{ $t('termsConsent.terms') }}</a\n            >\n          </i18n>\n        </al-checkbox>\n        <i18n\n          :path=\"implicitConsentText\"\n          tag=\"p\"\n          data-test=\"legal-footnote\"\n          class=\"legal align-center\">\n          <a\n            :href=\"privacyUrl\"\n            :data-test=\"`${name}-privacy-button`\"\n            target=\"_blank\"\n            place=\"privacyPolicy\"\n            @click=\"handlePrivacyClick\"\n            >{{ $t('termsConsent.privacyNotice') }}</a\n          >\n        </i18n>\n      </template>\n      <template v-else-if=\"showExplicitPrivacy\">\n        <al-checkbox\n          v-model=\"isExplicitPrivacyChecked\"\n          v-validate.immediate=\"'required:true'\"\n          :name=\"`${name}-privacy-consent-checkbox`\"\n          @input=\"handlePrivacyChecked\">\n          <i18n slot=\"label\" :path=\"consentTextPath\">\n            <a\n              :href=\"privacyUrl\"\n              :data-test=\"`${name}-privacy-button`\"\n              target=\"_blank\"\n              place=\"privacyPolicy\"\n              @click=\"handlePrivacyClick\"\n              >{{ $t('termsConsent.privacyNotice') }}</a\n            >\n          </i18n>\n        </al-checkbox>\n        <i18n\n          :path=\"implicitConsentText\"\n          tag=\"p\"\n          data-test=\"legal-footnote\"\n          class=\"legal align-center\">\n          <a\n            :href=\"termsUrl\"\n            :data-test=\"`${name}-terms-button`\"\n            target=\"_blank\"\n            place=\"termsAndConditions\"\n            @click=\"handleTermsClick\"\n            >{{ $t('termsConsent.terms') }}</a\n          >\n        </i18n>\n      </template>\n      <template v-else>\n        <i18n :path=\"consentTextPath\" tag=\"p\" data-test=\"legal-footnote\" class=\"legal align-center\">\n          <a\n            :href=\"termsUrl\"\n            :data-test=\"`${name}-terms-button`\"\n            target=\"_blank\"\n            place=\"termsAndConditions\"\n            @click=\"handleTermsClick\"\n            >{{ $t('termsConsent.terms') }}</a\n          >\n          <a\n            :href=\"privacyUrl\"\n            :data-test=\"`${name}-privacy-button`\"\n            target=\"_blank\"\n            place=\"privacyPolicy\"\n            @click=\"handlePrivacyClick\"\n            >{{ $t('termsConsent.privacyNotice') }}</a\n          >\n        </i18n>\n      </template>\n    </div>\n  </div>\n</template>\n\n<script>\nimport { AlCheckbox } from '@mc-alberta/alcapone'\nimport { COUNTRY_FEATURES } from '@/constants'\n\nexport default {\n  name: 'TuxTermsConsent',\n  components: { AlCheckbox },\n  inject: ['$validator'],\n  props: {\n    /**\n     * Whether or not to allow a heading with divider above the explict terms consent checkbox\n     */\n    allowHeading: {\n      type: Boolean,\n      default: false\n    },\n    /**\n     * If you would like to override the default text been displayed, you may passed a content text\n     * token to be used instead.\n     */\n    customText: {\n      type: String,\n      default: ''\n    },\n    /**\n     * Do not show the explicit consent checkbox even if it's required in a particular country.\n     */\n    disableExplicitConsent: {\n      type: Boolean,\n      default: false\n    },\n    /**\n     * The name of the component, used to label the data-test element.\n     */\n    name: {\n      type: String,\n      required: true\n    },\n    /**\n     * Privacy Notice Url\n     */\n    privacyUrl: {\n      type: String,\n      required: true\n    },\n    /**\n     * Show the reacceptance verbiage instead of the default\n     */\n    reacceptance: {\n      type: Boolean,\n      default: false\n    },\n    /**\n     * Terms & Conditions Url\n     */\n    termsUrl: {\n      type: String,\n      required: true\n    },\n    /**\n     * Whether or not to hide divider above the explict terms consent checkbox\n     */\n    hideDivider: {\n      type: Boolean,\n      default: false\n    },\n    /**\n     * Whether or not flex-grow should be set to 1\n     */\n    flexGrow: {\n      type: Boolean,\n      default: false\n    }\n  },\n  data() {\n    return {\n      isExplicitTermsRequired: false,\n      isExplicitPrivacyRequired: false,\n      isExplicitTermsPrivacyChecked: false,\n      isExplicitTermsChecked: false,\n      isExplicitPrivacyChecked: false,\n      consentClass: 'col-vertical-align-bottom'\n    }\n  },\n  computed: {\n    consentTextPath() {\n      let textPath\n\n      if (this.customText) {\n        textPath = this.customText\n      } else if (this.reacceptance) {\n        textPath = this.reacceptanceText\n      } else if (!this.disableExplicitConsent) {\n        const childText = this.getChildText()\n        textPath = `termsConsent.default.${childText}`\n      } else {\n        textPath = `termsConsent.default.consent`\n      }\n\n      return textPath\n    },\n    implicitConsentText() {\n      return this.isExplicitTermsRequired\n        ? 'termsConsent.default.implicitPrivacy'\n        : 'termsConsent.default.implicitTerms'\n    },\n    showExplicitTermsPrivacy() {\n      return this.showExplicitTerms && this.showExplicitPrivacy\n    },\n    showExplicitTerms() {\n      return this.isExplicitTermsRequired && !this.disableExplicitConsent\n    },\n    showExplicitPrivacy() {\n      return this.isExplicitPrivacyRequired && !this.disableExplicitConsent\n    },\n    reacceptanceText() {\n      return 'termsConsent.reacceptance.consent'\n    }\n  },\n  watch: {\n    '$i18n.locale': {\n      immediate: true,\n      handler() {\n        this.isExplicitTermsRequired = this.$i18nData.isCountryFeatureEnabled(\n          COUNTRY_FEATURES.EXPLICIT_TERMS_CONSENT,\n          this.$i18n.locale\n        )\n        this.isExplicitPrivacyRequired = this.$i18nData.isCountryFeatureEnabled(\n          COUNTRY_FEATURES.EXPLICIT_PRIVACY_CONSENT,\n          this.$i18n.locale\n        )\n      }\n    }\n  },\n  methods: {\n    getChildText() {\n      let childText\n      if (this.isExplicitTermsRequired && this.isExplicitPrivacyRequired) {\n        childText = 'explicitConsent'\n        this.consentClass = 'col-vertical-align-top'\n      } else if (this.isExplicitTermsRequired) {\n        childText = 'explicitTerms'\n        this.consentClass = 'col-vertical-space-between'\n      } else if (this.isExplicitPrivacyRequired) {\n        childText = 'explicitPrivacy'\n        this.consentClass = 'col-vertical-space-between'\n      } else {\n        childText = 'consent'\n        this.consentClass = 'col-vertical-align-bottom'\n      }\n      return childText\n    },\n    handlePrivacyClick(event) {\n      this.$emit('privacy-click', event)\n    },\n    handleTermsClick(event) {\n      this.$emit('terms-click', event)\n    },\n    handleConsentChecked(checked) {\n      this.$emit('consent-checked', checked)\n    },\n    handleTermsChecked(checked) {\n      this.$emit('terms-checked', checked)\n    },\n    handlePrivacyChecked(checked) {\n      this.$emit('privacy-checked', checked)\n    }\n  }\n}\n</script>\n\n<style scoped>\n.tux-terms-consent {\n  flex-grow: 1;\n}\n</style>\n"]
    },
    media: undefined
  });
};
/* scoped */
const __vue_scope_id__$f = "data-v-2f183168";
/* module identifier */
const __vue_module_identifier__$f = undefined;
/* functional template */
const __vue_is_functional_template__$f = false;
/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$m = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$f,
  staticRenderFns: __vue_staticRenderFns__$f
}, __vue_inject_styles__$f, __vue_script__$f, __vue_scope_id__$f, __vue_is_functional_template__$f, __vue_module_identifier__$f, false, createInjector, undefined, undefined);
var TuxTermsConsent = __vue_component__$m;

/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

// do not edit .js files directly - edit src/index.jst



var fastDeepEqual = function equal(a, b) {
  if (a === b) return true;

  if (a && b && typeof a == 'object' && typeof b == 'object') {
    if (a.constructor !== b.constructor) return false;

    var length, i, keys;
    if (Array.isArray(a)) {
      length = a.length;
      if (length != b.length) return false;
      for (i = length; i-- !== 0;)
        if (!equal(a[i], b[i])) return false;
      return true;
    }



    if (a.constructor === RegExp) return a.source === b.source && a.flags === b.flags;
    if (a.valueOf !== Object.prototype.valueOf) return a.valueOf() === b.valueOf();
    if (a.toString !== Object.prototype.toString) return a.toString() === b.toString();

    keys = Object.keys(a);
    length = keys.length;
    if (length !== Object.keys(b).length) return false;

    for (i = length; i-- !== 0;)
      if (!Object.prototype.hasOwnProperty.call(b, keys[i])) return false;

    for (i = length; i-- !== 0;) {
      var key = keys[i];

      if (!equal(a[key], b[key])) return false;
    }

    return true;
  }

  // true if both NaN, false otherwise
  return a!==a && b!==b;
};

/**
 * Copyright 2019 Google LLC. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at.
 *
 *      Http://www.apache.org/licenses/LICENSE-2.0.
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const DEFAULT_ID = "__googleMapsScriptId";
/**
 * The status of the [[Loader]].
 */
var LoaderStatus;
(function (LoaderStatus) {
    LoaderStatus[LoaderStatus["INITIALIZED"] = 0] = "INITIALIZED";
    LoaderStatus[LoaderStatus["LOADING"] = 1] = "LOADING";
    LoaderStatus[LoaderStatus["SUCCESS"] = 2] = "SUCCESS";
    LoaderStatus[LoaderStatus["FAILURE"] = 3] = "FAILURE";
})(LoaderStatus || (LoaderStatus = {}));
/**
 * [[Loader]] makes it easier to add Google Maps JavaScript API to your application
 * dynamically using
 * [Promises](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Promise).
 * It works by dynamically creating and appending a script node to the the
 * document head and wrapping the callback function so as to return a promise.
 *
 * ```
 * const loader = new Loader({
 *   apiKey: "",
 *   version: "weekly",
 *   libraries: ["places"]
 * });
 *
 * loader.load().then((google) => {
 *   const map = new google.maps.Map(...)
 * })
 * ```
 */
class Loader {
    /**
     * Creates an instance of Loader using [[LoaderOptions]]. No defaults are set
     * using this library, instead the defaults are set by the Google Maps
     * JavaScript API server.
     *
     * ```
     * const loader = Loader({apiKey, version: 'weekly', libraries: ['places']});
     * ```
     */
    constructor({ apiKey, authReferrerPolicy, channel, client, id = DEFAULT_ID, language, libraries = [], mapIds, nonce, region, retries = 3, url = "https://maps.googleapis.com/maps/api/js", version, }) {
        this.callbacks = [];
        this.done = false;
        this.loading = false;
        this.errors = [];
        this.apiKey = apiKey;
        this.authReferrerPolicy = authReferrerPolicy;
        this.channel = channel;
        this.client = client;
        this.id = id || DEFAULT_ID; // Do not allow empty string
        this.language = language;
        this.libraries = libraries;
        this.mapIds = mapIds;
        this.nonce = nonce;
        this.region = region;
        this.retries = retries;
        this.url = url;
        this.version = version;
        if (Loader.instance) {
            if (!fastDeepEqual(this.options, Loader.instance.options)) {
                throw new Error(`Loader must not be called again with different options. ${JSON.stringify(this.options)} !== ${JSON.stringify(Loader.instance.options)}`);
            }
            return Loader.instance;
        }
        Loader.instance = this;
    }
    get options() {
        return {
            version: this.version,
            apiKey: this.apiKey,
            channel: this.channel,
            client: this.client,
            id: this.id,
            libraries: this.libraries,
            language: this.language,
            region: this.region,
            mapIds: this.mapIds,
            nonce: this.nonce,
            url: this.url,
            authReferrerPolicy: this.authReferrerPolicy,
        };
    }
    get status() {
        if (this.errors.length) {
            return LoaderStatus.FAILURE;
        }
        if (this.done) {
            return LoaderStatus.SUCCESS;
        }
        if (this.loading) {
            return LoaderStatus.LOADING;
        }
        return LoaderStatus.INITIALIZED;
    }
    get failed() {
        return this.done && !this.loading && this.errors.length >= this.retries + 1;
    }
    /**
     * CreateUrl returns the Google Maps JavaScript API script url given the [[LoaderOptions]].
     *
     * @ignore
     * @deprecated
     */
    createUrl() {
        let url = this.url;
        url += `?callback=__googleMapsCallback`;
        if (this.apiKey) {
            url += `&key=${this.apiKey}`;
        }
        if (this.channel) {
            url += `&channel=${this.channel}`;
        }
        if (this.client) {
            url += `&client=${this.client}`;
        }
        if (this.libraries.length > 0) {
            url += `&libraries=${this.libraries.join(",")}`;
        }
        if (this.language) {
            url += `&language=${this.language}`;
        }
        if (this.region) {
            url += `&region=${this.region}`;
        }
        if (this.version) {
            url += `&v=${this.version}`;
        }
        if (this.mapIds) {
            url += `&map_ids=${this.mapIds.join(",")}`;
        }
        if (this.authReferrerPolicy) {
            url += `&auth_referrer_policy=${this.authReferrerPolicy}`;
        }
        return url;
    }
    deleteScript() {
        const script = document.getElementById(this.id);
        if (script) {
            script.remove();
        }
    }
    /**
     * Load the Google Maps JavaScript API script and return a Promise.
     * @deprecated, use importLibrary() instead.
     */
    load() {
        return this.loadPromise();
    }
    /**
     * Load the Google Maps JavaScript API script and return a Promise.
     *
     * @ignore
     * @deprecated, use importLibrary() instead.
     */
    loadPromise() {
        return new Promise((resolve, reject) => {
            this.loadCallback((err) => {
                if (!err) {
                    resolve(window.google);
                }
                else {
                    reject(err.error);
                }
            });
        });
    }
    importLibrary(name) {
        this.execute();
        return google.maps.importLibrary(name);
    }
    /**
     * Load the Google Maps JavaScript API script with a callback.
     * @deprecated, use importLibrary() instead.
     */
    loadCallback(fn) {
        this.callbacks.push(fn);
        this.execute();
    }
    /**
     * Set the script on document.
     */
    setScript() {
        var _a, _b;
        if (document.getElementById(this.id)) {
            // TODO wrap onerror callback for cases where the script was loaded elsewhere
            this.callback();
            return;
        }
        const params = {
            key: this.apiKey,
            channel: this.channel,
            client: this.client,
            libraries: this.libraries.length && this.libraries,
            v: this.version,
            mapIds: this.mapIds,
            language: this.language,
            region: this.region,
            authReferrerPolicy: this.authReferrerPolicy,
        };
        // keep the URL minimal:
        Object.keys(params).forEach(
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        (key) => !params[key] && delete params[key]);
        if (!((_b = (_a = window === null || window === void 0 ? void 0 : window.google) === null || _a === void 0 ? void 0 : _a.maps) === null || _b === void 0 ? void 0 : _b.importLibrary)) {
            // tweaked copy of https://developers.google.com/maps/documentation/javascript/load-maps-js-api#dynamic-library-import
            // which also sets the base url, the id, and the nonce
            /* eslint-disable */
            ((g) => {
                // @ts-ignore
                let h, a, k, p = "The Google Maps JavaScript API", c = "google", l = "importLibrary", q = "__ib__", m = document, b = window;
                // @ts-ignore
                b = b[c] || (b[c] = {});
                // @ts-ignore
                const d = b.maps || (b.maps = {}), r = new Set(), e = new URLSearchParams(), u = () => 
                // @ts-ignore
                h || (h = new Promise((f, n) => __awaiter(this, void 0, void 0, function* () {
                    var _a;
                    yield (a = m.createElement("script"));
                    a.id = this.id;
                    e.set("libraries", [...r] + "");
                    // @ts-ignore
                    for (k in g)
                        e.set(k.replace(/[A-Z]/g, (t) => "_" + t[0].toLowerCase()), g[k]);
                    e.set("callback", c + ".maps." + q);
                    a.src = this.url + `?` + e;
                    d[q] = f;
                    a.onerror = () => (h = n(Error(p + " could not load.")));
                    // @ts-ignore
                    a.nonce = this.nonce || ((_a = m.querySelector("script[nonce]")) === null || _a === void 0 ? void 0 : _a.nonce) || "";
                    m.head.append(a);
                })));
                // @ts-ignore
                d[l] ? console.warn(p + " only loads once. Ignoring:", g) : (d[l] = (f, ...n) => r.add(f) && u().then(() => d[l](f, ...n)));
            })(params);
            /* eslint-enable */
        }
        // While most libraries populate the global namespace when loaded via bootstrap params,
        // this is not the case for "marker" when used with the inline bootstrap loader
        // (and maybe others in the future). So ensure there is an importLibrary for each:
        const libraryPromises = this.libraries.map((library) => this.importLibrary(library));
        // ensure at least one library, to kick off loading...
        if (!libraryPromises.length) {
            libraryPromises.push(this.importLibrary("core"));
        }
        Promise.all(libraryPromises).then(() => this.callback(), (error) => {
            const event = new ErrorEvent("error", { error }); // for backwards compat
            this.loadErrorCallback(event);
        });
    }
    /**
     * Reset the loader state.
     */
    reset() {
        this.deleteScript();
        this.done = false;
        this.loading = false;
        this.errors = [];
        this.onerrorEvent = null;
    }
    resetIfRetryingFailed() {
        if (this.failed) {
            this.reset();
        }
    }
    loadErrorCallback(e) {
        this.errors.push(e);
        if (this.errors.length <= this.retries) {
            const delay = this.errors.length * Math.pow(2, this.errors.length);
            console.error(`Failed to load Google Maps script, retrying in ${delay} ms.`);
            setTimeout(() => {
                this.deleteScript();
                this.setScript();
            }, delay);
        }
        else {
            this.onerrorEvent = e;
            this.callback();
        }
    }
    callback() {
        this.done = true;
        this.loading = false;
        this.callbacks.forEach((cb) => {
            cb(this.onerrorEvent);
        });
        this.callbacks = [];
    }
    execute() {
        this.resetIfRetryingFailed();
        if (this.done) {
            this.callback();
        }
        else {
            // short circuit and warn if google.maps is already loaded
            if (window.google && window.google.maps && window.google.maps.version) {
                console.warn("Google Maps already loaded outside @googlemaps/js-api-loader." +
                    "This may result in undesirable behavior as options and script parameters may not match.");
                this.callback();
                return;
            }
            if (this.loading) ;
            else {
                this.loading = true;
                this.setScript();
            }
        }
    }
}

/**
 * Injects and loads google map script to document head and returns a promise containing the google object:
 * @return {Promise} - resolves to google object
 */
let apiKey;
const setAutocompleteApiKey = key => {
  // checking for null as string because dotenv does not accept falsy values
  // and we need a way to not set an API key for a particular enviroment ~Ronald
  if (key && key !== 'null') {
    apiKey = key;
  }
};
const initializeAutocomplete = async (vm, _ref) => {
  let {
    languageCode
  } = _ref;
  // do not load the script if we dont have an api key setup
  if (!apiKey) {
    return null;
  }
  const loader = new Loader({
    apiKey,
    version: 'weekly',
    language: languageCode
  });

  /*
   * Callback function that is invoked when there is an API auth error (i.e. invalid API key)
   * This would occur after the Google script successfully initializes without error, during user input
   * https://developers.google.com/maps/documentation/javascript/events#auth-errors
   *
   * The AddressForm must be notified of the API error, hence why we are using the Vue instance to
   * dispatch a Vue custom event
   */
  global.gm_authFailure = () => {
    vm.$root.$emit('autocompleteApiError');
  };
  return await loader.importLibrary('places');
};

/**
 * Returns a name mapping of address component types from autocomplete selection results
 *
 * @param {Object} place - results from the place the user selected from google autocomplete dropdown
 * @returns {Object}
 */
function _getPlaceTypeMap(place) {
  const shortNameFields = ['country', 'administrative_area_level_1'];
  return place?.address_components?.reduce((placeTypeMap, currAddressComponent) => {
    /* eslint-disable camelcase */
    const {
      types,
      short_name,
      long_name
    } = currAddressComponent;
    const addressType = types[0];
    placeTypeMap[addressType] = shortNameFields.includes(addressType) ? short_name : long_name;
    /* eslint-enable camelcase */

    return placeTypeMap;
  }, {});
}

/**
 * Returns a country friendly address based on user's google autocomplete selection
 *
 * --- Sample Addresses ---
 *
 * AR (Argentina):
 *  - Estados Unidos 1234, C1227 CABA, Argentina
 *  - Amenábar 1565, C1426 AKC, Buenos Aires, Argentina
 *  - Echenagucía 1232, Buenos Aires, Argentina
 *
 * GB (United Kingdom):
 *  - 121 Ladbroke Grove, Notting Hill, London W11 1PN, UK
 *  - 123 Buckingham Palace Rd, Victoria, London SW1W 9SR, UK
 *
 * IE (Ireland)
 *  - 123 S Circular Rd, Merchants Quay, Dublin 8, D08 K1HH, Ireland
 *
 * SE (Sweden):
 *  - Råsundavägen 123, 169 50 Solna, Sweden
 *  - Valbovägen 321, 818 32 Valbo, Sweden
 *
 * TR (Turkey):
 *  - Ata, Lizbon Cd No:123, 06460 Çankaya/Ankara, Turkey
 *  - Yeni, 26180. Sk., 02040 Adıyaman Merkez/Adıyaman, Turkey
 *  - Ergazi, Batıkent Blv. No:14, 06370 Ostim Osb/Yenimahalle/Ankara, Turkey
 *
 * US (United States):
 *  - 2000 Purchase St, Purchase, NY 10577, USA
 *  - 341 Gold St, Brooklyn, NY 11201, USA
 *
 * {@link https://developers.google.com/places/supported_types#table2}
 *
 * @param {Object} place - object that contains results from the place the user selected from google autocomplete dropdown
 * @returns {Object}
 */
// eslint-disable-next-line complexity
function getAddressFromPlace(place) {
  const placeTypeMap = _getPlaceTypeMap(place);
  if (!placeTypeMap || !Object.keys(placeTypeMap).length) return;

  /* eslint-disable camelcase */
  const {
    administrative_area_level_1,
    administrative_area_level_2,
    administrative_area_level_3,
    administrative_area_level_4,
    country,
    locality,
    neighborhood,
    postal_code,
    postal_town,
    route,
    street_number,
    sublocality_level_1,
    sublocality_level_2,
    sublocality_level_3,
    sublocality_level_4,
    subpremise,
    premise,
    point_of_interest
  } = placeTypeMap;
  const defaultConfig = {
    countryCode: country,
    line1: [street_number, route].filter(Boolean).join(' '),
    city: locality || sublocality_level_1,
    state: administrative_area_level_1,
    zip: postal_code
  };
  const countryOverrides = {
    AR: {
      line1: [route, street_number].filter(Boolean).join(' ')
    },
    AT: {
      line1: [route, street_number].filter(Boolean).join(' ')
    },
    BG: {
      line1: [neighborhood, [route, street_number].filter(Boolean).join(' ')].filter(Boolean).join(', '),
      line2: subpremise
    },
    CR: {
      line1: [route, street_number].filter(Boolean).join(' ') || point_of_interest,
      city: locality || administrative_area_level_2,
      state: administrative_area_level_1
    },
    DE: {
      line1: [route, street_number].filter(Boolean).join(' ')
    },
    EE: {
      line1: [route, street_number].filter(Boolean).join(' ')
    },
    EG: {
      line1: [street_number, route].filter(Boolean).join(' ') || administrative_area_level_3,
      line2: administrative_area_level_2,
      city: administrative_area_level_1
    },
    ES: {
      state: administrative_area_level_2
    },
    FI: {
      line1: [route, street_number].filter(Boolean).join(' ')
    },
    GB: {
      city: postal_town
    },
    GR: {
      line1: [route, street_number].filter(Boolean).join(' ')
    },
    HK: {
      city: neighborhood
    },
    HR: {
      line1: [route, street_number].filter(Boolean).join(' ')
    },
    HU: {
      line1: [route, street_number].filter(Boolean).join(' ')
    },
    IE: {
      city: locality || postal_town
    },
    IL: {
      line1: [route, street_number].filter(Boolean).join(' ')
    },
    JO: {
      line1: [route, street_number].filter(Boolean).join(' ')
    },
    LT: {
      line1: [route, street_number].filter(Boolean).join(' '),
      zip: `${country}-${postal_code}`
    },
    LV: {
      line1: [route, street_number].filter(Boolean).join(' '),
      zip: `${country}-${postal_code}`
    },
    MX: {
      city: locality,
      line1: [getRawField(place, 'route')?.short_name, street_number].filter(Boolean).join(' '),
      line2: sublocality_level_1,
      state: getRawField(place, 'administrative_area_level_1')?.long_name
    },
    SE: {
      city: postal_town
    },
    SK: {
      line1: [route, street_number].filter(Boolean).join(' ')
    },
    TR: {
      line1: [[route, street_number].filter(Boolean).join(' '), administrative_area_level_4, administrative_area_level_3, administrative_area_level_2].filter(Boolean).join(', '),
      city: administrative_area_level_1,
      state: undefined
    },
    VN: {
      line1: [street_number, route].filter(Boolean).join(' '),
      line2: neighborhood,
      line3: administrative_area_level_2 || administrative_area_level_1,
      city: locality || administrative_area_level_1,
      state: undefined
    },
    IN: {
      line1: [[street_number, route].filter(Boolean).join(' '), premise, neighborhood, sublocality_level_4, sublocality_level_3, sublocality_level_2, sublocality_level_1].filter(Boolean).join(', '),
      city: locality || administrative_area_level_2,
      state: getRawField(place, 'administrative_area_level_1')?.long_name
    },
    IT: {
      state: getRawField(place, 'administrative_area_level_2')?.short_name
    },
    JP: {
      line1: [[[route, sublocality_level_3, sublocality_level_4, premise].filter(Boolean).join('-'), sublocality_level_2].filter(Boolean).join(' '), locality].filter(Boolean).join(', ')
    },
    NZ: {
      city: locality,
      line3: sublocality_level_1
    },
    RO: {
      line1: [route, street_number].filter(Boolean).join(' ')
    },
    RS: {
      line1: [route, street_number].filter(Boolean).join(' ')
    }
  };
  /* eslint-enable camelcase */

  return Object.assign({}, defaultConfig, countryOverrides[country]);
}
function getRawField(place, fieldName) {
  return place.address_components.find(_ref2 => {
    let {
      types
    } = _ref2;
    return types.includes(fieldName);
  });
}

/**
 * Removes address fields with value of empty string
 *
 * **Note:** This function does not mutate `address`.
 *
 * @param {Object} address
 * @return {Object} address without empty strings
 */
const sanitize = address => {
  const addressSansEmptyStrings = {};
  for (const key in address) {
    const value = address[key];
    if (value?.length) {
      addressSansEmptyStrings[key] = value;
    }
  }
  return addressSansEmptyStrings;
};
var sanitize$1 = sanitize;

//
var script$e = {
  name: 'CityField',
  components: {
    AlInput
  },
  inject: ['$validator'],
  props: {
    autocomplete: {
      type: String,
      default: ''
    },
    address: {
      type: Object,
      default: null
    },
    name: {
      type: String,
      required: true
    },
    optionalForm: {
      type: Boolean,
      default: false
    },
    addressConfig: {
      type: Object,
      required: true
    }
  },
  computed: {
    localAddress: {
      get() {
        return this.address;
      },
      set(localAddress) {
        this.$emit('input', localAddress);
      }
    },
    isFormDirty() {
      if (this.fields) {
        return Object.keys(this.fields).some(key => key.includes(this.name) && this.fields[key].changed);
      }
      return false;
    },
    isFieldRequired() {
      return !this.optionalForm || this.isFormDirty;
    },
    inputLabelText() {
      return `${this.$t('addressForm.city')}${this.hasOptionalText('cityTown') ? ` ${this.$t('addressForm.optional')}` : ''}`;
    }
  },
  methods: {
    input() {
      this.$emit('input');
    },
    blur() {
      this.$emit('blur');
    },
    isEnabled(field) {
      return this.addressConfig[field]?.enabled;
    },
    hasOptionalText(field) {
      return !this.addressConfig[field]?.required;
    },
    setConfigRules(config) {
      const rules = {};
      const ruleMap = {
        ...(this.isFieldRequired && {
          required: 'required'
        }),
        minimumLength: 'min',
        maximumLength: 'max',
        regex: 'regex'
      };
      for (const rule in ruleMap) {
        if (config[rule]) {
          rules[ruleMap[rule]] = config[rule];
        }
      }
      return rules;
    },
    getValidationRules(field) {
      /**
       * Creates a VeeValidate rules object based on the given config.
       *
       * @param {Object} config - address field config
       * @returns {Object}
       */

      const config = this.addressConfig[field];
      const rules = config ? this.setConfigRules(config) : {};
      return rules;
    }
  }
};

/* script */
const __vue_script__$e = script$e;

/* template */
var __vue_render__$e = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _vm.isEnabled("cityTown") ? _c("div", {
    staticClass: "col"
  }, [_c("al-input", {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: _vm.getValidationRules("cityTown"),
      expression: "getValidationRules('cityTown')"
    }],
    attrs: {
      label: _vm.inputLabelText,
      name: _vm.name + "-city",
      autocomplete: _vm.autocomplete + " address-level2",
      "data-test": "city",
      type: "text"
    },
    on: {
      input: _vm.input,
      blur: _vm.blur
    },
    model: {
      value: _vm.localAddress.city,
      callback: function ($$v) {
        _vm.$set(_vm.localAddress, "city", $$v);
      },
      expression: "localAddress.city"
    }
  })], 1) : _vm._e();
};
var __vue_staticRenderFns__$e = [];
__vue_render__$e._withStripped = true;

/* style */
const __vue_inject_styles__$e = undefined;
/* scoped */
const __vue_scope_id__$e = undefined;
/* module identifier */
const __vue_module_identifier__$e = undefined;
/* functional template */
const __vue_is_functional_template__$e = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$l = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$e,
  staticRenderFns: __vue_staticRenderFns__$e
}, __vue_inject_styles__$e, __vue_script__$e, __vue_scope_id__$e, __vue_is_functional_template__$e, __vue_module_identifier__$e, false, undefined, undefined, undefined);
var city = __vue_component__$l;

//
var script$d = {
  name: 'CountryCodeField',
  components: {
    AlDropdown
  },
  inject: ['$validator'],
  props: {
    address: {
      type: Object,
      default: null
    },
    countries: {
      type: Array,
      default: () => []
    },
    name: {
      type: String,
      required: true
    },
    optionalForm: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    localAddress: {
      get() {
        return this.address;
      },
      set(localAddress) {
        this.$emit('input', localAddress);
      }
    },
    isFormDirty() {
      if (this.fields) {
        return Object.keys(this.fields).some(key => key.includes(this.name) && this.fields[key].changed);
      }
      return false;
    },
    isFieldRequired() {
      return !this.optionalForm || this.isFormDirty;
    }
  },
  methods: {
    input() {
      this.$emit('update-country-code', this.address.countryCode);
    },
    blur() {
      this.$emit('blur');
    }
  }
};

/* script */
const __vue_script__$d = script$d;

/* template */
var __vue_render__$d = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("div", {
    staticClass: "row"
  }, [_c("div", {
    staticClass: "col"
  }, [_c("al-dropdown", {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: _vm.isFieldRequired ? "required" : "",
      expression: "isFieldRequired ? 'required' : ''"
    }],
    attrs: {
      label: _vm.$t("addressForm.countryCode"),
      options: _vm.countries,
      name: _vm.name + "-countryCode"
    },
    on: {
      input: _vm.input,
      blur: _vm.blur
    },
    model: {
      value: _vm.localAddress.countryCode,
      callback: function ($$v) {
        _vm.$set(_vm.localAddress, "countryCode", $$v);
      },
      expression: "localAddress.countryCode"
    }
  })], 1)]);
};
var __vue_staticRenderFns__$d = [];
__vue_render__$d._withStripped = true;

/* style */
const __vue_inject_styles__$d = undefined;
/* scoped */
const __vue_scope_id__$d = undefined;
/* module identifier */
const __vue_module_identifier__$d = undefined;
/* functional template */
const __vue_is_functional_template__$d = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$k = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$d,
  staticRenderFns: __vue_staticRenderFns__$d
}, __vue_inject_styles__$d, __vue_script__$d, __vue_scope_id__$d, __vue_is_functional_template__$d, __vue_module_identifier__$d, false, undefined, undefined, undefined);
var country = __vue_component__$k;

//
var script$c = {
  components: {
    AlAutocompleteInput,
    AlInput
  },
  inject: ['$validator'],
  props: {
    autocomplete: {
      type: String,
      default: ''
    },
    address: {
      type: Object,
      default: null
    },
    enableAutocomplete: {
      type: Boolean,
      default: false
    },
    enableSingleAddressLine: {
      type: Boolean,
      default: false
    },
    alAutocompleteInputKey: {
      type: Number,
      required: true
    },
    line1Name: {
      type: String,
      required: true
    },
    name: {
      type: String,
      required: true
    },
    optionalForm: {
      type: Boolean,
      default: false
    },
    addressConfig: {
      type: Object,
      required: true
    },
    separateLineOneFields: {
      type: Array,
      required: true
    },
    separateLineThreeFields: {
      type: Array,
      required: true
    }
  },
  data() {
    return {
      addressAutocomplete: {},
      defaultCountryRestrict: 'US',
      lastFocusedInputId: '',
      addressLine1Value: {},
      addressLine3Value: {}
    };
  },
  computed: {
    localAddress: {
      get() {
        return this.address;
      },
      set(localAddress) {
        this.$emit('input', localAddress);
      }
    },
    isFormDirty() {
      if (this.fields) {
        return Object.keys(this.fields).some(key => key.includes(this.name) && this.fields[key].changed);
      }
      return false;
    },
    isFieldRequired() {
      return !this.optionalForm || this.isFormDirty;
    },
    inputLabelText() {
      return `${this.$t('addressForm.line1')} ${this.hasOptionalText('line1') ? this.$t('addressForm.optional') : ''}`.trim();
    },
    line2LabelText() {
      return `${this.$t('addressForm.line2')} ${this.hasOptionalText('line2') ? this.$t('addressForm.optional') : ''}`.trim();
    },
    line3LabelText() {
      return `${this.$t('addressForm.line3')} ${this.hasOptionalText('line3') ? this.$t('addressForm.optional') : ''}`.trim();
    },
    isLine1Split() {
      return this.separateLineOneFields.length > 0;
    },
    isLine3Split() {
      return this.separateLineThreeFields.length > 0;
    },
    isLine3Enabled() {
      return this.isEnabled('line3');
    },
    isSingleAddressLineEnabled() {
      return !this.isLine1Split && this.enableSingleAddressLine;
    },
    line1SplitLabel() {
      return {
        streetName: this.$t('addressForm.streetName'),
        streetNumber: this.$t('addressForm.streetNumber')
      };
    },
    line3SplitLabel() {
      return {
        neighborhood: this.$t('addressForm.neighborhood'),
        complemento: this.$t('addressForm.complemento')
      };
    }
  },
  methods: {
    input() {
      if (this.isLine1Split) {
        this.combineLine1();
      }
      if (this.isLine3Split) {
        this.combineLine3();
      }
      this.$emit('input');
    },
    autocompleteInputBlur() {
      this.$emit('autocomplete-input-blur');
      this.blur();
    },
    blur() {
      this.$emit('blur');
    },
    isEnabled(field) {
      return this.addressConfig[field]?.enabled;
    },
    hasOptionalText(field) {
      return !this.addressConfig[field]?.required;
    },
    setConfigRules(config) {
      const rules = {};
      const ruleMap = {
        ...(this.isFieldRequired && {
          required: 'required'
        }),
        minimumLength: 'min',
        maximumLength: 'max',
        regex: 'regex'
      };
      for (const rule in ruleMap) {
        if (config[rule]) {
          rules[ruleMap[rule]] = config[rule];
        }
      }
      return rules;
    },
    getValidationRules(field) {
      /**
       * Creates a VeeValidate rules object based on the given config.
       *
       * @param {Object} config - address field config
       * @returns {Object}
       */

      const config = this.addressConfig[field];
      const rules = config ? this.setConfigRules(config) : {};
      return rules;
    },
    getValidationForLine1(field) {
      const rules = this.getValidationRules('line1');
      const streetNameOverride = {
        max: 67
      };
      const streetNumberOverride = {
        max: 7
      };
      const override = field === 'streetName' ? streetNameOverride : streetNumberOverride;
      return Object.assign(rules, override);
    },
    getValidationForLine3(field) {
      const rules = this.getValidationRules('line3');
      const complementoOverride = {
        max: 29
      };
      const neighborhoodOverride = {
        max: 45
      };
      const override = field === 'complemento' ? complementoOverride : neighborhoodOverride;
      return Object.assign(rules, override);
    },
    combineLine1() {
      this.localAddress.line1 = Object.values(this.addressLine1Value).filter(Boolean).join(' ');
    },
    combineLine3() {
      this.localAddress.line3 = Object.values(this.addressLine3Value).filter(Boolean).join(' ');
    }
  }
};

/* script */
const __vue_script__$c = script$c;

/* template */
var __vue_render__$c = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("div", [_vm.isLine1Split ? _c("div", _vm._l(_vm.separateLineOneFields, function (field, index) {
    return _c("div", {
      key: field,
      staticClass: "row"
    }, [_c("div", {
      staticClass: "col"
    }, [_c("al-input", {
      directives: [{
        name: "validate",
        rawName: "v-validate",
        value: _vm.getValidationForLine1(field),
        expression: "getValidationForLine1(field)"
      }],
      staticClass: "col",
      attrs: {
        label: _vm.line1SplitLabel[field],
        name: _vm.name + "-" + field,
        autocomplete: _vm.autocomplete + " address-" + field,
        "data-test": field,
        type: "text"
      },
      on: {
        input: _vm.input,
        blur: _vm.blur
      },
      model: {
        value: _vm.addressLine1Value[index],
        callback: function ($$v) {
          _vm.$set(_vm.addressLine1Value, index, $$v);
        },
        expression: "addressLine1Value[index]"
      }
    })], 1)]);
  }), 0) : [_c("div", {
    staticClass: "row"
  }, [_c("div", {
    staticClass: "col"
  }, [_c("al-autocomplete-input", {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: _vm.getValidationRules("line1"),
      expression: "getValidationRules('line1')"
    }],
    key: _vm.alAutocompleteInputKey,
    attrs: {
      name: _vm.line1Name,
      label: _vm.inputLabelText
    },
    on: {
      input: _vm.input,
      blur: _vm.autocompleteInputBlur
    },
    model: {
      value: _vm.localAddress.line1,
      callback: function ($$v) {
        _vm.$set(_vm.localAddress, "line1", $$v);
      },
      expression: "localAddress.line1"
    }
  })], 1)])], _vm._v(" "), _c("div", {
    staticClass: "row",
    class: {
      "row-expandable": _vm.isSingleAddressLineEnabled
    }
  }, [_c("div", {
    staticClass: "col"
  }, [_c("al-input", {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: _vm.getValidationRules("line2"),
      expression: "getValidationRules('line2')"
    }],
    attrs: {
      label: _vm.line2LabelText,
      name: _vm.name + "-line2",
      autocomplete: _vm.autocomplete + " address-line2",
      "data-test": "line2",
      type: "text"
    },
    on: {
      input: _vm.input,
      blur: _vm.blur
    },
    model: {
      value: _vm.localAddress.line2,
      callback: function ($$v) {
        _vm.$set(_vm.localAddress, "line2", $$v);
      },
      expression: "localAddress.line2"
    }
  })], 1)]), _vm._v(" "), _vm.isLine3Split ? _c("div", _vm._l(_vm.separateLineThreeFields, function (field, index) {
    return _c("div", {
      key: field,
      staticClass: "row",
      class: {
        "row-expandable": _vm.isSingleAddressLineEnabled
      }
    }, [_c("div", {
      staticClass: "col"
    }, [_c("al-input", {
      directives: [{
        name: "validate",
        rawName: "v-validate",
        value: _vm.getValidationForLine3(field),
        expression: "getValidationForLine3(field)"
      }],
      attrs: {
        label: _vm.line3SplitLabel[field] + " " + (_vm.hasOptionalText(field) ? _vm.$t("addressForm.optional") : ""),
        name: _vm.name + "-" + field,
        autocomplete: _vm.autocomplete + " address-" + field,
        "data-test": field,
        type: "text"
      },
      on: {
        input: _vm.input,
        blur: _vm.blur
      },
      model: {
        value: _vm.addressLine3Value[index],
        callback: function ($$v) {
          _vm.$set(_vm.addressLine3Value, index, $$v);
        },
        expression: "addressLine3Value[index]"
      }
    })], 1)]);
  }), 0) : [_vm.isLine3Enabled ? _c("div", {
    staticClass: "row",
    class: {
      "row-expandable": _vm.isSingleAddressLineEnabled
    }
  }, [_c("div", {
    staticClass: "col"
  }, [_c("al-input", {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: _vm.getValidationRules("line3"),
      expression: "getValidationRules('line3')"
    }],
    attrs: {
      label: _vm.line3LabelText,
      name: _vm.name + "-line3",
      autocomplete: _vm.autocomplete + " address-line3",
      "data-test": "line3",
      type: "text"
    },
    on: {
      input: _vm.input,
      blur: _vm.blur
    },
    model: {
      value: _vm.localAddress.line3,
      callback: function ($$v) {
        _vm.$set(_vm.localAddress, "line3", $$v);
      },
      expression: "localAddress.line3"
    }
  })], 1)]) : _vm._e()]], 2);
};
var __vue_staticRenderFns__$c = [];
__vue_render__$c._withStripped = true;

/* style */
const __vue_inject_styles__$c = undefined;
/* scoped */
const __vue_scope_id__$c = undefined;
/* module identifier */
const __vue_module_identifier__$c = undefined;
/* functional template */
const __vue_is_functional_template__$c = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$j = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$c,
  staticRenderFns: __vue_staticRenderFns__$c
}, __vue_inject_styles__$c, __vue_script__$c, __vue_scope_id__$c, __vue_is_functional_template__$c, __vue_module_identifier__$c, false, undefined, undefined, undefined);
var lineFields = __vue_component__$j;

//
var script$b = {
  name: 'NameField',
  components: {
    AlInput
  },
  inject: ['$validator'],
  props: {
    enableNameField: {
      type: Boolean,
      default: true
    },
    address: {
      type: Object,
      default: null
    },
    autocomplete: {
      type: String,
      default: ''
    },
    name: {
      type: String,
      required: true
    },
    optionalForm: {
      type: Boolean,
      default: false
    },
    addressConfig: {
      type: Object,
      required: true
    }
  },
  computed: {
    localAddress: {
      get() {
        return this.address;
      },
      set(localAddress) {
        this.$emit('input', localAddress);
      }
    },
    nameMaximumLength() {
      // First/Last name is concatenated with a space
      const maxLengthSansSpace = this.addressConfig.fullName.maximumLength - 1;
      // Split maximum of fullName for first/last
      const halfMax = Math.floor(maxLengthSansSpace / 2);
      // Even Numbers
      return halfMax - halfMax % 2;
    },
    isFormDirty() {
      if (this.fields) {
        return Object.keys(this.fields).some(key => key.includes(this.name) && this.fields[key].changed);
      }
      return false;
    },
    isFieldRequired() {
      return !this.optionalForm || this.isFormDirty;
    }
  },
  methods: {
    input() {
      this.$emit('input');
    },
    blur() {
      this.$emit('blur');
    }
  }
};

/* script */
const __vue_script__$b = script$b;

/* template */
var __vue_render__$b = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _vm.enableNameField ? _c("div", {
    staticClass: "row"
  }, [_c("div", {
    staticClass: "col"
  }, [_c("al-input", {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: (_vm.isFieldRequired ? "required|" : "") + "max:" + _vm.nameMaximumLength,
      expression: "`${isFieldRequired ? 'required|' : ''}max:${nameMaximumLength}`"
    }],
    attrs: {
      label: _vm.$t("addressForm.firstName"),
      name: _vm.name + "-firstName",
      autocomplete: _vm.autocomplete + " given-name",
      "data-test": "first-name",
      type: "text"
    },
    on: {
      input: _vm.input,
      blur: _vm.blur
    },
    model: {
      value: _vm.localAddress.firstName,
      callback: function ($$v) {
        _vm.$set(_vm.localAddress, "firstName", $$v);
      },
      expression: "localAddress.firstName"
    }
  })], 1), _vm._v(" "), _c("div", {
    staticClass: "col"
  }, [_c("al-input", {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: (_vm.isFieldRequired ? "required|" : "") + "max:" + _vm.nameMaximumLength,
      expression: "`${isFieldRequired ? 'required|' : ''}max:${nameMaximumLength}`"
    }],
    attrs: {
      label: _vm.$t("addressForm.lastName"),
      name: _vm.name + "-lastName",
      autocomplete: _vm.autocomplete + " family-name",
      type: "text",
      "data-test": "last-name"
    },
    on: {
      input: _vm.input,
      blur: _vm.blur
    },
    model: {
      value: _vm.localAddress.lastName,
      callback: function ($$v) {
        _vm.$set(_vm.localAddress, "lastName", $$v);
      },
      expression: "localAddress.lastName"
    }
  })], 1)]) : _vm._e();
};
var __vue_staticRenderFns__$b = [];
__vue_render__$b._withStripped = true;

/* style */
const __vue_inject_styles__$b = undefined;
/* scoped */
const __vue_scope_id__$b = undefined;
/* module identifier */
const __vue_module_identifier__$b = undefined;
/* functional template */
const __vue_is_functional_template__$b = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$i = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$b,
  staticRenderFns: __vue_staticRenderFns__$b
}, __vue_inject_styles__$b, __vue_script__$b, __vue_scope_id__$b, __vue_is_functional_template__$b, __vue_module_identifier__$b, false, undefined, undefined, undefined);
var name = __vue_component__$i;

//
var script$a = {
  name: 'StateField',
  components: {
    AlDropdown,
    AlInput
  },
  inject: ['$validator'],
  props: {
    autocomplete: {
      type: String,
      default: ''
    },
    address: {
      type: Object,
      default: null
    },
    name: {
      type: String,
      required: true
    },
    optionalForm: {
      type: Boolean,
      default: false
    },
    addressConfig: {
      type: Object,
      required: true
    }
  },
  computed: {
    localAddress: {
      get() {
        return this.address;
      },
      set(localAddress) {
        this.$emit('input', localAddress);
      }
    },
    subdivision() {
      const subdivisions = this.addressConfig.subdivision.enum;
      if (!subdivisions) {
        return null;
      }
      return subdivisions.map(subdivision => ({
        value: subdivision,
        label: subdivision
      }));
    },
    isFormDirty() {
      if (this.fields) {
        return Object.keys(this.fields).some(key => key.includes(this.name) && this.fields[key].changed);
      }
      return false;
    },
    isFieldRequired() {
      return !this.optionalForm || this.isFormDirty;
    },
    inputLabelText() {
      return `${this.$t('addressForm.subdivision')}${this.hasOptionalText('subdivision') ? ` ${this.$t('addressForm.optional')}` : ''}`;
    }
  },
  methods: {
    input() {
      this.$emit('input');
    },
    blur() {
      this.$emit('blur');
    },
    isEnabled(field) {
      return this.addressConfig[field]?.enabled;
    },
    hasOptionalText(field) {
      return !this.addressConfig[field]?.required;
    },
    setConfigRules(config) {
      const rules = {};
      const ruleMap = {
        ...(this.isFieldRequired && {
          required: 'required'
        }),
        minimumLength: 'min',
        maximumLength: 'max',
        regex: 'regex'
      };
      for (const rule in ruleMap) {
        if (config[rule]) {
          rules[ruleMap[rule]] = config[rule];
        }
      }
      return rules;
    },
    getValidationRules(field) {
      /**
       * Creates a VeeValidate rules object based on the given config.
       *
       * @param {Object} config - address field config
       * @returns {Object}
       */

      const config = this.addressConfig[field];
      const rules = config ? this.setConfigRules(config) : {};
      return rules;
    }
  }
};

/* script */
const __vue_script__$a = script$a;

/* template */
var __vue_render__$a = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _vm.isEnabled("subdivision") ? _c("div", {
    staticClass: "col"
  }, [_vm.subdivision ? _c("al-dropdown", {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: _vm.getValidationRules("subdivision"),
      expression: "getValidationRules('subdivision')"
    }],
    attrs: {
      label: _vm.inputLabelText,
      options: _vm.subdivision,
      name: _vm.name + "-subdivision",
      autocomplete: _vm.autocomplete + " address-level1",
      "data-test": "subdivision"
    },
    on: {
      input: _vm.input,
      blur: _vm.blur
    },
    model: {
      value: _vm.localAddress.state,
      callback: function ($$v) {
        _vm.$set(_vm.localAddress, "state", $$v);
      },
      expression: "localAddress.state"
    }
  }) : _vm.isEnabled("subdivision") ? _c("al-input", {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: _vm.getValidationRules("subdivision"),
      expression: "getValidationRules('subdivision')"
    }],
    attrs: {
      label: _vm.inputLabelText,
      name: _vm.name + "-subdivision",
      autocomplete: _vm.autocomplete + " address-level1",
      type: "text",
      "data-test": "subdivision"
    },
    on: {
      input: _vm.input,
      blur: _vm.blur
    },
    model: {
      value: _vm.localAddress.state,
      callback: function ($$v) {
        _vm.$set(_vm.localAddress, "state", $$v);
      },
      expression: "localAddress.state"
    }
  }) : _vm._e()], 1) : _vm._e();
};
var __vue_staticRenderFns__$a = [];
__vue_render__$a._withStripped = true;

/* style */
const __vue_inject_styles__$a = undefined;
/* scoped */
const __vue_scope_id__$a = undefined;
/* module identifier */
const __vue_module_identifier__$a = undefined;
/* functional template */
const __vue_is_functional_template__$a = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$h = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$a,
  staticRenderFns: __vue_staticRenderFns__$a
}, __vue_inject_styles__$a, __vue_script__$a, __vue_scope_id__$a, __vue_is_functional_template__$a, __vue_module_identifier__$a, false, undefined, undefined, undefined);
var state = __vue_component__$h;

//
var script$9 = {
  name: 'ZipField',
  components: {
    AlInput
  },
  inject: ['$validator'],
  props: {
    autocomplete: {
      type: String,
      default: ''
    },
    address: {
      type: Object,
      default: null
    },
    name: {
      type: String,
      required: true
    },
    optionalForm: {
      type: Boolean,
      default: false
    },
    addressConfig: {
      type: Object,
      required: true
    }
  },
  computed: {
    localAddress: {
      get() {
        return this.address;
      },
      set(localAddress) {
        this.$emit('input', localAddress);
      }
    },
    postalMask() {
      /**
       * fetch mask value for zipcode from address config
       *
       * @returns {String}
       */
      return this.addressConfig.postalCode?.mask || null;
    },
    isFormDirty() {
      if (this.fields) {
        return Object.keys(this.fields).some(key => key.includes(this.name) && this.fields[key].changed);
      }
      return false;
    },
    isFieldRequired() {
      return !this.optionalForm || this.isFormDirty;
    },
    inputLabelText() {
      return `${this.$t('addressForm.zip')}${this.hasOptionalText('postalCode') ? ` ${this.$t('addressForm.optional')}` : ''}`;
    }
  },
  methods: {
    input() {
      this.$emit('input');
    },
    blur() {
      this.$emit('blur');
    },
    isEnabled(field) {
      return this.addressConfig[field]?.enabled;
    },
    hasOptionalText(field) {
      return !this.addressConfig[field]?.required;
    },
    setConfigRules(config) {
      const rules = {};
      const ruleMap = {
        ...(this.isFieldRequired && {
          required: 'required'
        }),
        minimumLength: 'min',
        maximumLength: 'max',
        regex: 'regex'
      };
      for (const rule in ruleMap) {
        if (config[rule]) {
          rules[ruleMap[rule]] = config[rule];
        }
      }
      return rules;
    },
    getValidationRules(field) {
      /**
       * Creates a VeeValidate rules object based on the given config.
       *
       * @param {Object} config - address field config
       * @returns {Object}
       */

      const config = this.addressConfig[field];
      const rules = config ? this.setConfigRules(config) : {};
      return rules;
    }
  }
};

/* script */
const __vue_script__$9 = script$9;

/* template */
var __vue_render__$9 = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _vm.isEnabled("postalCode") ? _c("div", {
    staticClass: "col"
  }, [_c("al-input", {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: _vm.getValidationRules("postalCode"),
      expression: "getValidationRules('postalCode')"
    }],
    attrs: {
      label: _vm.inputLabelText,
      mask: _vm.postalMask,
      name: _vm.name + "-postalCode",
      autocomplete: _vm.autocomplete + " postal-code",
      type: "text",
      "data-test": "postal-code"
    },
    on: {
      input: _vm.input,
      blur: _vm.blur
    },
    model: {
      value: _vm.localAddress.zip,
      callback: function ($$v) {
        _vm.$set(_vm.localAddress, "zip", $$v);
      },
      expression: "localAddress.zip"
    }
  })], 1) : _vm._e();
};
var __vue_staticRenderFns__$9 = [];
__vue_render__$9._withStripped = true;

/* style */
const __vue_inject_styles__$9 = undefined;
/* scoped */
const __vue_scope_id__$9 = undefined;
/* module identifier */
const __vue_module_identifier__$9 = undefined;
/* functional template */
const __vue_is_functional_template__$9 = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$g = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$9,
  staticRenderFns: __vue_staticRenderFns__$9
}, __vue_inject_styles__$9, __vue_script__$9, __vue_scope_id__$9, __vue_is_functional_template__$9, __vue_module_identifier__$9, false, undefined, undefined, undefined);
var zip = __vue_component__$g;

//
const singleAddressHiddenFields = ['line1', 'line2', 'line3', 'city', 'state', 'zip'];
var script$8 = {
  name: 'TuxAddressForm',
  components: {
    name,
    country,
    lineFields,
    city,
    state,
    zip
  },
  inject: ['$validator'],
  model: {
    prop: 'address',
    event: 'input'
  },
  props: {
    address: {
      type: Object,
      default: null
    },
    name: {
      type: String,
      required: true
    },
    countries: {
      type: Array,
      required: true
    },
    postalCodeOnly: {
      type: Boolean,
      default: false
    },
    nameOnly: {
      type: Boolean,
      default: false
    },
    enableNameField: {
      type: Boolean,
      default: true
    },
    autocomplete: {
      type: String,
      default: ''
    },
    enableAutocomplete: {
      type: Boolean,
      default: false
    },
    optionalForm: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      userCountryCode: this.address.countryCode,
      addressAutocomplete: {},
      defaultCountryRestrict: 'US',
      line1Focused: false,
      line1Name: `${this.name}-line1`,
      alAutocompleteInputKey: 0,
      rowsExpanded: false,
      isAutocompleteEnabled: this.enableAutocomplete && !this.postalCodeOnly,
      initialAddress: JSON.parse(JSON.stringify(this.address)),
      singleAddressHiddenFields,
      hasNameData: !!(this.address.firstName || this.address.lastName)
    };
  },
  computed: {
    countryConfig() {
      return this.$i18nData.getCountryConfig(this.userCountryCode, false) || {};
    },
    addressConfig() {
      return this.countryConfig.address || {};
    },
    currentCountryCodeFields() {
      if (this.postalCodeOnly) {
        const fields = ['country', 'zip'];
        return this.includeNameField ? ['name'].concat(fields) : fields;
      }
      if (this.nameOnly) {
        return ['name'];
      }
      const defaultSortOrder = ['name', 'country', 'lineFields', 'city', ['state', 'zip']];
      return this.countryConfig.addressFieldsSortOrder || defaultSortOrder;
    },
    filteredCountryCodeFields() {
      return this.currentCountryCodeFields.filter(field => {
        return JSON.stringify(field) !== JSON.stringify(this.splitLineOneFields) && JSON.stringify(field) !== JSON.stringify(this.splitLineThreeFields);
      });
    },
    filteredCountries() {
      return this.countries.filter(country => !this.$i18nData.isCountryRestricted(country.value));
    },
    splitLineOneFields() {
      return this.currentCountryCodeFields.find(field => {
        return field.includes('streetName') && field.includes('streetNumber');
      }) || [];
    },
    splitLineThreeFields() {
      return this.currentCountryCodeFields.find(field => {
        return field.includes('complemento') && field.includes('neighborhood');
      }) || [];
    },
    form() {
      return this.address;
    },
    hiddenFieldsHadInitialData() {
      return this.singleAddressHiddenFields.some(field => this.initialAddress?.[field]);
    },
    isSingleAddressLineEnabled() {
      return this.isAutocompleteEnabled && !this.hiddenFieldsHadInitialData;
    },
    includeNameField() {
      return this.enableNameField || this.hasNameData;
    },
    languageCode() {
      return this.$i18nData.getLocaleParts(this.$i18n.locale).languageCode;
    }
  },
  watch: {
    enableAutocomplete(value) {
      this.isAutocompleteEnabled = value;
      this.remountAutocomplete();
      if (value) {
        this.initializeGoogleAutocomplete();
      }
    }
  },
  created() {
    document.addEventListener('click', this.handleClick);
    document.addEventListener('focusin', this.handleFocusIn);
    this.$root.$on('autocompleteApiError', this.handleAutocompleteApiError);
  },
  async mounted() {
    await this.$validator.reset();
    await this.validate();
    if (this.isAutocompleteEnabled) {
      await this.initializeGoogleAutocomplete();
    }
  },
  beforeDestroy() {
    document.removeEventListener('click', this.handleClick);
    document.removeEventListener('focusin', this.handleFocusIn);
    this.$root.$off('autocompleteApiError', this.handleAutocompleteApiError);
    if (typeof this.addressAutocomplete.removeListener === 'function') {
      this.addressAutocomplete.removeListener('place_changed', this.handleAddressSelect);
    }
  },
  methods: {
    async updateCountryCode(countryCode) {
      if (!countryCode) return;

      // istanbul ignore else
      if (window.nds) {
        window.nds.clear();
      }
      this.userCountryCode = countryCode;
      if (typeof this.addressAutocomplete.setComponentRestrictions === 'function') {
        this.addressAutocomplete.setComponentRestrictions({
          country: countryCode
        });
      }
      this.form.state = '';
      this.normalizeAddressFields(this.form);

      /**
       * Input event triggered from country dropdown
       *
       * @event input
       * @type {Object}
       */
      this.$emit('input', this.form);
      await this.$validator.reset();
      await this.validate();

      // istanbul ignore else
      if (window.nds) {
        window.nds.bindNewFields();
      }
    },
    input() {
      /**
       * @event input
       * @type {Object}
       */
      this.$emit('input', this.form);
    },
    expandRows() {
      this.rowsExpanded = true;
    },
    blur() {
      /**
       * Clean up that removes all fields with empty strings before emitting input event.
       * Address service fails validation when sending optional fields that are empty like
       * line2, line3, etc fields
       *
       * @event blur
       * @type {Object}
       */
      this.$emit('input', sanitize$1(this.form));
    },
    async initializeGoogleAutocomplete() {
      try {
        const googlePlacesAPI = await initializeAutocomplete(this, {
          languageCode: this.languageCode
        });
        if (!googlePlacesAPI) {
          throw new Error('Missing API key');
        }
        const options = {
          componentRestrictions: {
            country: this.form.countryCode || this.defaultCountryRestrict
          }
        };
        this.addressAutocomplete = new googlePlacesAPI.Autocomplete(document.getElementById(this.line1Name), options);
        // To ensure getting address focused data only, also to minimize billing cost
        this.addressAutocomplete.setFields(['address_component']);
        // this event is triggered when a suggested address is selected
        this.addressAutocomplete.addListener('place_changed', this.handleAddressSelect);
      } catch (err) {
        /* eslint-disable no-console */
        console.error('Error initializing Google Places API:', err);
        /* eslint-enable no-console */
      }
    },

    async handleAddressSelect() {
      this.expandRows();

      // Get the place details for the selected address option
      const place = this.addressAutocomplete.getPlace();
      const newAddress = getAddressFromPlace(place);
      this.normalizeAddressFields(newAddress);
      if (this.includeNameField) {
        newAddress.firstName = this.form.firstName;
        newAddress.lastName = this.form.lastName;
      }
      await this.fillForm(newAddress);
    },
    async fillForm(address) {
      this.userCountryCode = address.countryCode;
      this.$emit('input', address);
      this.$emit('autocomplete-selection', address);
      await this.$validator.reset();
      await this.validate();
    },
    async validate() {
      const isValid = await this.$validator.validateAll();
      if (!isValid) {
        this.$emit('error', {
          field: this.name,
          msg: 'error.address'
        });
      }
    },
    /**
     * If user clicks into line 1, then blurs, falling back to default input due to API error shouldn't focus the input
     *
     * The if-statements in this function are separated as a small optimization
     * so that the node.contains line doesn't get computed when it doesn't need to
     */
    handleClick(event) {
      if (this.line1Focused) {
        const clickedOutsideLine1 = !document.getElementById(this.line1Name).contains(event.target);
        if (clickedOutsideLine1) {
          this.line1Focused = false;
        }
      }
    },
    handleFocusIn(e) {
      if (e?.target) {
        this.line1Focused = e?.target?.id === this.line1Name;
      }
    },
    // On Google API error during runtime, fallback to default input behavior (i.e. still use al-autocomplete-input but without API initialization)
    handleAutocompleteApiError() {
      this.expandRows();
      this.remountAutocomplete();
    },
    async remountAutocomplete() {
      // re-mounts the AlAutocompleteInput component to reset its state
      // to before the Google Map API initialization
      this.alAutocompleteInputKey++;
      await this.$nextTick();

      // a side effect of the API error is it appends a disabled attribute to the input
      // focus on the input again if the user had previously been focused on it
      if (this.line1Focused) {
        document.getElementById(this.line1Name).focus();
      }
    },
    /**
     * In-place normalization to remove address fields from a given object if it's disabled in addressConfig
     *
     * This prevents bind 400 errors which was caused by sending disabled field data
     *
     * @param {Object} address - address to normalize
     * @returns {Object} in-place normalized address object
     */
    normalizeAddressFields(address) {
      const fieldMap = {
        line1: 'line1',
        line2: 'line2',
        line3: 'line3',
        cityTown: 'city',
        subdivision: 'state',
        postalCode: 'zip'
      };
      for (const configField in fieldMap) {
        const {
          enabled
        } = this.addressConfig?.[configField] || {};
        const addressField = fieldMap[configField];
        if (!enabled && Object.prototype.hasOwnProperty.call(address, addressField)) {
          delete address[addressField];
        }
      }
    }
  }
};

/* script */
const __vue_script__$8 = script$8;

/* template */
var __vue_render__$8 = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("div", {
    class: {
      "rows-expanded": _vm.rowsExpanded
    },
    attrs: {
      "data-test": _vm.name
    }
  }, [_vm._l(_vm.filteredCountryCodeFields, function (field) {
    return [field === "name" ? _c("div", {
      key: field
    }, [_c("name", {
      attrs: {
        "address-config": _vm.addressConfig,
        "enable-name-field": _vm.includeNameField,
        autocomplete: _vm.autocomplete,
        name: _vm.name,
        address: _vm.form,
        "optional-form": _vm.optionalForm
      },
      on: {
        input: _vm.input,
        blur: _vm.blur
      }
    })], 1) : field === "country" ? _c("div", {
      key: field
    }, [_c("country", {
      attrs: {
        countries: _vm.filteredCountries,
        name: _vm.name,
        address: _vm.form,
        "optional-form": _vm.optionalForm
      },
      on: {
        input: _vm.input,
        blur: _vm.blur,
        "update-country-code": _vm.updateCountryCode
      }
    })], 1) : field === "lineFields" ? _c("div", {
      key: field
    }, [_c("line-fields", {
      attrs: {
        "address-config": _vm.addressConfig,
        "al-autocomplete-input-key": _vm.alAutocompleteInputKey,
        autocomplete: _vm.autocomplete,
        "enable-autocomplete": _vm.isAutocompleteEnabled,
        "enable-single-address-line": _vm.isSingleAddressLineEnabled,
        "line1-name": _vm.line1Name,
        name: _vm.name,
        address: _vm.form,
        "optional-form": _vm.optionalForm,
        "separate-line-one-fields": _vm.splitLineOneFields,
        "separate-line-three-fields": _vm.splitLineThreeFields
      },
      on: {
        input: _vm.input,
        blur: _vm.blur,
        "autocomplete-input-blur": _vm.expandRows
      }
    })], 1) : Array.isArray(field) ? _c("div", {
      key: field.join("-"),
      staticClass: "row",
      class: {
        "row-expandable": _vm.isSingleAddressLineEnabled
      }
    }, _vm._l(field, function (currentField) {
      return _c("" + currentField, {
        key: currentField,
        tag: "component",
        attrs: {
          "address-config": _vm.addressConfig,
          "enable-name-field": _vm.includeNameField,
          autocomplete: _vm.autocomplete,
          countries: _vm.countries,
          name: _vm.name,
          address: _vm.form,
          "optional-form": _vm.optionalForm
        },
        on: {
          input: _vm.input,
          blur: _vm.blur
        }
      });
    }), 1) : _c("div", {
      key: field,
      staticClass: "row",
      class: {
        "row-expandable": _vm.isSingleAddressLineEnabled
      }
    }, [_c("" + field, {
      tag: "component",
      attrs: {
        "enable-name-field": _vm.includeNameField,
        "address-config": _vm.addressConfig,
        autocomplete: _vm.autocomplete,
        countries: _vm.countries,
        name: _vm.name,
        address: _vm.form,
        "optional-form": _vm.optionalForm
      },
      on: {
        input: _vm.input,
        blur: _vm.blur
      }
    })], 1)];
  })], 2);
};
var __vue_staticRenderFns__$8 = [];
__vue_render__$8._withStripped = true;

/* style */
const __vue_inject_styles__$8 = function (inject) {
  if (!inject) return;
  inject("data-v-f001188e_0", {
    source: "\n.row-expandable {\n  display: none;\n  overflow: hidden;\n\n  transition: max-height 0.3s ease-in, opacity 0.3s ease-out;\n  max-height: 0;\n  opacity: 0;\n}\n.rows-expanded .row-expandable {\n  display: flex;\n  max-height: 12.5rem;\n  opacity: 1;\n}\n",
    map: {
      "version": 3,
      "sources": ["/vol_01/sys_apps_01/jenkins/workspace/Alberta_BERT_tuxedo_master/src/components/addressForm/TuxAddressForm.vue"],
      "names": [],
      "mappings": ";AAudA;EACA,aAAA;EACA,gBAAA;;EAEA,0DAAA;EACA,aAAA;EACA,UAAA;AACA;AAEA;EACA,aAAA;EACA,mBAAA;EACA,UAAA;AACA",
      "file": "TuxAddressForm.vue",
      "sourcesContent": ["<template>\n  <div :data-test=\"name\" :class=\"{ 'rows-expanded': rowsExpanded }\">\n    <template v-for=\"field in filteredCountryCodeFields\">\n      <!--\n        standalone components that are not expected to dynamically\n        place side by side are imported below. They have their own\n        wrapper with col and row classes -->\n\n      <div v-if=\"field === 'name'\" :key=\"field\">\n        <name\n          :address-config=\"addressConfig\"\n          :enable-name-field=\"includeNameField\"\n          :autocomplete=\"autocomplete\"\n          :name=\"name\"\n          :address=\"form\"\n          :optional-form=\"optionalForm\"\n          @input=\"input\"\n          @blur=\"blur\" />\n      </div>\n\n      <div v-else-if=\"field === 'country'\" :key=\"field\">\n        <country\n          :countries=\"filteredCountries\"\n          :name=\"name\"\n          :address=\"form\"\n          :optional-form=\"optionalForm\"\n          @input=\"input\"\n          @blur=\"blur\"\n          @update-country-code=\"updateCountryCode\" />\n      </div>\n\n      <div v-else-if=\"field === 'lineFields'\" :key=\"field\">\n        <line-fields\n          :address-config=\"addressConfig\"\n          :al-autocomplete-input-key=\"alAutocompleteInputKey\"\n          :autocomplete=\"autocomplete\"\n          :enable-autocomplete=\"isAutocompleteEnabled\"\n          :enable-single-address-line=\"isSingleAddressLineEnabled\"\n          :line1-name=\"line1Name\"\n          :name=\"name\"\n          :address=\"form\"\n          :optional-form=\"optionalForm\"\n          :separate-line-one-fields=\"splitLineOneFields\"\n          :separate-line-three-fields=\"splitLineThreeFields\"\n          @input=\"input\"\n          @blur=\"blur\"\n          @autocomplete-input-blur=\"expandRows\" />\n      </div>\n\n      <!--\n        The rest of the form fields below like state, city and zip have the flexibility\n        to placed next to one another. This is driven by the sorting config\n\n        Below template will place fields on the same row -->\n      <div\n        v-else-if=\"Array.isArray(field)\"\n        :key=\"field.join('-')\"\n        :class=\"{ 'row-expandable': isSingleAddressLineEnabled }\"\n        class=\"row\">\n        <component\n          :is=\"`${currentField}`\"\n          v-for=\"currentField in field\"\n          :key=\"currentField\"\n          :address-config=\"addressConfig\"\n          :enable-name-field=\"includeNameField\"\n          :autocomplete=\"autocomplete\"\n          :countries=\"countries\"\n          :name=\"name\"\n          :address=\"form\"\n          :optional-form=\"optionalForm\"\n          @input=\"input\"\n          @blur=\"blur\" />\n      </div>\n\n      <!--\n        Below will just simply place remaining fields on its own row\n      -->\n      <div\n        v-else\n        :key=\"field\"\n        :class=\"{ 'row-expandable': isSingleAddressLineEnabled }\"\n        class=\"row\">\n        <component\n          :is=\"`${field}`\"\n          :enable-name-field=\"includeNameField\"\n          :address-config=\"addressConfig\"\n          :autocomplete=\"autocomplete\"\n          :countries=\"countries\"\n          :name=\"name\"\n          :address=\"form\"\n          :optional-form=\"optionalForm\"\n          @input=\"input\"\n          @blur=\"blur\" />\n      </div>\n    </template>\n  </div>\n</template>\n\n<script>\nimport { getAddressFromPlace, initializeAutocomplete } from '@/utils/googleAutocomplete'\nimport sanitize from '@/utils/sanitize'\n\nimport city from './parts/CityField'\nimport country from './parts/CountryCodeField'\nimport lineFields from './parts/LineFields'\nimport name from './parts/NameField'\nimport state from './parts/StateField'\nimport zip from './parts/ZipField'\n\nexport const singleAddressHiddenFields = ['line1', 'line2', 'line3', 'city', 'state', 'zip']\n\nexport default {\n  name: 'TuxAddressForm',\n  components: {\n    name,\n    country,\n    lineFields,\n    city,\n    state,\n    zip\n  },\n  inject: ['$validator'],\n  model: {\n    prop: 'address',\n    event: 'input'\n  },\n  props: {\n    address: {\n      type: Object,\n      default: null\n    },\n    name: {\n      type: String,\n      required: true\n    },\n    countries: {\n      type: Array,\n      required: true\n    },\n    postalCodeOnly: {\n      type: Boolean,\n      default: false\n    },\n    nameOnly: {\n      type: Boolean,\n      default: false\n    },\n    enableNameField: {\n      type: Boolean,\n      default: true\n    },\n    autocomplete: {\n      type: String,\n      default: ''\n    },\n    enableAutocomplete: {\n      type: Boolean,\n      default: false\n    },\n    optionalForm: {\n      type: Boolean,\n      default: false\n    }\n  },\n  data() {\n    return {\n      userCountryCode: this.address.countryCode,\n      addressAutocomplete: {},\n      defaultCountryRestrict: 'US',\n      line1Focused: false,\n      line1Name: `${this.name}-line1`,\n      alAutocompleteInputKey: 0,\n      rowsExpanded: false,\n      isAutocompleteEnabled: this.enableAutocomplete && !this.postalCodeOnly,\n      initialAddress: JSON.parse(JSON.stringify(this.address)),\n      singleAddressHiddenFields,\n      hasNameData: !!(this.address.firstName || this.address.lastName)\n    }\n  },\n  computed: {\n    countryConfig() {\n      return this.$i18nData.getCountryConfig(this.userCountryCode, false) || {}\n    },\n    addressConfig() {\n      return this.countryConfig.address || {}\n    },\n    currentCountryCodeFields() {\n      if (this.postalCodeOnly) {\n        const fields = ['country', 'zip']\n\n        return this.includeNameField ? ['name'].concat(fields) : fields\n      }\n\n      if (this.nameOnly) {\n        return ['name']\n      }\n\n      const defaultSortOrder = ['name', 'country', 'lineFields', 'city', ['state', 'zip']]\n      return this.countryConfig.addressFieldsSortOrder || defaultSortOrder\n    },\n    filteredCountryCodeFields() {\n      return this.currentCountryCodeFields.filter((field) => {\n        return (\n          JSON.stringify(field) !== JSON.stringify(this.splitLineOneFields) &&\n          JSON.stringify(field) !== JSON.stringify(this.splitLineThreeFields)\n        )\n      })\n    },\n    filteredCountries() {\n      return this.countries.filter((country) => !this.$i18nData.isCountryRestricted(country.value))\n    },\n    splitLineOneFields() {\n      return (\n        this.currentCountryCodeFields.find((field) => {\n          return field.includes('streetName') && field.includes('streetNumber')\n        }) || []\n      )\n    },\n    splitLineThreeFields() {\n      return (\n        this.currentCountryCodeFields.find((field) => {\n          return field.includes('complemento') && field.includes('neighborhood')\n        }) || []\n      )\n    },\n    form() {\n      return this.address\n    },\n    hiddenFieldsHadInitialData() {\n      return this.singleAddressHiddenFields.some((field) => this.initialAddress?.[field])\n    },\n    isSingleAddressLineEnabled() {\n      return this.isAutocompleteEnabled && !this.hiddenFieldsHadInitialData\n    },\n    includeNameField() {\n      return this.enableNameField || this.hasNameData\n    },\n    languageCode() {\n      return this.$i18nData.getLocaleParts(this.$i18n.locale).languageCode\n    }\n  },\n\n  watch: {\n    enableAutocomplete(value) {\n      this.isAutocompleteEnabled = value\n      this.remountAutocomplete()\n\n      if (value) {\n        this.initializeGoogleAutocomplete()\n      }\n    }\n  },\n\n  created() {\n    document.addEventListener('click', this.handleClick)\n    document.addEventListener('focusin', this.handleFocusIn)\n    this.$root.$on('autocompleteApiError', this.handleAutocompleteApiError)\n  },\n\n  async mounted() {\n    await this.$validator.reset()\n    await this.validate()\n\n    if (this.isAutocompleteEnabled) {\n      await this.initializeGoogleAutocomplete()\n    }\n  },\n\n  beforeDestroy() {\n    document.removeEventListener('click', this.handleClick)\n    document.removeEventListener('focusin', this.handleFocusIn)\n    this.$root.$off('autocompleteApiError', this.handleAutocompleteApiError)\n    if (typeof this.addressAutocomplete.removeListener === 'function') {\n      this.addressAutocomplete.removeListener('place_changed', this.handleAddressSelect)\n    }\n  },\n\n  methods: {\n    async updateCountryCode(countryCode) {\n      if (!countryCode) return\n\n      // istanbul ignore else\n      if (window.nds) {\n        window.nds.clear()\n      }\n\n      this.userCountryCode = countryCode\n\n      if (typeof this.addressAutocomplete.setComponentRestrictions === 'function') {\n        this.addressAutocomplete.setComponentRestrictions({ country: countryCode })\n      }\n\n      this.form.state = ''\n      this.normalizeAddressFields(this.form)\n\n      /**\n       * Input event triggered from country dropdown\n       *\n       * @event input\n       * @type {Object}\n       */\n      this.$emit('input', this.form)\n\n      await this.$validator.reset()\n      await this.validate()\n\n      // istanbul ignore else\n      if (window.nds) {\n        window.nds.bindNewFields()\n      }\n    },\n\n    input() {\n      /**\n       * @event input\n       * @type {Object}\n       */\n      this.$emit('input', this.form)\n    },\n\n    expandRows() {\n      this.rowsExpanded = true\n    },\n\n    blur() {\n      /**\n       * Clean up that removes all fields with empty strings before emitting input event.\n       * Address service fails validation when sending optional fields that are empty like\n       * line2, line3, etc fields\n       *\n       * @event blur\n       * @type {Object}\n       */\n      this.$emit('input', sanitize(this.form))\n    },\n\n    async initializeGoogleAutocomplete() {\n      try {\n        const googlePlacesAPI = await initializeAutocomplete(this, {\n          languageCode: this.languageCode\n        })\n        if (!googlePlacesAPI) {\n          throw new Error('Missing API key')\n        }\n\n        const options = {\n          componentRestrictions: { country: this.form.countryCode || this.defaultCountryRestrict }\n        }\n        this.addressAutocomplete = new googlePlacesAPI.Autocomplete(\n          document.getElementById(this.line1Name),\n          options\n        )\n        // To ensure getting address focused data only, also to minimize billing cost\n        this.addressAutocomplete.setFields(['address_component'])\n        // this event is triggered when a suggested address is selected\n        this.addressAutocomplete.addListener('place_changed', this.handleAddressSelect)\n      } catch (err) {\n        /* eslint-disable no-console */\n        console.error('Error initializing Google Places API:', err)\n        /* eslint-enable no-console */\n      }\n    },\n\n    async handleAddressSelect() {\n      this.expandRows()\n\n      // Get the place details for the selected address option\n      const place = this.addressAutocomplete.getPlace()\n      const newAddress = getAddressFromPlace(place)\n      this.normalizeAddressFields(newAddress)\n\n      if (this.includeNameField) {\n        newAddress.firstName = this.form.firstName\n        newAddress.lastName = this.form.lastName\n      }\n      await this.fillForm(newAddress)\n    },\n\n    async fillForm(address) {\n      this.userCountryCode = address.countryCode\n      this.$emit('input', address)\n      this.$emit('autocomplete-selection', address)\n\n      await this.$validator.reset()\n      await this.validate()\n    },\n\n    async validate() {\n      const isValid = await this.$validator.validateAll()\n      if (!isValid) {\n        this.$emit('error', {\n          field: this.name,\n          msg: 'error.address'\n        })\n      }\n    },\n\n    /**\n     * If user clicks into line 1, then blurs, falling back to default input due to API error shouldn't focus the input\n     *\n     * The if-statements in this function are separated as a small optimization\n     * so that the node.contains line doesn't get computed when it doesn't need to\n     */\n    handleClick(event) {\n      if (this.line1Focused) {\n        const clickedOutsideLine1 = !document.getElementById(this.line1Name).contains(event.target)\n\n        if (clickedOutsideLine1) {\n          this.line1Focused = false\n        }\n      }\n    },\n\n    handleFocusIn(e) {\n      if (e?.target) {\n        this.line1Focused = e?.target?.id === this.line1Name\n      }\n    },\n\n    // On Google API error during runtime, fallback to default input behavior (i.e. still use al-autocomplete-input but without API initialization)\n    handleAutocompleteApiError() {\n      this.expandRows()\n      this.remountAutocomplete()\n    },\n\n    async remountAutocomplete() {\n      // re-mounts the AlAutocompleteInput component to reset its state\n      // to before the Google Map API initialization\n      this.alAutocompleteInputKey++\n\n      await this.$nextTick()\n\n      // a side effect of the API error is it appends a disabled attribute to the input\n      // focus on the input again if the user had previously been focused on it\n      if (this.line1Focused) {\n        document.getElementById(this.line1Name).focus()\n      }\n    },\n\n    /**\n     * In-place normalization to remove address fields from a given object if it's disabled in addressConfig\n     *\n     * This prevents bind 400 errors which was caused by sending disabled field data\n     *\n     * @param {Object} address - address to normalize\n     * @returns {Object} in-place normalized address object\n     */\n    normalizeAddressFields(address) {\n      const fieldMap = {\n        line1: 'line1',\n        line2: 'line2',\n        line3: 'line3',\n        cityTown: 'city',\n        subdivision: 'state',\n        postalCode: 'zip'\n      }\n\n      for (const configField in fieldMap) {\n        const { enabled } = this.addressConfig?.[configField] || {}\n        const addressField = fieldMap[configField]\n\n        if (!enabled && Object.prototype.hasOwnProperty.call(address, addressField)) {\n          delete address[addressField]\n        }\n      }\n    }\n  }\n}\n</script>\n\n<style>\n.row-expandable {\n  display: none;\n  overflow: hidden;\n\n  transition: max-height 0.3s ease-in, opacity 0.3s ease-out;\n  max-height: 0;\n  opacity: 0;\n}\n\n.rows-expanded .row-expandable {\n  display: flex;\n  max-height: 12.5rem;\n  opacity: 1;\n}\n</style>\n"]
    },
    media: undefined
  });
};
/* scoped */
const __vue_scope_id__$8 = undefined;
/* module identifier */
const __vue_module_identifier__$8 = undefined;
/* functional template */
const __vue_is_functional_template__$8 = false;
/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$f = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$8,
  staticRenderFns: __vue_staticRenderFns__$8
}, __vue_inject_styles__$8, __vue_script__$8, __vue_scope_id__$8, __vue_is_functional_template__$8, __vue_module_identifier__$8, false, createInjector, undefined, undefined);
var TuxAddressForm = __vue_component__$f;

/**
 * Format mobile number using country specific masking rules
 */
function formatMobileNumber(phone, consumerCountryCode) {
  const {
    countryCode: callingCode,
    phoneNumber
  } = phone;
  const mask = i18nData.getPhoneMaskingRule(callingCode, consumerCountryCode);
  return `+${callingCode} ${filter(phoneNumber, mask)}`;
}

//
var script$7 = {
  name: 'TuxProvisionCreate',
  components: {
    AlCardPreview,
    AlCheckbox,
    AlContactInput,
    AlInput,
    AlNotify,
    TuxAddressForm,
    TuxAddressLabel,
    TuxFraudProtection,
    TuxGoogleConsent,
    TuxTermsConsent
  },
  inject: ['$validator'],
  model: {
    prop: 'formData',
    event: 'input'
  },
  props: {
    /**
     * Main data prop that will be used with v-model in the parent component.
     */
    formData: {
      type: Object,
      default: null
    },
    /**
     * Whether or not to allow a partner banner at the top of the page
     */
    allowPartnerBanner: {
      type: Boolean,
      default: false
    },
    /**
     * Data object for displaying card preview. Card must be in Mastercard (not Emvco) spec.
     */
    card: {
      type: Object,
      required: true
    },
    /**
     * List of countries to select in address drop-down menu
     */
    countries: {
      type: Array,
      required: true
    },
    /**
     * Locale country
     */
    countryCode: {
      type: String,
      required: true
    },
    /**
     * Whether or not billingAddress can be edited
     */
    editableBillingAddress: {
      type: Boolean,
      default: false
    },
    /**
     * Whether or not consumer info can be edited
     */
    editableConsumerInfo: {
      type: Boolean,
      default: false
    },
    /**
     * Whether or not address autocomplete should be enabled
     */
    enableAutocomplete: {
      type: Boolean,
      default: false
    },
    /**
     * Whether or not user exists already.
     *
     * If existingUser is false = show everything
     * If existingUser is true = don't show things like marketing opt in, remember me, etc. as user was already given these options
     */
    existingUser: {
      type: Boolean,
      default: false
    },
    /**
     * Force display an error, useful for server side errors. "*This will overwrite all other client side validation and errors.*". It is the consumer's responsibility to clear out this error message.
     */
    manualError: {
      type: String,
      default: null
    },
    /**
     * Error message if there is a national id validation error
     */
    nationalIdError: {
      type: String,
      default: null
    },
    /**
     * Privacy Notice Url
     */
    privacyUrl: {
      type: String,
      required: true
    },
    /**
     * Google Privacy Notice Url
     */
    googlePrivacyUrl: {
      type: String,
      default: null
    },
    /**
     * Google Terms and Conditions Url
     */
    googleTermsUrl: {
      type: String,
      default: null
    },
    /**
     * Whether or not to show Marketing Opt In checkbox
     */
    showMarketingOptIn: {
      type: Boolean,
      default: false
    },
    /**
     * Whether or not to show Remember Me checkbox
     */
    showRememberMe: {
      type: Boolean,
      default: false
    },
    /**
     * Force billing address to be displayed even if the billing address preference is `NONE`
     */
    forceDisplayBilling: {
      type: Boolean,
      default: false
    },
    /**
     * Terms & Conditions Url
     */
    termsUrl: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      buttonText: 'provisionCreate.primaryCTA',
      countryOptions: this.$i18nData.getPhonesConfig(),
      editBillingClicked: false,
      isContactEditing: false,
      form: {
        billingAddress: {},
        marketingOptIn: false,
        nationalId: '',
        phoneNumber: {
          country: '',
          countryCode: '',
          phoneNumber: ''
        },
        rememberMe: false,
        saveAsShipping: false,
        shippingAddress: {},
        userId: ''
      },
      initialBillingAddress: this.formData?.billingAddress || {},
      initialUserId: this.formData?.userId || '',
      initialPhoneNumber: this.formData?.phoneNumber || '',
      isAutocompleteApiEnabled: false,
      showShippingCheckBox: true,
      isInitialBillingDataIncomplete: true,
      isPiiDataProvided: false,
      transformedAddress: {},
      // assign a key to the terms consent component to force re-render on key change
      termsConsentKey: 0
    };
  },
  computed: {
    addressConfig() {
      return this.$i18nData.getCountryConfig(this.initialBillingAddress.countryCode, false)?.address;
    },
    heading() {
      return this.existingUser ? 'provisionCreate.reviewHeading' : 'provisionCreate.heading';
    },
    cardBrand() {
      const {
        shortProductDescription,
        issuerName,
        paymentNetworkName
      } = this.card;
      return shortProductDescription || issuerName || paymentNetworkName;
    },
    cardImg() {
      return this.card?.artUrl || this.card?.cardArtUrl;
    },
    cardCountryConfig() {
      return this.$i18nData.getCountryConfig(this.card?.countryCode);
    },
    formattedMobileNumber() {
      return formatMobileNumber(this.initialPhoneNumber, this.countryCode);
    },
    addressFormat() {
      return this.cardCountryConfig?.billingAddressFormat === constants.ADDRESS_FORMAT.FULL ? constants.ADDRESS_FORMAT.FULL : constants.ADDRESS_FORMAT.NONE;
    },
    isAutocompleteEnabled() {
      return this.enableAutocomplete && this.isAutocompleteApiEnabled;
    },
    isEditingBilling() {
      const isEditingByChoice = this.editableBillingAddress && this.editBillingClicked;
      const displayAddressForm = !this.initialBillingAddress?.name && !this.isNoneView;
      return isEditingByChoice || displayAddressForm;
    },
    isFullView() {
      return this.addressFormat === constants.ADDRESS_FORMAT.FULL;
    },
    isRestrictedCountry() {
      return this.$i18nData.isCountryRestricted(this.countryCode);
    },
    isNoneView() {
      return this.addressFormat === constants.ADDRESS_FORMAT.NONE || this.isRestrictedCountry;
    },
    nationalIdConfig() {
      const {
        consumer
      } = this.$i18nData.getCountryConfig(this.countryCode) || {};
      return consumer?.nationalId;
    },
    nationalIdValidationRules() {
      let validationRules;
      if (this.nationalIdConfig) {
        const {
          required,
          minimumLength: min,
          maximumLength: max
        } = this.nationalIdConfig;
        validationRules = {
          required,
          min,
          max,
          national_id: true
        };
      }
      return validationRules;
    },
    partnerName() {
      const {
        issuerName,
        shortProductDescription,
        paymentNetworkName
      } = this.card;
      return issuerName || shortProductDescription || paymentNetworkName;
    },
    showCardPreview() {
      return this.card && Object.keys(this.card).length > 0;
    },
    showEditBillingButton() {
      if (this.isNoneView) {
        return;
      }
      return this.editableBillingAddress && !this.showBillingAddressForm;
    },
    isContactSectionReadOnly() {
      return this.editableConsumerInfo && this.initialUserId && this.initialPhoneNumber.phoneNumber && !this.isContactEditing;
    },
    showHeadingPadding() {
      return !this.manualError && this.showPartnerBanner;
    },
    showBillingAddressSection() {
      return this.forceDisplayBilling ? !this.isRestrictedCountry && this.isAddressValid : !this.isNoneView;
    },
    showBillingAddressForm() {
      return !this.forceDisplayBilling && (this.isEditingBilling || this.isInitialBillingDataIncomplete);
    },
    showFirstLastNameField() {
      if (!this.showBillingAddressSection) {
        return this.isNoneView;
      }
      const hasFullName = this.initialBillingAddress.firstName && this.initialBillingAddress.lastName || this.initialBillingAddress.name;
      return !hasFullName;
    },
    showPartnerBanner() {
      return this.allowPartnerBanner && this.partnerName;
    },
    showToolTip() {
      return !this.isInitialBillingDataIncomplete && !this.editableBillingAddress;
    },
    disableContinueButton() {
      const validationError = this.hasValidationErrors !== undefined ? this.hasValidationErrors : this.errors?.any();
      return validationError || Boolean(this.manualError) || Boolean(this.nationalIdError);
    },
    requiredFields() {
      return Object.keys(this.addressConfig).filter(field => Boolean(this.addressConfig[field].required));
    },
    isAddressValid() {
      return this.requiredFields.every(field => Boolean(this.transformedAddress[field]));
    },
    showShippingAddressForm() {
      return !this.form.saveAsShipping;
    },
    isConsumerDataPresent() {
      return !!(this.initialUserId || this.initialPhoneNumber.phoneNumber);
    }
  },
  watch: {
    countryCode: {
      immediate: true,
      handler() {
        this.isAutocompleteApiEnabled = this.$i18nData.isCountryFeatureEnabled(constants.COUNTRY_FEATURES.ENABLE_ADDRESS_AUTOCOMPLETE, this.$i18n.locale);
        this.termsConsentKey++;
      }
    },
    'form.saveAsShipping': {
      immediate: true,
      handler(newValue) {
        if (newValue) {
          this.form.shippingAddress = {
            countryCode: this.countryCode
          };
        } else {
          this.form.shippingAddress.countryCode = this.countryCode;
        }
      }
    }
  },
  created() {
    this.form = merge({}, this.form, this.formData);
    this.transformedAddress = transformEmvcoToMastercard(this.initialBillingAddress);
    this.isPiiDataProvided = this.checkIsPiiDataProvided();
    this.isInitialBillingDataIncomplete = this.checkIsBillingDataIncomplete();
  },
  mounted() {
    this.$validator.validateAll();
  },
  methods: {
    handleAutocompleteSelected(event) {
      this.$emit('autocomplete-selected', event);
    },
    handleEditBilling(event) {
      this.editBillingClicked = true;
      this.form.billingAddress = splitAddressNames(this.form.billingAddress);
      this.$emit('edit-billing-address', event);
    },
    handleMarketingOptIn(event) {
      this.input();
      this.$emit('marketing-opt-in', event);
    },
    handlePrivacyClick(event) {
      this.$emit('privacy-click', event);
    },
    handleRememberMe(event) {
      this.input();
      this.$emit('remember-me', event);
    },
    handleSaveAsShipping(event) {
      this.input();
      this.$emit('save-as-shipping', event);
    },
    handleSubmit(event) {
      this.$emit('format', this.addressFormat);
      this.$emit('submit', event);
    },
    handleTermsClick(event) {
      this.$emit('terms-click', event);
    },
    input() {
      /**
       * @event input
       * @type {Object}
       */
      this.$emit('input', this.form);
    },
    checkIsBillingDataIncomplete() {
      if (this.isFullView) {
        return this.handleFullView();
      } else {
        return this.handleNoneView();
      }
    },
    handleFullView() {
      if (!this.isAddressValid) {
        this.form.billingAddress = splitAddressNames(this.form.billingAddress);
        return true;
      }
      return false;
    },
    handleNoneView() {
      if (!this.isAddressValid) this.showShippingCheckBox = false;
      this.form.billingAddress = splitAddressNames(this.form.billingAddress);
      return false;
    },
    checkIsPiiDataProvided() {
      return this.requiredFields.some(field => Boolean(this.transformedAddress[field])) || this.isConsumerDataPresent;
    }
  }
};

/* script */
const __vue_script__$7 = script$7;

/* template */
var __vue_render__$7 = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("div", {
    staticClass: "container"
  }, [_vm.manualError ? _c("al-notify", {
    staticClass: "padding-top-sm",
    attrs: {
      error: "",
      name: "avs-error"
    }
  }, [_vm._v("\n    " + _vm._s(_vm.$t(_vm.manualError)) + "\n  ")]) : _vm.showPartnerBanner ? _c("div", {
    staticClass: "row-banner",
    attrs: {
      "data-test": "partner-banner"
    }
  }, [_c("div", {
    staticClass: "col-full"
  }, [_c("p", {
    staticClass: "info"
  }, [_c("i", {
    staticClass: "icon-info-inverse icon-size-xs"
  }), _vm._v("\n        " + _vm._s(_vm.$t("provisionCreate.bannerInfo", {
    partnerName: _vm.partnerName
  })) + "\n      ")])])]) : _vm._e(), _vm._v(" "), _c("form", {
    staticClass: "container",
    attrs: {
      novalidate: ""
    },
    on: {
      submit: function ($event) {
        $event.preventDefault();
      }
    }
  }, [_c("div", {
    class: ["row", {
      "padding-top-sm": _vm.showHeadingPadding
    }]
  }, [_c("div", {
    staticClass: "col-full"
  }, [_c("h1", {
    staticClass: "heading-xl"
  }, [_vm._v("\n          " + _vm._s(_vm.$t(_vm.heading)) + "\n        ")])])]), _vm._v(" "), _c("div", {
    class: {
      card: _vm.isPiiDataProvided
    }
  }, [_c("div", {
    staticClass: "card__item"
  }, [_c("div", {
    staticClass: "row"
  }, [_c("div", {
    staticClass: "col-full"
  }, [_vm.showCardPreview ? _c("al-card-preview", {
    attrs: {
      img: _vm.cardImg,
      brand: _vm.cardBrand,
      number: "•••• " + _vm.card.primaryAccountNumberSuffix,
      name: "card-preview"
    }
  }) : _vm._e()], 1)])]), _vm._v(" "), _vm.showBillingAddressSection ? [_c("div", {
    staticClass: "card__item"
  }, [_c("div", {
    staticClass: "row"
  }, [_c("div", {
    class: _vm.showEditBillingButton ? "col-3" : "col"
  }, [_c("h2", {
    staticClass: "heading-md"
  }, [_vm._v("\n                " + _vm._s(_vm.$t("provisionCreate.billingAddressHeading"))), _vm.showToolTip ? _c("i", {
    directives: [{
      name: "tooltip",
      rawName: "v-tooltip",
      value: _vm.$t("provisionCreate.billingAddressTooltip"),
      expression: "$t('provisionCreate.billingAddressTooltip')"
    }],
    staticClass: "provisionCreate__billing-tooltip icon-info icon-size-xs",
    attrs: {
      "data-test": "provisionCreate-billingAddressTooltip",
      "aria-label": _vm.$t("provisionCreate.billingAddressHeading"),
      tabindex: "0"
    }
  }) : _vm._e()])]), _vm._v(" "), _vm.showEditBillingButton ? _c("div", {
    staticClass: "col-1 align-right"
  }, [_c("button", {
    staticClass: "btn--secondary",
    attrs: {
      type: "button",
      "data-test": "edit-billing-btn"
    },
    on: {
      click: _vm.handleEditBilling
    }
  }, [_vm._v("\n                " + _vm._s(_vm.$t("provisionCreate.edit")) + "\n              ")])]) : _vm._e()]), _vm._v(" "), _vm.showBillingAddressForm ? [_vm.isAutocompleteEnabled ? _c("tux-google-consent", {
    attrs: {
      "privacy-url": _vm.googlePrivacyUrl,
      "terms-url": _vm.googleTermsUrl,
      "data-test": "google-consent-billing"
    },
    on: {
      "privacy-click": _vm.handlePrivacyClick,
      "terms-click": _vm.handleTermsClick
    }
  }) : _vm._e(), _vm._v(" "), _c("tux-address-form", {
    attrs: {
      countries: _vm.countries,
      "enable-autocomplete": _vm.isAutocompleteEnabled,
      "enable-name-field": "",
      autocomplete: "billing",
      name: "billing-address"
    },
    on: {
      "autocomplete-selection": _vm.handleAutocompleteSelected,
      input: _vm.input
    },
    model: {
      value: _vm.form.billingAddress,
      callback: function ($$v) {
        _vm.$set(_vm.form, "billingAddress", $$v);
      },
      expression: "form.billingAddress"
    }
  })] : _c("div", {
    staticClass: "row",
    attrs: {
      "data-test": "billing-address-read-only"
    }
  }, [_c("div", {
    staticClass: "col-full"
  }, [_c("tux-address-label", {
    staticClass: "provisionCreate__address-label",
    attrs: {
      address: _vm.form.billingAddress
    }
  })], 1)]), _vm._v(" "), _vm.showShippingCheckBox ? [_c("div", {
    staticClass: "row margin-top-sm"
  }, [_c("div", {
    staticClass: "col-full"
  }, [_c("al-checkbox", {
    attrs: {
      label: _vm.$t("provisionCreate.shippingSameAsBilling"),
      name: "shippingSameAsBilling",
      "data-test": "shipping-same-as-billing"
    },
    on: {
      input: _vm.handleSaveAsShipping
    },
    model: {
      value: _vm.form.saveAsShipping,
      callback: function ($$v) {
        _vm.$set(_vm.form, "saveAsShipping", $$v);
      },
      expression: "form.saveAsShipping"
    }
  })], 1)])] : _vm._e(), _vm._v(" "), _vm.showShippingAddressForm ? [_c("div", {
    staticClass: "row"
  }, [_c("div", {
    staticClass: "col-full"
  }, [_c("h2", {
    staticClass: "heading-md"
  }, [_vm._v("\n                  " + _vm._s(_vm.$t("provisionCreate.shippingAddressHeading")) + "\n                ")])])]), _vm._v(" "), _vm.isAutocompleteEnabled ? _c("tux-google-consent", {
    attrs: {
      "privacy-url": _vm.googlePrivacyUrl,
      "terms-url": _vm.googleTermsUrl,
      "data-test": "google-consent-shipping"
    },
    on: {
      "privacy-click": _vm.handlePrivacyClick,
      "terms-click": _vm.handleTermsClick
    }
  }) : _vm._e(), _vm._v(" "), _c("tux-address-form", {
    attrs: {
      countries: _vm.countries,
      "enable-autocomplete": _vm.isAutocompleteEnabled,
      "enable-name-field": "",
      "optional-form": "",
      autocomplete: "shipping",
      name: "shippingAddress"
    },
    on: {
      "autocomplete-selection": _vm.handleAutocompleteSelected,
      input: _vm.input
    },
    model: {
      value: _vm.form.shippingAddress,
      callback: function ($$v) {
        _vm.$set(_vm.form, "shippingAddress", $$v);
      },
      expression: "form.shippingAddress"
    }
  })] : _vm._e()], 2)] : _vm._e(), _vm._v(" "), _c("div", {
    staticClass: "card__item"
  }, [_c("div", {
    staticClass: "row"
  }, [_c("div", {
    staticClass: "col-3"
  }, [_c("h2", {
    staticClass: "heading-md"
  }, [_vm._v("\n              " + _vm._s(_vm.$t("provisionCreate.contactInformation")) + "\n            ")])]), _vm._v(" "), _vm.isContactSectionReadOnly && !_vm.existingUser ? _c("div", {
    staticClass: "col-1 align-right"
  }, [_c("button", {
    staticClass: "btn--secondary align-right",
    attrs: {
      "aria-label": "edit button",
      "data-test": "btn-edit"
    },
    on: {
      click: function ($event) {
        _vm.isContactEditing = true;
      }
    }
  }, [_vm._v("\n              " + _vm._s(_vm.$t("provisionCreate.edit")) + "\n            ")])]) : _vm._e()]), _vm._v(" "), _vm.isContactSectionReadOnly ? [_c("div", {
    staticClass: "row",
    attrs: {
      "data-test": "contact-read-only"
    }
  }, [_c("div", {
    staticClass: "col-full"
  }, [_c("p", [_c("span", {
    attrs: {
      "data-test": "user-id"
    }
  }, [_vm._v("\n                  " + _vm._s(_vm.initialUserId) + "\n                ")]), _vm._v(" "), _c("br"), _vm._v(" "), _c("span", {
    attrs: {
      "data-test": "phone-number"
    }
  }, [_vm._v("\n                  " + _vm._s(_vm.formattedMobileNumber) + "\n                ")])])])])] : [_vm.showFirstLastNameField ? _c("div", {
    staticClass: "col"
  }, [_c("tux-address-form", {
    attrs: {
      "name-only": "",
      countries: _vm.countries,
      "enable-autocomplete": _vm.isAutocompleteEnabled,
      autocomplete: "name",
      name: "name"
    },
    on: {
      "autocomplete-selection": _vm.handleAutocompleteSelected,
      input: _vm.input
    },
    model: {
      value: _vm.form.billingAddress,
      callback: function ($$v) {
        _vm.$set(_vm.form, "billingAddress", $$v);
      },
      expression: "form.billingAddress"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c("div", {
    staticClass: "row"
  }, [_c("div", {
    staticClass: "col-full"
  }, [_c("al-input", {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: "required|email",
      expression: "'required|email'"
    }],
    attrs: {
      label: _vm.$t("placeholder.email"),
      type: "email",
      name: "userId",
      "data-test": "user-id"
    },
    on: {
      input: _vm.input
    },
    model: {
      value: _vm.form.userId,
      callback: function ($$v) {
        _vm.$set(_vm.form, "userId", $$v);
      },
      expression: "form.userId"
    }
  })], 1)]), _vm._v(" "), _c("div", {
    staticClass: "row"
  }, [_c("div", {
    staticClass: "col-full"
  }, [_c("al-contact-input", {
    attrs: {
      countries: _vm.countryOptions,
      label: _vm.$t("placeholder.mobileNumber"),
      legal: _vm.$t("provisionCreate.mobileHelperText"),
      name: "phoneNumber",
      "data-test": "phone-number"
    },
    on: {
      input: _vm.input
    },
    model: {
      value: _vm.form.phoneNumber,
      callback: function ($$v) {
        _vm.$set(_vm.form, "phoneNumber", $$v);
      },
      expression: "form.phoneNumber"
    }
  })], 1)])], _vm._v(" "), !_vm.existingUser ? [_vm.nationalIdConfig ? _c("div", {
    staticClass: "row"
  }, [_c("div", {
    staticClass: "col-full"
  }, [_c("h2", {
    staticClass: "heading-md"
  }, [_vm._v("\n                " + _vm._s(_vm.$t("provisionCreate.nationalId")) + "\n              ")]), _vm._v(" "), _c("al-input", {
    directives: [{
      name: "validate",
      rawName: "v-validate.immediate",
      value: _vm.nationalIdValidationRules,
      expression: "nationalIdValidationRules",
      modifiers: {
        immediate: true
      }
    }],
    attrs: {
      mask: _vm.nationalIdConfig.mask,
      "manual-error": _vm.$t(_vm.nationalIdError),
      label: _vm.$t("provisionCreate.identificationNumber"),
      name: "nationalId",
      "data-test": "national-id"
    },
    on: {
      input: _vm.input
    },
    model: {
      value: _vm.form.nationalId,
      callback: function ($$v) {
        _vm.$set(_vm.form, "nationalId", $$v);
      },
      expression: "form.nationalId"
    }
  })], 1)]) : _vm._e(), _vm._v(" "), _vm.showRememberMe ? _c("div", {
    staticClass: "row"
  }, [_c("div", {
    staticClass: "col-full"
  }, [_c("h3", [_vm._v("\n                " + _vm._s(_vm.$t("provisionCreate.rememberMeHeading")) + "\n              ")]), _vm._v(" "), _c("al-checkbox", {
    attrs: {
      label: _vm.$t("provisionCreate.rememberMe"),
      subtext: _vm.$t("provisionCreate.rememberMeSubheading"),
      "data-test": "remember-me",
      name: "remember-me"
    },
    on: {
      input: _vm.handleRememberMe
    },
    model: {
      value: _vm.form.rememberMe,
      callback: function ($$v) {
        _vm.$set(_vm.form, "rememberMe", $$v);
      },
      expression: "form.rememberMe"
    }
  })], 1)]) : _vm._e(), _vm._v(" "), _vm.showMarketingOptIn ? _c("div", {
    staticClass: "row"
  }, [_c("div", {
    staticClass: "col-full"
  }, [_c("al-checkbox", {
    attrs: {
      label: _vm.$t("provisionCreate.marketingOptIn"),
      subtext: _vm.$t("provisionCreate.marketingOptInSubheading"),
      name: "marketingOptIn",
      "data-test": "marketing-opt-in"
    },
    on: {
      input: _vm.handleMarketingOptIn
    },
    model: {
      value: _vm.form.marketingOptIn,
      callback: function ($$v) {
        _vm.$set(_vm.form, "marketingOptIn", $$v);
      },
      expression: "form.marketingOptIn"
    }
  })], 1)]) : _vm._e()] : _vm._e()], 2)], 2), _vm._v(" "), !_vm.existingUser ? _c("tux-fraud-protection", {
    attrs: {
      name: "fraud-protection"
    }
  }) : _vm._e(), _vm._v(" "), !_vm.existingUser ? _c("tux-terms-consent", {
    key: _vm.termsConsentKey,
    attrs: {
      "flex-grow": "",
      name: "provision",
      "privacy-url": _vm.privacyUrl,
      "terms-url": _vm.termsUrl
    }
  }) : _vm._e(), _vm._v(" "), _c("div", {
    staticClass: "row row-vertical-align-bottom"
  }, [_c("div", {
    staticClass: "col-full align-center"
  }, [_c("button", {
    staticClass: "uppercase fill",
    attrs: {
      type: "submit",
      disabled: _vm.disableContinueButton,
      "data-test": "form-submit-button",
      "aria-label": _vm.$t(_vm.buttonText)
    },
    on: {
      click: _vm.handleSubmit
    }
  }, [_vm._v("\n          " + _vm._s(_vm.$t(_vm.buttonText)) + "\n        ")])]), _vm._v(" "), _vm.$slots && _vm.$slots["secondary-cta"] ? _c("div", {
    staticClass: "col-full align-center"
  }, [_vm._t("secondary-cta")], 2) : _vm._e()])], 1)], 1);
};
var __vue_staticRenderFns__$7 = [];
__vue_render__$7._withStripped = true;

/* style */
const __vue_inject_styles__$7 = function (inject) {
  if (!inject) return;
  inject("data-v-77c570c4_0", {
    source: "\n.row-vertical-align-bottom[data-v-77c570c4] {\n  flex-grow: 0;\n}\n",
    map: {
      "version": 3,
      "sources": ["/vol_01/sys_apps_01/jenkins/workspace/Alberta_BERT_tuxedo_master/src/components/TuxProvisionCreate.vue"],
      "names": [],
      "mappings": ";AAsrBA;EACA,YAAA;AACA",
      "file": "TuxProvisionCreate.vue",
      "sourcesContent": ["<template>\n  <div class=\"container\">\n    <al-notify v-if=\"manualError\" error class=\"padding-top-sm\" name=\"avs-error\">\n      {{ $t(manualError) }}\n    </al-notify>\n\n    <div v-else-if=\"showPartnerBanner\" class=\"row-banner\" data-test=\"partner-banner\">\n      <div class=\"col-full\">\n        <p class=\"info\">\n          <i class=\"icon-info-inverse icon-size-xs\" />\n          {{ $t('provisionCreate.bannerInfo', { partnerName }) }}\n        </p>\n      </div>\n    </div>\n\n    <form class=\"container\" novalidate @submit.prevent>\n      <div :class=\"['row', { 'padding-top-sm': showHeadingPadding }]\">\n        <div class=\"col-full\">\n          <h1 class=\"heading-xl\">\n            {{ $t(heading) }}\n          </h1>\n        </div>\n      </div>\n      <div :class=\"{ card: isPiiDataProvided }\">\n        <div class=\"card__item\">\n          <div class=\"row\">\n            <div class=\"col-full\">\n              <al-card-preview\n                v-if=\"showCardPreview\"\n                :img=\"cardImg\"\n                :brand=\"cardBrand\"\n                :number=\"`•••• ${card.primaryAccountNumberSuffix}`\"\n                name=\"card-preview\" />\n            </div>\n          </div>\n        </div>\n        <template v-if=\"showBillingAddressSection\">\n          <div class=\"card__item\">\n            <div class=\"row\">\n              <div :class=\"showEditBillingButton ? 'col-3' : 'col'\">\n                <h2 class=\"heading-md\">\n                  <!-- Tooltip icon is required to be on the same line as the text node to prevent orphaning of the icon -->\n                  {{ $t('provisionCreate.billingAddressHeading')\n                  }}<i\n                    v-if=\"showToolTip\"\n                    v-tooltip=\"$t('provisionCreate.billingAddressTooltip')\"\n                    data-test=\"provisionCreate-billingAddressTooltip\"\n                    :aria-label=\"$t('provisionCreate.billingAddressHeading')\"\n                    class=\"provisionCreate__billing-tooltip icon-info icon-size-xs\"\n                    tabindex=\"0\" />\n                </h2>\n              </div>\n              <div v-if=\"showEditBillingButton\" class=\"col-1 align-right\">\n                <button\n                  type=\"button\"\n                  data-test=\"edit-billing-btn\"\n                  class=\"btn--secondary\"\n                  @click=\"handleEditBilling\">\n                  {{ $t('provisionCreate.edit') }}\n                </button>\n              </div>\n            </div>\n\n            <template v-if=\"showBillingAddressForm\">\n              <tux-google-consent\n                v-if=\"isAutocompleteEnabled\"\n                :privacy-url=\"googlePrivacyUrl\"\n                :terms-url=\"googleTermsUrl\"\n                data-test=\"google-consent-billing\"\n                @privacy-click=\"handlePrivacyClick\"\n                @terms-click=\"handleTermsClick\" />\n              <tux-address-form\n                v-model=\"form.billingAddress\"\n                :countries=\"countries\"\n                :enable-autocomplete=\"isAutocompleteEnabled\"\n                enable-name-field\n                autocomplete=\"billing\"\n                name=\"billing-address\"\n                @autocomplete-selection=\"handleAutocompleteSelected\"\n                @input=\"input\" />\n            </template>\n            <div v-else class=\"row\" data-test=\"billing-address-read-only\">\n              <div class=\"col-full\">\n                <tux-address-label\n                  :address=\"form.billingAddress\"\n                  class=\"provisionCreate__address-label\" />\n              </div>\n            </div>\n            <template v-if=\"showShippingCheckBox\">\n              <div class=\"row margin-top-sm\">\n                <div class=\"col-full\">\n                  <al-checkbox\n                    v-model=\"form.saveAsShipping\"\n                    :label=\"$t('provisionCreate.shippingSameAsBilling')\"\n                    name=\"shippingSameAsBilling\"\n                    data-test=\"shipping-same-as-billing\"\n                    @input=\"handleSaveAsShipping\" />\n                </div>\n              </div>\n            </template>\n            <template v-if=\"showShippingAddressForm\">\n              <div class=\"row\">\n                <div class=\"col-full\">\n                  <h2 class=\"heading-md\">\n                    {{ $t('provisionCreate.shippingAddressHeading') }}\n                  </h2>\n                </div>\n              </div>\n              <tux-google-consent\n                v-if=\"isAutocompleteEnabled\"\n                :privacy-url=\"googlePrivacyUrl\"\n                :terms-url=\"googleTermsUrl\"\n                data-test=\"google-consent-shipping\"\n                @privacy-click=\"handlePrivacyClick\"\n                @terms-click=\"handleTermsClick\" />\n              <tux-address-form\n                v-model=\"form.shippingAddress\"\n                :countries=\"countries\"\n                :enable-autocomplete=\"isAutocompleteEnabled\"\n                enable-name-field\n                optional-form\n                autocomplete=\"shipping\"\n                name=\"shippingAddress\"\n                @autocomplete-selection=\"handleAutocompleteSelected\"\n                @input=\"input\" />\n            </template>\n          </div>\n        </template>\n        <div class=\"card__item\">\n          <div class=\"row\">\n            <div class=\"col-3\">\n              <h2 class=\"heading-md\">\n                {{ $t('provisionCreate.contactInformation') }}\n              </h2>\n            </div>\n            <div v-if=\"isContactSectionReadOnly && !existingUser\" class=\"col-1 align-right\">\n              <button\n                aria-label=\"edit button\"\n                class=\"btn--secondary align-right\"\n                data-test=\"btn-edit\"\n                @click=\"isContactEditing = true\">\n                {{ $t('provisionCreate.edit') }}\n              </button>\n            </div>\n          </div>\n          <template v-if=\"isContactSectionReadOnly\">\n            <div data-test=\"contact-read-only\" class=\"row\">\n              <div class=\"col-full\">\n                <p>\n                  <span data-test=\"user-id\">\n                    {{ initialUserId }}\n                  </span>\n                  <br />\n                  <span data-test=\"phone-number\">\n                    {{ formattedMobileNumber }}\n                  </span>\n                </p>\n              </div>\n            </div>\n          </template>\n          <template v-else>\n            <div v-if=\"showFirstLastNameField\" class=\"col\">\n              <tux-address-form\n                v-model=\"form.billingAddress\"\n                name-only\n                :countries=\"countries\"\n                :enable-autocomplete=\"isAutocompleteEnabled\"\n                autocomplete=\"name\"\n                name=\"name\"\n                @autocomplete-selection=\"handleAutocompleteSelected\"\n                @input=\"input\" />\n            </div>\n            <div class=\"row\">\n              <div class=\"col-full\">\n                <al-input\n                  v-model=\"form.userId\"\n                  v-validate=\"'required|email'\"\n                  :label=\"$t('placeholder.email')\"\n                  type=\"email\"\n                  name=\"userId\"\n                  data-test=\"user-id\"\n                  @input=\"input\" />\n              </div>\n            </div>\n            <div class=\"row\">\n              <div class=\"col-full\">\n                <al-contact-input\n                  v-model=\"form.phoneNumber\"\n                  :countries=\"countryOptions\"\n                  :label=\"$t('placeholder.mobileNumber')\"\n                  :legal=\"$t('provisionCreate.mobileHelperText')\"\n                  name=\"phoneNumber\"\n                  data-test=\"phone-number\"\n                  @input=\"input\" />\n              </div>\n            </div>\n          </template>\n          <template v-if=\"!existingUser\">\n            <div v-if=\"nationalIdConfig\" class=\"row\">\n              <div class=\"col-full\">\n                <h2 class=\"heading-md\">\n                  {{ $t('provisionCreate.nationalId') }}\n                </h2>\n                <al-input\n                  v-model=\"form.nationalId\"\n                  v-validate.immediate=\"nationalIdValidationRules\"\n                  :mask=\"nationalIdConfig.mask\"\n                  :manual-error=\"$t(nationalIdError)\"\n                  :label=\"$t('provisionCreate.identificationNumber')\"\n                  name=\"nationalId\"\n                  data-test=\"national-id\"\n                  @input=\"input\" />\n              </div>\n            </div>\n\n            <div v-if=\"showRememberMe\" class=\"row\">\n              <div class=\"col-full\">\n                <h3>\n                  {{ $t('provisionCreate.rememberMeHeading') }}\n                </h3>\n                <al-checkbox\n                  v-model=\"form.rememberMe\"\n                  :label=\"$t('provisionCreate.rememberMe')\"\n                  :subtext=\"$t('provisionCreate.rememberMeSubheading')\"\n                  data-test=\"remember-me\"\n                  name=\"remember-me\"\n                  @input=\"handleRememberMe\" />\n              </div>\n            </div>\n            <div v-if=\"showMarketingOptIn\" class=\"row\">\n              <div class=\"col-full\">\n                <al-checkbox\n                  v-model=\"form.marketingOptIn\"\n                  :label=\"$t('provisionCreate.marketingOptIn')\"\n                  :subtext=\"$t('provisionCreate.marketingOptInSubheading')\"\n                  name=\"marketingOptIn\"\n                  data-test=\"marketing-opt-in\"\n                  @input=\"handleMarketingOptIn\" />\n              </div>\n            </div>\n          </template>\n        </div>\n      </div>\n\n      <tux-fraud-protection v-if=\"!existingUser\" name=\"fraud-protection\" />\n\n      <tux-terms-consent\n        v-if=\"!existingUser\"\n        :key=\"termsConsentKey\"\n        flex-grow\n        name=\"provision\"\n        :privacy-url=\"privacyUrl\"\n        :terms-url=\"termsUrl\" />\n\n      <div class=\"row row-vertical-align-bottom\">\n        <div class=\"col-full align-center\">\n          <button\n            type=\"submit\"\n            :disabled=\"disableContinueButton\"\n            data-test=\"form-submit-button\"\n            class=\"uppercase fill\"\n            :aria-label=\"$t(buttonText)\"\n            @click=\"handleSubmit\">\n            {{ $t(buttonText) }}\n          </button>\n        </div>\n        <div v-if=\"$slots && $slots['secondary-cta']\" class=\"col-full align-center\">\n          <slot name=\"secondary-cta\" />\n        </div>\n      </div>\n    </form>\n  </div>\n</template>\n\n<script>\nimport { AlCardPreview, AlCheckbox, AlContactInput, AlInput, AlNotify } from '@mc-alberta/alcapone'\nimport merge from 'lodash.merge'\nimport TuxAddressLabel from '@/components/TuxAddressLabel'\nimport TuxFraudProtection from '@/components/TuxFraudProtection'\nimport TuxGoogleConsent from '@/components/TuxGoogleConsent'\nimport TuxTermsConsent from '@/components/TuxTermsConsent'\nimport TuxAddressForm from '@/components/addressForm/TuxAddressForm'\nimport { ADDRESS_FORMAT, COUNTRY_FEATURES } from '@/constants'\nimport { splitAddressNames, transformEmvcoToMastercard } from '@/utils/address'\nimport { formatMobileNumber } from '@/utils/formatMobileNumber.js'\n\nexport default {\n  name: 'TuxProvisionCreate',\n  components: {\n    AlCardPreview,\n    AlCheckbox,\n    AlContactInput,\n    AlInput,\n    AlNotify,\n    TuxAddressForm,\n    TuxAddressLabel,\n    TuxFraudProtection,\n    TuxGoogleConsent,\n    TuxTermsConsent\n  },\n  inject: ['$validator'],\n  model: {\n    prop: 'formData',\n    event: 'input'\n  },\n  props: {\n    /**\n     * Main data prop that will be used with v-model in the parent component.\n     */\n    formData: {\n      type: Object,\n      default: null\n    },\n    /**\n     * Whether or not to allow a partner banner at the top of the page\n     */\n    allowPartnerBanner: {\n      type: Boolean,\n      default: false\n    },\n    /**\n     * Data object for displaying card preview. Card must be in Mastercard (not Emvco) spec.\n     */\n    card: {\n      type: Object,\n      required: true\n    },\n    /**\n     * List of countries to select in address drop-down menu\n     */\n    countries: {\n      type: Array,\n      required: true\n    },\n    /**\n     * Locale country\n     */\n    countryCode: {\n      type: String,\n      required: true\n    },\n    /**\n     * Whether or not billingAddress can be edited\n     */\n    editableBillingAddress: {\n      type: Boolean,\n      default: false\n    },\n    /**\n     * Whether or not consumer info can be edited\n     */\n    editableConsumerInfo: {\n      type: Boolean,\n      default: false\n    },\n    /**\n     * Whether or not address autocomplete should be enabled\n     */\n    enableAutocomplete: {\n      type: Boolean,\n      default: false\n    },\n    /**\n     * Whether or not user exists already.\n     *\n     * If existingUser is false = show everything\n     * If existingUser is true = don't show things like marketing opt in, remember me, etc. as user was already given these options\n     */\n    existingUser: {\n      type: Boolean,\n      default: false\n    },\n    /**\n     * Force display an error, useful for server side errors. \"*This will overwrite all other client side validation and errors.*\". It is the consumer's responsibility to clear out this error message.\n     */\n    manualError: {\n      type: String,\n      default: null\n    },\n    /**\n     * Error message if there is a national id validation error\n     */\n    nationalIdError: {\n      type: String,\n      default: null\n    },\n    /**\n     * Privacy Notice Url\n     */\n    privacyUrl: {\n      type: String,\n      required: true\n    },\n    /**\n     * Google Privacy Notice Url\n     */\n    googlePrivacyUrl: {\n      type: String,\n      default: null\n    },\n    /**\n     * Google Terms and Conditions Url\n     */\n    googleTermsUrl: {\n      type: String,\n      default: null\n    },\n    /**\n     * Whether or not to show Marketing Opt In checkbox\n     */\n    showMarketingOptIn: {\n      type: Boolean,\n      default: false\n    },\n    /**\n     * Whether or not to show Remember Me checkbox\n     */\n    showRememberMe: {\n      type: Boolean,\n      default: false\n    },\n    /**\n     * Force billing address to be displayed even if the billing address preference is `NONE`\n     */\n    forceDisplayBilling: {\n      type: Boolean,\n      default: false\n    },\n    /**\n     * Terms & Conditions Url\n     */\n    termsUrl: {\n      type: String,\n      required: true\n    }\n  },\n  data() {\n    return {\n      buttonText: 'provisionCreate.primaryCTA',\n      countryOptions: this.$i18nData.getPhonesConfig(),\n      editBillingClicked: false,\n      isContactEditing: false,\n      form: {\n        billingAddress: {},\n        marketingOptIn: false,\n        nationalId: '',\n        phoneNumber: {\n          country: '',\n          countryCode: '',\n          phoneNumber: ''\n        },\n        rememberMe: false,\n        saveAsShipping: false,\n        shippingAddress: {},\n        userId: ''\n      },\n      initialBillingAddress: this.formData?.billingAddress || {},\n      initialUserId: this.formData?.userId || '',\n      initialPhoneNumber: this.formData?.phoneNumber || '',\n      isAutocompleteApiEnabled: false,\n      showShippingCheckBox: true,\n      isInitialBillingDataIncomplete: true,\n      isPiiDataProvided: false,\n      transformedAddress: {},\n      // assign a key to the terms consent component to force re-render on key change\n      termsConsentKey: 0\n    }\n  },\n  computed: {\n    addressConfig() {\n      return this.$i18nData.getCountryConfig(this.initialBillingAddress.countryCode, false)?.address\n    },\n    heading() {\n      return this.existingUser ? 'provisionCreate.reviewHeading' : 'provisionCreate.heading'\n    },\n    cardBrand() {\n      const { shortProductDescription, issuerName, paymentNetworkName } = this.card\n      return shortProductDescription || issuerName || paymentNetworkName\n    },\n    cardImg() {\n      return this.card?.artUrl || this.card?.cardArtUrl\n    },\n    cardCountryConfig() {\n      return this.$i18nData.getCountryConfig(this.card?.countryCode)\n    },\n    formattedMobileNumber() {\n      return formatMobileNumber(this.initialPhoneNumber, this.countryCode)\n    },\n    addressFormat() {\n      return this.cardCountryConfig?.billingAddressFormat === ADDRESS_FORMAT.FULL\n        ? ADDRESS_FORMAT.FULL\n        : ADDRESS_FORMAT.NONE\n    },\n    isAutocompleteEnabled() {\n      return this.enableAutocomplete && this.isAutocompleteApiEnabled\n    },\n    isEditingBilling() {\n      const isEditingByChoice = this.editableBillingAddress && this.editBillingClicked\n      const displayAddressForm = !this.initialBillingAddress?.name && !this.isNoneView\n      return isEditingByChoice || displayAddressForm\n    },\n    isFullView() {\n      return this.addressFormat === ADDRESS_FORMAT.FULL\n    },\n    isRestrictedCountry() {\n      return this.$i18nData.isCountryRestricted(this.countryCode)\n    },\n    isNoneView() {\n      return this.addressFormat === ADDRESS_FORMAT.NONE || this.isRestrictedCountry\n    },\n    nationalIdConfig() {\n      const { consumer } = this.$i18nData.getCountryConfig(this.countryCode) || {}\n      return consumer?.nationalId\n    },\n    nationalIdValidationRules() {\n      let validationRules\n\n      if (this.nationalIdConfig) {\n        const { required, minimumLength: min, maximumLength: max } = this.nationalIdConfig\n        validationRules = { required, min, max, national_id: true }\n      }\n\n      return validationRules\n    },\n    partnerName() {\n      const { issuerName, shortProductDescription, paymentNetworkName } = this.card\n      return issuerName || shortProductDescription || paymentNetworkName\n    },\n    showCardPreview() {\n      return this.card && Object.keys(this.card).length > 0\n    },\n    showEditBillingButton() {\n      if (this.isNoneView) {\n        return\n      }\n      return this.editableBillingAddress && !this.showBillingAddressForm\n    },\n    isContactSectionReadOnly() {\n      return (\n        this.editableConsumerInfo &&\n        this.initialUserId &&\n        this.initialPhoneNumber.phoneNumber &&\n        !this.isContactEditing\n      )\n    },\n    showHeadingPadding() {\n      return !this.manualError && this.showPartnerBanner\n    },\n    showBillingAddressSection() {\n      return this.forceDisplayBilling\n        ? !this.isRestrictedCountry && this.isAddressValid\n        : !this.isNoneView\n    },\n    showBillingAddressForm() {\n      return (\n        !this.forceDisplayBilling && (this.isEditingBilling || this.isInitialBillingDataIncomplete)\n      )\n    },\n    showFirstLastNameField() {\n      if (!this.showBillingAddressSection) {\n        return this.isNoneView\n      }\n\n      const hasFullName =\n        (this.initialBillingAddress.firstName && this.initialBillingAddress.lastName) ||\n        this.initialBillingAddress.name\n      return !hasFullName\n    },\n    showPartnerBanner() {\n      return this.allowPartnerBanner && this.partnerName\n    },\n    showToolTip() {\n      return !this.isInitialBillingDataIncomplete && !this.editableBillingAddress\n    },\n    disableContinueButton() {\n      const validationError =\n        this.hasValidationErrors !== undefined ? this.hasValidationErrors : this.errors?.any()\n      return validationError || Boolean(this.manualError) || Boolean(this.nationalIdError)\n    },\n    requiredFields() {\n      return Object.keys(this.addressConfig).filter((field) =>\n        Boolean(this.addressConfig[field].required)\n      )\n    },\n    isAddressValid() {\n      return this.requiredFields.every((field) => Boolean(this.transformedAddress[field]))\n    },\n    showShippingAddressForm() {\n      return !this.form.saveAsShipping\n    },\n    isConsumerDataPresent() {\n      return !!(this.initialUserId || this.initialPhoneNumber.phoneNumber)\n    }\n  },\n  watch: {\n    countryCode: {\n      immediate: true,\n      handler() {\n        this.isAutocompleteApiEnabled = this.$i18nData.isCountryFeatureEnabled(\n          COUNTRY_FEATURES.ENABLE_ADDRESS_AUTOCOMPLETE,\n          this.$i18n.locale\n        )\n        this.termsConsentKey++\n      }\n    },\n    'form.saveAsShipping': {\n      immediate: true,\n      handler(newValue) {\n        if (newValue) {\n          this.form.shippingAddress = { countryCode: this.countryCode }\n        } else {\n          this.form.shippingAddress.countryCode = this.countryCode\n        }\n      }\n    }\n  },\n  created() {\n    this.form = merge({}, this.form, this.formData)\n    this.transformedAddress = transformEmvcoToMastercard(this.initialBillingAddress)\n    this.isPiiDataProvided = this.checkIsPiiDataProvided()\n    this.isInitialBillingDataIncomplete = this.checkIsBillingDataIncomplete()\n  },\n  mounted() {\n    this.$validator.validateAll()\n  },\n  methods: {\n    handleAutocompleteSelected(event) {\n      this.$emit('autocomplete-selected', event)\n    },\n    handleEditBilling(event) {\n      this.editBillingClicked = true\n      this.form.billingAddress = splitAddressNames(this.form.billingAddress)\n      this.$emit('edit-billing-address', event)\n    },\n    handleMarketingOptIn(event) {\n      this.input()\n      this.$emit('marketing-opt-in', event)\n    },\n    handlePrivacyClick(event) {\n      this.$emit('privacy-click', event)\n    },\n    handleRememberMe(event) {\n      this.input()\n      this.$emit('remember-me', event)\n    },\n    handleSaveAsShipping(event) {\n      this.input()\n      this.$emit('save-as-shipping', event)\n    },\n    handleSubmit(event) {\n      this.$emit('format', this.addressFormat)\n      this.$emit('submit', event)\n    },\n    handleTermsClick(event) {\n      this.$emit('terms-click', event)\n    },\n    input() {\n      /**\n       * @event input\n       * @type {Object}\n       */\n      this.$emit('input', this.form)\n    },\n    checkIsBillingDataIncomplete() {\n      if (this.isFullView) {\n        return this.handleFullView()\n      } else {\n        return this.handleNoneView()\n      }\n    },\n    handleFullView() {\n      if (!this.isAddressValid) {\n        this.form.billingAddress = splitAddressNames(this.form.billingAddress)\n        return true\n      }\n\n      return false\n    },\n    handleNoneView() {\n      if (!this.isAddressValid) this.showShippingCheckBox = false\n      this.form.billingAddress = splitAddressNames(this.form.billingAddress)\n      return false\n    },\n    checkIsPiiDataProvided() {\n      return (\n        this.requiredFields.some((field) => Boolean(this.transformedAddress[field])) ||\n        this.isConsumerDataPresent\n      )\n    }\n  }\n}\n</script>\n\n<style scoped>\n.row-vertical-align-bottom {\n  flex-grow: 0;\n}\n</style>\n"]
    },
    media: undefined
  });
};
/* scoped */
const __vue_scope_id__$7 = "data-v-77c570c4";
/* module identifier */
const __vue_module_identifier__$7 = undefined;
/* functional template */
const __vue_is_functional_template__$7 = false;
/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$d = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$7,
  staticRenderFns: __vue_staticRenderFns__$7
}, __vue_inject_styles__$7, __vue_script__$7, __vue_scope_id__$7, __vue_is_functional_template__$7, __vue_module_identifier__$7, false, createInjector, undefined, undefined);
var __vue_component__$e = __vue_component__$d;

//
var script$6 = {
  name: 'TuxPushNotification',
  components: {
    AlButton,
    AlStyledContainer
  },
  props: {
    /**
     * Mark the primary cta as loading
     */
    isLoading: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    ctaAction(event) {
      this.$emit('cta-click', event);
    },
    secondaryCtaAction(event) {
      this.$emit('secondary-cta-click', event);
    },
    resendNotification(event) {
      this.$emit('resend-notification', event);
    }
  }
};

/* script */
const __vue_script__$6 = script$6;

/* template */
var __vue_render__$6 = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("div", {
    staticClass: "container text-align-left"
  }, [_c("div", {
    staticClass: "row"
  }, [_c("div", {
    staticClass: "col-full"
  }, [_c("h1", [_vm._v("\n        " + _vm._s(_vm.$t("pushNotification.heading")) + "\n      ")]), _vm._v(" "), _c("p", {
    staticClass: "margin-bottom-md"
  }, [_vm._v("\n        " + _vm._s(_vm.$t("pushNotification.subheading")) + "\n      ")])])]), _vm._v(" "), _c("div", {
    staticClass: "row"
  }, [_c("div", {
    staticClass: "col-full"
  }, [_c("al-styled-container", {
    attrs: {
      name: "push-notification-steps",
      wrap: "",
      "no-fade": ""
    }
  }, [_c("ol", {
    staticClass: "padding-left-md margin-right-none"
  }, [_c("li", [_c("i18n", {
    attrs: {
      path: "pushNotification.stepOne.normal",
      tag: "p"
    },
    scopedSlots: _vm._u([{
      key: "boldText",
      fn: function () {
        return [_c("span", {
          staticClass: "weight-semibold"
        }, [_vm._v("\n                  " + _vm._s(_vm.$t("pushNotification.stepOne.bold")) + "\n                ")])];
      },
      proxy: true
    }])
  }), _vm._v(" "), _c("button", {
    staticClass: "btn--secondary",
    attrs: {
      disabled: _vm.isLoading,
      "data-test": "resend-notification",
      type: "button"
    },
    on: {
      click: _vm.resendNotification
    }
  }, [_vm._v("\n              " + _vm._s(_vm.$t("pushNotification.resend")) + "\n            ")])], 1), _vm._v(" "), _c("li", {
    staticClass: "padding-top-sm"
  }, [_c("i18n", {
    attrs: {
      path: "pushNotification.stepTwo.normal",
      tag: "p"
    },
    scopedSlots: _vm._u([{
      key: "boldText",
      fn: function () {
        return [_c("span", {
          staticClass: "weight-semibold"
        }, [_vm._v("\n                  " + _vm._s(_vm.$t("pushNotification.stepTwo.bold")) + "\n                ")])];
      },
      proxy: true
    }])
  })], 1)])])], 1)]), _vm._v(" "), _c("div", {
    staticClass: "row-vertical-align-bottom"
  }, [_c("div", {
    staticClass: "col-full"
  }, [_c("al-button", {
    attrs: {
      name: "primary-button",
      loading: _vm.isLoading,
      "aria-label": _vm.$t("button.continue"),
      label: _vm.$t("button.continue"),
      uppercase: ""
    },
    on: {
      click: _vm.ctaAction
    }
  }), _vm._v(" "), _c("button", {
    staticClass: "btn--secondary fill margin-top-lg",
    attrs: {
      disabled: _vm.isLoading,
      "data-test": "secondary-button"
    },
    on: {
      click: _vm.secondaryCtaAction
    }
  }, [_vm._v("\n        " + _vm._s(_vm.$t("pushNotification.continueAnotherWay")) + "\n      ")])], 1)])]);
};
var __vue_staticRenderFns__$6 = [];
__vue_render__$6._withStripped = true;

/* style */
const __vue_inject_styles__$6 = undefined;
/* scoped */
const __vue_scope_id__$6 = undefined;
/* module identifier */
const __vue_module_identifier__$6 = undefined;
/* functional template */
const __vue_is_functional_template__$6 = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$b = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$6,
  staticRenderFns: __vue_staticRenderFns__$6
}, __vue_inject_styles__$6, __vue_script__$6, __vue_scope_id__$6, __vue_is_functional_template__$6, __vue_module_identifier__$6, false, undefined, undefined, undefined);
var __vue_component__$c = __vue_component__$b;

//
const CHANNELS = {
  EMAIL: 'EMAIL',
  ISSUER: 'ISSUER',
  PUSH: 'PUSH',
  SMS: 'SMS'
};
var script$5 = {
  name: 'TuxVerification',
  components: {
    AlButton,
    AlCodeInput,
    AlLoader,
    AlNotify
  },
  props: {
    /**
     * Should the form auto submit when the OTP field is filled
     */
    autoSubmit: {
      type: Boolean,
      default: false
    },
    /**
     * The channel the OTP was sent to
     * @values SMS, EMAIL, PUSH, ISSUER
     */
    channel: {
      type: String,
      required: true,
      validator: prop => Object.keys(CHANNELS).includes(prop)
    },
    /**
     * Shows a cancel button
     */
    showCancel: {
      type: Boolean,
      default: false
    },
    /**
     * The text to show for the cancel button, only pass if different than the default 'Cancel'
     */
    cancelLabel: {
      type: String,
      default: ''
    },
    /**
     * The heading text, only add it if you wish to override the default.
     */
    heading: {
      type: String,
      default: ''
    },
    /**
     * Hides the heading text
     */
    hideHeading: {
      type: Boolean,
      default: false
    },
    /**
     * Set to true when the OTP code has been successfully accepted.
     */
    isSuccessful: {
      type: Boolean,
      default: false
    },
    /**
     * The issuer name related to this OTP. This is optional, but it is used
     * as an interpolation in strings where the issuer is referenced.
     */
    issuer: {
      type: String,
      default: ''
    },
    /**
     * Mark the form as loading
     */
    loading: {
      type: Boolean,
      default: false
    },
    /**
     * Mark the OTP field as been in error state, and show this message.
     */
    manualErrorToken: {
      type: String,
      default: ''
    },
    /**
     * Show the "continue another way" option to select multiple channels to OTP.
     */
    multiChannel: {
      type: Boolean,
      default: false
    },
    /**
     * Uses a optional name so it can be passed in as al code input test selectors. E.g. data-test="name-1".
     */
    name: {
      type: String,
      default: 'otp'
    },
    /**
     * Shows a page level error at the top of the page
     */
    pageNotification: {
      type: String,
      default: ''
    },
    /**
     * Where the OTP was sent to, either an email or phone number.
     */
    sentTo: {
      type: String,
      default: ''
    },
    /**
     * The subheading text, only send it if you wish to override the default.
     */
    subheading: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      code: ''
    };
  },
  computed: {
    disableContinueButton() {
      const validationError = this.hasValidationErrors !== undefined ? this.hasValidationErrors : this.errors?.any();
      return validationError;
    },
    content() {
      let heading = 'verification.headings.default';
      let subheading = 'verification.subheadings.default';
      let subtext = null;
      switch (this.channel) {
        case CHANNELS.EMAIL:
          subtext = 'verification.helperText';
          break;
        case CHANNELS.ISSUER:
          heading = 'verification.headings.issuer';
          subheading = 'verification.subheadings.issuer';
          break;
        case CHANNELS.PUSH:
          heading = 'verification.headings.pushNotification';
          subheading = 'verification.subheadings.pushNotification';
          break;
      }

      // if something was passed in as props, that should take priority
      heading = this.heading || heading;
      subheading = this.subheading || subheading;
      return {
        heading,
        subheading,
        subtext
      };
    },
    manualError: {
      get() {
        return this.$t(this.manualErrorToken);
      },
      set(value) {
        this.$emit('update:manual-error-token', value);
      }
    },
    showLoadingIndicator() {
      return this.autoSubmit && this.loading;
    }
  },
  async mounted() {
    await this.$validator.validateAll();
  },
  methods: {
    filled() {
      if (this.autoSubmit) {
        this.submit();
      }
    },
    submit() {
      if (!this.loading) {
        this.$emit('submit', this.code);
      }
    },
    resend() {
      this.$emit('resend');
      this.clearForm();
    },
    showOptions() {
      this.$emit('show-options');
      this.clearForm();
    },
    cancel() {
      this.$emit('cancel');
      this.clearForm();
    },
    complete() {
      this.$emit('complete');
    },
    clearForm() {
      this.code = '';
      this.manualError = '';
    }
  }
};

/* script */
const __vue_script__$5 = script$5;

/* template */
var __vue_render__$5 = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("main", [_c("form", {
    staticClass: "container text-align-left",
    on: {
      submit: function ($event) {
        $event.preventDefault();
      }
    }
  }, [_vm.pageNotification ? _c("al-notify", {
    attrs: {
      error: "",
      name: "page-notification"
    }
  }, [_vm._v("\n      " + _vm._s(_vm.$t(_vm.pageNotification)) + "\n    ")]) : _vm._e(), _vm._v(" "), _c("div", {
    staticClass: "row-vertical-align-center"
  }, [_c("div", {
    staticClass: "col-full",
    attrs: {
      "data-test": "otp-headings"
    }
  }, [!_vm.hideHeading ? _c("h1", {
    staticClass: "margin-bottom-sm"
  }, [_vm._v("\n          " + _vm._s(_vm.$t(_vm.content.heading)) + "\n        ")]) : _vm._e(), _vm._v(" "), _c("h2", {
    staticClass: "heading-md weight-regular color-primary align-left"
  }, [_vm._v("\n          " + _vm._s(_vm.$t(_vm.content.subheading, {
    issuer: _vm.issuer
  })) + "\n          "), _vm.sentTo ? _c("span", {
    directives: [{
      name: "ellipsis",
      rawName: "v-ellipsis",
      value: "@",
      expression: "'@'"
    }],
    staticClass: "no-wrap",
    attrs: {
      "data-test": "sent-to"
    }
  }, [_vm._v(_vm._s(_vm.sentTo) + ".")]) : _vm._e()])]), _vm._v(" "), _c("div", {
    staticClass: "col-full"
  }, [_c("al-code-input", {
    directives: [{
      name: "autofocus",
      rawName: "v-autofocus"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: "required|numeric|length:6",
      expression: "'required|numeric|length:6'"
    }],
    attrs: {
      "is-successful": _vm.isSuccessful,
      label: _vm.$t("verification.fieldLabel"),
      length: 6,
      "manual-error": _vm.manualError,
      subtext: _vm.$t(_vm.content.subtext),
      name: _vm.name
    },
    on: {
      "update:manualError": function ($event) {
        _vm.manualError = $event;
      },
      "update:manual-error": function ($event) {
        _vm.manualError = $event;
      },
      filled: _vm.filled,
      complete: _vm.complete
    },
    model: {
      value: _vm.code,
      callback: function ($$v) {
        _vm.code = $$v;
      },
      expression: "code"
    }
  })], 1), _vm._v(" "), _c("div", {
    staticClass: "col-full",
    class: {
      "margin-top-sm": _vm.content.subtext
    }
  }, [_vm.multiChannel ? _c("button", {
    staticClass: "btn--secondary",
    attrs: {
      "data-test": "continue-another-way",
      type: "button"
    },
    on: {
      click: _vm.showOptions
    }
  }, [_vm._v("\n          " + _vm._s(_vm.$t("verification.continueAnotherWay")) + "\n        ")]) : _c("button", {
    staticClass: "btn--secondary",
    attrs: {
      "data-test": "resend-otp",
      type: "button"
    },
    on: {
      click: _vm.resend
    }
  }, [_vm._v("\n          " + _vm._s(_vm.$t("verification.resendCode")) + "\n        ")])])]), _vm._v(" "), _c("div", {
    staticClass: "row row-vertical-align-bottom"
  }, [_c("div", {
    staticClass: "col-full"
  }, [_vm.autoSubmit ? _c("al-loader", {
    staticClass: "dancing-dots margin-bottom-sm",
    class: {
      "visibility-hidden": !_vm.showLoadingIndicator
    },
    attrs: {
      "aria-hidden": !_vm.showLoadingIndicator,
      "dancing-dots": "",
      name: "otp-loading-indicator"
    }
  }) : _c("al-button", {
    attrs: {
      loading: _vm.loading,
      disabled: _vm.disableContinueButton,
      label: _vm.$t("button.continue"),
      name: "form-submit-button",
      uppercase: ""
    },
    on: {
      click: _vm.submit
    }
  })], 1), _vm._v(" "), _vm.showCancel ? _c("div", {
    staticClass: "col-full align-center"
  }, [_c("button", {
    staticClass: "btn--secondary",
    attrs: {
      disabled: _vm.loading,
      type: "button",
      "data-test": "cancel-otp"
    },
    on: {
      click: _vm.cancel
    }
  }, [_vm._v("\n          " + _vm._s(_vm.$t(_vm.cancelLabel || "button.cancel")) + "\n        ")])]) : _vm._e()])], 1)]);
};
var __vue_staticRenderFns__$5 = [];
__vue_render__$5._withStripped = true;

/* style */
const __vue_inject_styles__$5 = undefined;
/* scoped */
const __vue_scope_id__$5 = undefined;
/* module identifier */
const __vue_module_identifier__$5 = undefined;
/* functional template */
const __vue_is_functional_template__$5 = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$9 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$5,
  staticRenderFns: __vue_staticRenderFns__$5
}, __vue_inject_styles__$5, __vue_script__$5, __vue_scope_id__$5, __vue_is_functional_template__$5, __vue_module_identifier__$5, false, undefined, undefined, undefined);
var __vue_component__$a = __vue_component__$9;

//
var script$4 = {
  name: 'TuxCustomConsent',
  components: {
    AlCheckbox
  },
  inject: ['$validator'],
  props: {
    /**
     * The name of the component, used to label the data-test element.
     */
    name: {
      type: String,
      required: true
    },
    /**
     * Array of consent data objects.
     */
    consentData: {
      type: Array,
      required: true
    }
  },
  data() {
    return {
      isExplicitConsentChecked: []
    };
  },
  computed: {
    explicitConsentData() {
      return this.consentData.filter(consentObject => {
        return consentObject.isExplicit;
      });
    },
    implicitConsentData() {
      return this.consentData.filter(consentObject => {
        return !consentObject.isExplicit;
      });
    }
  },
  created() {
    this.isExplicitConsentChecked = Array(this.explicitConsentData.length).fill(false);
  },
  methods: {
    handleLinkClick(event, name) {
      this.$emit(`${name}-click`, event);
    },
    handleConsentChecked(checked, name) {
      this.$emit(`${name}-checked`, checked);
    }
  }
};

/* script */
const __vue_script__$4 = script$4;

/* template */
var __vue_render__$4 = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("div", {
    staticClass: "row"
  }, [_c("div", {
    staticClass: "col-full"
  }, [_vm._l(_vm.explicitConsentData, function (consent, index) {
    return _c("al-checkbox", {
      directives: [{
        name: "validate",
        rawName: "v-validate.immediate",
        value: "required:true",
        expression: "'required:true'",
        modifiers: {
          immediate: true
        }
      }],
      key: consent.name,
      attrs: {
        name: consent.name + "-consent-checkbox"
      },
      on: {
        input: function ($event) {
          return _vm.handleConsentChecked($event, consent.name);
        }
      },
      model: {
        value: _vm.isExplicitConsentChecked[index],
        callback: function ($$v) {
          _vm.$set(_vm.isExplicitConsentChecked, index, $$v);
        },
        expression: "isExplicitConsentChecked[index]"
      }
    }, [_c("i18n", {
      attrs: {
        slot: "label",
        path: consent.path
      },
      slot: "label"
    }, _vm._l(consent.links, function (link) {
      return _c("a", {
        key: link.place,
        attrs: {
          href: link.url,
          "data-test": link.selector,
          target: "_blank",
          place: link.place
        },
        on: {
          click: function ($event) {
            return _vm.handleLinkClick($event, link.place);
          }
        }
      }, [_vm._v(_vm._s(_vm.$t(link.path)))]);
    }), 0)], 1);
  }), _vm._v(" "), _vm._l(_vm.implicitConsentData, function (consent) {
    return _c("i18n", {
      key: consent.name,
      staticClass: "legal align-center",
      attrs: {
        path: consent.path,
        tag: "p",
        "data-test": consent.name + "-implicit-consent"
      }
    }, _vm._l(consent.links, function (link) {
      return _c("a", {
        key: link.place,
        attrs: {
          href: link.url,
          "data-test": link.selector,
          target: "_blank",
          place: link.place
        },
        on: {
          click: function ($event) {
            return _vm.handleLinkClick($event, link.place);
          }
        }
      }, [_vm._v(_vm._s(_vm.$t(link.path)))]);
    }), 0);
  })], 2)]);
};
var __vue_staticRenderFns__$4 = [];
__vue_render__$4._withStripped = true;

/* style */
const __vue_inject_styles__$4 = undefined;
/* scoped */
const __vue_scope_id__$4 = undefined;
/* module identifier */
const __vue_module_identifier__$4 = undefined;
/* functional template */
const __vue_is_functional_template__$4 = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$8 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$4,
  staticRenderFns: __vue_staticRenderFns__$4
}, __vue_inject_styles__$4, __vue_script__$4, __vue_scope_id__$4, __vue_is_functional_template__$4, __vue_module_identifier__$4, false, undefined, undefined, undefined);
var TuxCustomConsent = __vue_component__$8;

//
var script$3 = {
  name: 'TuxFidoAuthentication',
  components: {
    AlBranding,
    AlButton,
    AlCardPreview,
    AlStyledContainer
  },
  props: {
    /**
     * Card information
     */
    maskedCard: {
      type: Object,
      default: null
    },
    /**
     * To style the button as loading or not
     */
    isLoading: {
      type: Boolean,
      default: false
    },
    /**
     * Name of the merchant
     */
    merchantName: {
      type: String,
      required: true
    },
    /**
     * Total amount for the current transaction
     */
    transactionAmount: {
      type: String,
      required: true
    }
  },
  methods: {
    confirm() {
      this.$emit('continue');
    }
  }
};

/* script */
const __vue_script__$3 = script$3;

/* template */
var __vue_render__$3 = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("div", {
    staticClass: "container"
  }, [_vm._m(0), _vm._v(" "), _c("div", {
    staticClass: "row"
  }, [_c("div", {
    staticClass: "col-full align-center"
  }, [_c("h1", {
    staticClass: "margin-bottom-fido",
    attrs: {
      "data-test": "title"
    }
  }, [_vm._v(_vm._s(_vm.$t("fido.authentication.title")))])]), _vm._v(" "), _c("div", {
    staticClass: "col-full"
  }, [_c("al-styled-container", {
    staticClass: "margin-bottom-fido",
    attrs: {
      name: "payment-details",
      form: "",
      "no-fade": ""
    }
  }, [_vm.maskedCard ? _c("al-card-preview", {
    staticClass: "margin-bottom-sm",
    attrs: {
      name: "card-preview",
      img: _vm.maskedCard.digitalCardData.artUri,
      brand: _vm.maskedCard.digitalCardData.presentationName || _vm.maskedCard.digitalCardData.descriptorName || _vm.maskedCard.paymentCardDescriptor,
      number: "•••• " + _vm.maskedCard.panLastFour
    }
  }) : _vm._e(), _vm._v(" "), _c("p", {
    staticClass: "heading-md payto-text margin-bottom-none"
  }, [_vm._v("\n          " + _vm._s(_vm.$t("fido.authentication.payto")) + "\n        ")]), _vm._v(" "), _c("div", {
    staticClass: "row-space-between"
  }, [_c("p", {
    staticClass: "margin-bottom-none"
  }, [_vm._v(_vm._s(_vm.merchantName))]), _vm._v(" "), _c("p", {
    staticClass: "margin-bottom-none"
  }, [_vm._v(_vm._s(_vm.transactionAmount))])])], 1)], 1)]), _vm._v(" "), _c("div", {
    staticClass: "row"
  }, [_c("div", {
    staticClass: "col-full"
  }, [_c("al-button", {
    staticClass: "margin-bottom-fido",
    attrs: {
      uppercase: "",
      loading: _vm.isLoading,
      label: _vm.$t("button.confirm"),
      name: "primary-button",
      icon: "icon-passkey"
    },
    on: {
      click: _vm.confirm
    }
  })], 1), _vm._v(" "), _c("div", {
    staticClass: "col-full"
  }, [_c("div", {
    staticClass: "tagline-container col-horizontal-justify-center margin-bottom-fido"
  }, [_c("p", {
    staticClass: "margin-bottom-none margin-right-xs heading-md"
  }, [_vm._v("\n          " + _vm._s(_vm.$t("fido.tagline")) + "\n        ")]), _vm._v(" "), _c("al-branding", {
    attrs: {
      networks: ["mastercard"],
      description: "Secure Remote Commerce",
      "without-src-logo": ""
    }
  })], 1)])])]);
};
var __vue_staticRenderFns__$3 = [function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("div", {
    staticClass: "row align-center"
  }, [_c("div", {
    staticClass: "col-full"
  }, [_c("i", {
    staticClass: "margin-top-fido margin-bottom-fido icon-biometrics"
  })])]);
}];
__vue_render__$3._withStripped = true;

/* style */
const __vue_inject_styles__$3 = function (inject) {
  if (!inject) return;
  inject("data-v-06e5a6d8_0", {
    source: "\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n/* TODO: Find a better solution than overriding right margin of al-branding */\n.tagline-container[data-v-06e5a6d8] .header__brand__item .card-brand-logo--mastercard {\n  margin-right: 0px;\n}\n.tagline-container[data-v-06e5a6d8] .header__brand__item {\n  margin-right: 0px !important;\n}\n.icon-biometrics[data-v-06e5a6d8] {\n  width: 9.625rem; /* 154px */\n  height: 9.25rem; /* 148px */\n}\n.margin-top-fido[data-v-06e5a6d8] {\n  margin-top: 1.5rem; /* 24px */\n}\n.margin-bottom-fido[data-v-06e5a6d8] {\n  margin-bottom: 1.5rem; /* 24px */\n}\n.row-space-between[data-v-06e5a6d8] {\n  margin-left: 0;\n  margin-right: 0;\n}\n.styled-container--card[data-v-06e5a6d8] .styled-container__item {\n  padding: 1.5rem !important; /* 24px */\n}\n\n/* TODO: Remove media queries once responsive vertical rhythm is added in alcapone */\n@media screen and (max-height: 550px) {\n.icon-biometrics[data-v-06e5a6d8] {\n    width: 5.75rem; /* 92px */\n    height: 5.5rem; /* 88px */\n}\nh1[data-v-06e5a6d8] {\n    font-size: 1.25rem; /* 20px */\n    line-height: 1.75rem; /* 28px */\n}\n.responsive-subtitle[data-v-06e5a6d8] {\n    font-size: 0.938rem; /* 15px */\n    line-height: 1.438rem; /* 23px */\n}\n.margin-top-fido[data-v-06e5a6d8] {\n    margin-top: 1rem; /* 16px */\n}\n.margin-bottom-fido[data-v-06e5a6d8] {\n    margin-bottom: 1rem; /* 16px */\n}\n.styled-container[data-v-06e5a6d8] {\n    margin-bottom: 1rem !important; /* 16px */\n}\n.styled-container--card[data-v-06e5a6d8] .styled-container__item {\n    padding: 1rem !important; /* 16px */\n}\n}\n@media screen and (min-height: 550px) and (max-height: 750px) {\n.icon-biometrics[data-v-06e5a6d8] {\n    width: 7.688rem; /* 123px */\n    height: 7.375rem; /* 118px */\n}\nh1[data-v-06e5a6d8] {\n    font-size: 1.25rem; /* 20px */\n    line-height: 1.75rem; /* 28px */\n}\n.responsive-subtitle[data-v-06e5a6d8] {\n    font-size: 0.938rem; /* 15px */\n    line-height: 1.438rem; /* 23px */\n}\n.margin-top-fido[data-v-06e5a6d8] {\n    margin-top: 1rem; /* 16px */\n}\n.margin-bottom-fido[data-v-06e5a6d8] {\n    margin-bottom: 1rem; /* 16px */\n}\n.styled-container[data-v-06e5a6d8] {\n    margin-bottom: 1rem !important; /* 16px */\n}\n.styled-container--card[data-v-06e5a6d8] .styled-container__item {\n    padding: 1rem !important; /* 16px */\n}\n}\n",
    map: {
      "version": 3,
      "sources": ["/vol_01/sys_apps_01/jenkins/workspace/Alberta_BERT_tuxedo_master/src/components/fido/TuxFidoAuthentication.vue"],
      "names": [],
      "mappings": ";;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;AA2GA,6EAAA;AACA;EACA,iBAAA;AACA;AAEA;EACA,4BAAA;AACA;AAEA;EACA,eAAA,EAAA,UAAA;EACA,eAAA,EAAA,UAAA;AACA;AAEA;EACA,kBAAA,EAAA,SAAA;AACA;AAEA;EACA,qBAAA,EAAA,SAAA;AACA;AAEA;EACA,cAAA;EACA,eAAA;AACA;AAEA;EACA,0BAAA,EAAA,SAAA;AACA;;AAEA,oFAAA;AACA;AACA;IACA,cAAA,EAAA,SAAA;IACA,cAAA,EAAA,SAAA;AACA;AAEA;IACA,kBAAA,EAAA,SAAA;IACA,oBAAA,EAAA,SAAA;AACA;AAEA;IACA,mBAAA,EAAA,SAAA;IACA,qBAAA,EAAA,SAAA;AACA;AAEA;IACA,gBAAA,EAAA,SAAA;AACA;AAEA;IACA,mBAAA,EAAA,SAAA;AACA;AAEA;IACA,8BAAA,EAAA,SAAA;AACA;AAEA;IACA,wBAAA,EAAA,SAAA;AACA;AACA;AAEA;AACA;IACA,eAAA,EAAA,UAAA;IACA,gBAAA,EAAA,UAAA;AACA;AAEA;IACA,kBAAA,EAAA,SAAA;IACA,oBAAA,EAAA,SAAA;AACA;AAEA;IACA,mBAAA,EAAA,SAAA;IACA,qBAAA,EAAA,SAAA;AACA;AAEA;IACA,gBAAA,EAAA,SAAA;AACA;AAEA;IACA,mBAAA,EAAA,SAAA;AACA;AAEA;IACA,8BAAA,EAAA,SAAA;AACA;AAEA;IACA,wBAAA,EAAA,SAAA;AACA;AACA",
      "file": "TuxFidoAuthentication.vue",
      "sourcesContent": ["<template>\n  <div class=\"container\">\n    <div class=\"row align-center\">\n      <div class=\"col-full\">\n        <i class=\"margin-top-fido margin-bottom-fido icon-biometrics\" />\n      </div>\n    </div>\n\n    <div class=\"row\">\n      <div class=\"col-full align-center\">\n        <h1 data-test=\"title\" class=\"margin-bottom-fido\">{{ $t('fido.authentication.title') }}</h1>\n      </div>\n      <div class=\"col-full\">\n        <al-styled-container name=\"payment-details\" class=\"margin-bottom-fido\" form no-fade>\n          <al-card-preview\n            v-if=\"maskedCard\"\n            class=\"margin-bottom-sm\"\n            name=\"card-preview\"\n            :img=\"maskedCard.digitalCardData.artUri\"\n            :brand=\"\n              maskedCard.digitalCardData.presentationName ||\n              maskedCard.digitalCardData.descriptorName ||\n              maskedCard.paymentCardDescriptor\n            \"\n            :number=\"`•••• ${maskedCard.panLastFour}`\" />\n          <p class=\"heading-md payto-text margin-bottom-none\">\n            {{ $t('fido.authentication.payto') }}\n          </p>\n          <div class=\"row-space-between\">\n            <p class=\"margin-bottom-none\">{{ merchantName }}</p>\n            <p class=\"margin-bottom-none\">{{ transactionAmount }}</p>\n          </div>\n        </al-styled-container>\n      </div>\n    </div>\n\n    <div class=\"row\">\n      <div class=\"col-full\">\n        <al-button\n          uppercase\n          :loading=\"isLoading\"\n          :label=\"$t('button.confirm')\"\n          name=\"primary-button\"\n          icon=\"icon-passkey\"\n          class=\"margin-bottom-fido\"\n          @click=\"confirm\" />\n      </div>\n      <div class=\"col-full\">\n        <div class=\"tagline-container col-horizontal-justify-center margin-bottom-fido\">\n          <p class=\"margin-bottom-none margin-right-xs heading-md\">\n            {{ $t('fido.tagline') }}\n          </p>\n          <al-branding\n            :networks=\"['mastercard']\"\n            description=\"Secure Remote Commerce\"\n            without-src-logo />\n        </div>\n      </div>\n    </div>\n  </div>\n</template>\n\n<script>\nimport { AlBranding, AlButton, AlCardPreview, AlStyledContainer } from '@mc-alberta/alcapone'\n\nexport default {\n  name: 'TuxFidoAuthentication',\n  components: { AlBranding, AlButton, AlCardPreview, AlStyledContainer },\n  props: {\n    /**\n     * Card information\n     */\n    maskedCard: {\n      type: Object,\n      default: null\n    },\n    /**\n     * To style the button as loading or not\n     */\n    isLoading: {\n      type: Boolean,\n      default: false\n    },\n    /**\n     * Name of the merchant\n     */\n    merchantName: {\n      type: String,\n      required: true\n    },\n    /**\n     * Total amount for the current transaction\n     */\n    transactionAmount: {\n      type: String,\n      required: true\n    }\n  },\n  methods: {\n    confirm() {\n      this.$emit('continue')\n    }\n  }\n}\n</script>\n\n<style scoped>\n/* TODO: Find a better solution than overriding right margin of al-branding */\n.tagline-container::v-deep .header__brand__item .card-brand-logo--mastercard {\n  margin-right: 0px;\n}\n\n.tagline-container::v-deep .header__brand__item {\n  margin-right: 0px !important;\n}\n\n.icon-biometrics {\n  width: 9.625rem; /* 154px */\n  height: 9.25rem; /* 148px */\n}\n\n.margin-top-fido {\n  margin-top: 1.5rem; /* 24px */\n}\n\n.margin-bottom-fido {\n  margin-bottom: 1.5rem; /* 24px */\n}\n\n.row-space-between {\n  margin-left: 0;\n  margin-right: 0;\n}\n\n.styled-container--card::v-deep .styled-container__item {\n  padding: 1.5rem !important; /* 24px */\n}\n\n/* TODO: Remove media queries once responsive vertical rhythm is added in alcapone */\n@media screen and (max-height: 550px) {\n  .icon-biometrics {\n    width: 5.75rem; /* 92px */\n    height: 5.5rem; /* 88px */\n  }\n\n  h1 {\n    font-size: 1.25rem; /* 20px */\n    line-height: 1.75rem; /* 28px */\n  }\n\n  .responsive-subtitle {\n    font-size: 0.938rem; /* 15px */\n    line-height: 1.438rem; /* 23px */\n  }\n\n  .margin-top-fido {\n    margin-top: 1rem; /* 16px */\n  }\n\n  .margin-bottom-fido {\n    margin-bottom: 1rem; /* 16px */\n  }\n\n  .styled-container {\n    margin-bottom: 1rem !important; /* 16px */\n  }\n\n  .styled-container--card::v-deep .styled-container__item {\n    padding: 1rem !important; /* 16px */\n  }\n}\n\n@media screen and (min-height: 550px) and (max-height: 750px) {\n  .icon-biometrics {\n    width: 7.688rem; /* 123px */\n    height: 7.375rem; /* 118px */\n  }\n\n  h1 {\n    font-size: 1.25rem; /* 20px */\n    line-height: 1.75rem; /* 28px */\n  }\n\n  .responsive-subtitle {\n    font-size: 0.938rem; /* 15px */\n    line-height: 1.438rem; /* 23px */\n  }\n\n  .margin-top-fido {\n    margin-top: 1rem; /* 16px */\n  }\n\n  .margin-bottom-fido {\n    margin-bottom: 1rem; /* 16px */\n  }\n\n  .styled-container {\n    margin-bottom: 1rem !important; /* 16px */\n  }\n\n  .styled-container--card::v-deep .styled-container__item {\n    padding: 1rem !important; /* 16px */\n  }\n}\n</style>\n"]
    },
    media: undefined
  });
};
/* scoped */
const __vue_scope_id__$3 = "data-v-06e5a6d8";
/* module identifier */
const __vue_module_identifier__$3 = undefined;
/* functional template */
const __vue_is_functional_template__$3 = false;
/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$6 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$3,
  staticRenderFns: __vue_staticRenderFns__$3
}, __vue_inject_styles__$3, __vue_script__$3, __vue_scope_id__$3, __vue_is_functional_template__$3, __vue_module_identifier__$3, false, createInjector, undefined, undefined);
var __vue_component__$7 = __vue_component__$6;

//
var script$2 = {
  name: 'TuxFidoEnrollment',
  components: {
    AlBranding,
    AlButton,
    TuxCustomConsent
  },
  props: {
    /**
     * To style the button as loading or not
     */
    isLoading: {
      type: Boolean,
      default: false
    },
    /**
     * Array of consent data objects.
     */
    consentData: {
      type: Array,
      required: true
    },
    /**
     * Is the device recognized or not for Fido
     */
    recognized: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      // assign a key to the custom consent component to force re-render
      termsConsentKey: 0
    };
  },
  computed: {
    header() {
      const title = this.recognized ? 'fido.enrollment.recognizedTitle' : 'fido.enrollment.unrecognizedTitle';
      const subtitle = this.recognized ? 'fido.enrollment.recognizedSubtitle' : 'fido.enrollment.unrecognizedSubtitle';
      return {
        title,
        subtitle
      };
    },
    primaryCtaLabel() {
      return this.recognized ? 'fido.enrollment.recognizedCtaLabel' : 'fido.enrollment.unrecognizedCtaLabel';
    }
  },
  watch: {
    consentData: {
      handler() {
        this.termsConsentKey++;
      }
    }
  },
  methods: {
    confirm() {
      this.$emit('continue');
    },
    cancel() {
      this.$emit('cancel');
    }
  }
};

/* script */
const __vue_script__$2 = script$2;

/* template */
var __vue_render__$2 = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("div", {
    staticClass: "container"
  }, [_c("div", {
    staticClass: "row row-vertical-align-center"
  }, [_c("div", {
    staticClass: "col-full align-center"
  }, [_c("i", {
    staticClass: "margin-bottom-fido icon-biometrics"
  }), _vm._v(" "), _c("h1", {
    staticClass: "margin-bottom-fido"
  }, [_vm._v(_vm._s(_vm.$t(_vm.header.title)))]), _vm._v(" "), _c("p", {
    staticClass: "margin-bottom-fido responsive-subtitle"
  }, [_vm._v("\n        " + _vm._s(_vm.$t(_vm.header.subtitle)) + "\n      ")])]), _vm._v(" "), _c("div", {
    staticClass: "row"
  }, [_c("div", {
    staticClass: "col-full"
  }, [_c("div", {
    staticClass: "tagline-container col-horizontal-justify-center margin-bottom-fido"
  }, [_c("p", {
    staticClass: "margin-bottom-none margin-right-xs"
  }, [_vm._v("\n            " + _vm._s(_vm.$t("fido.tagline")) + "\n          ")]), _vm._v(" "), _c("al-branding", {
    attrs: {
      networks: ["mastercard"],
      description: "Secure Remote Commerce",
      "without-src-logo": ""
    }
  })], 1), _vm._v(" "), _vm.recognized ? _c("p", {
    staticClass: "legal align-center",
    attrs: {
      "data-test": "recognized-legal-text"
    }
  }, [_vm._v("\n          " + _vm._s(_vm.$t("fido.enrollment.recognizedLegalText")) + "\n        ")]) : _c("tux-custom-consent", {
    key: _vm.termsConsentKey,
    attrs: {
      name: "legal-text",
      "consent-data": _vm.consentData
    }
  })], 1), _vm._v(" "), _c("div", {
    staticClass: "col-full"
  }, [_c("al-button", {
    ref: "primaryButton",
    staticClass: "margin-bottom-fido",
    attrs: {
      uppercase: "",
      loading: _vm.isLoading,
      disabled: _vm.errors.any(),
      label: _vm.$t(_vm.primaryCtaLabel),
      name: "primary-button",
      icon: "icon-passkey"
    },
    on: {
      click: _vm.confirm
    }
  }), _vm._v(" "), _c("button", {
    staticClass: "btn--secondary fill",
    attrs: {
      disabled: _vm.isLoading,
      "data-test": "secondary-button"
    },
    on: {
      click: _vm.cancel
    }
  }, [_vm._v("\n          " + _vm._s(_vm.$t("fido.enrollment.secondaryCtaLabel")) + "\n        ")])], 1)])])]);
};
var __vue_staticRenderFns__$2 = [];
__vue_render__$2._withStripped = true;

/* style */
const __vue_inject_styles__$2 = function (inject) {
  if (!inject) return;
  inject("data-v-1f3c287a_0", {
    source: "\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n/* TODO: Find a better solution than overriding right margin of al-branding */\n.tagline-container[data-v-1f3c287a] .header__brand__item .card-brand-logo--mastercard {\n  margin-right: 0px;\n}\n.tagline-container[data-v-1f3c287a] .header__brand__item {\n  margin-right: 0px !important;\n}\n.icon-biometrics[data-v-1f3c287a] {\n  width: 9.625rem; /* 154px */\n  height: 9.25rem; /* 148px */\n}\n.margin-bottom-fido[data-v-1f3c287a] {\n  margin-bottom: 1.5rem; /* 24px */\n}\n\n/* TODO: Remove media queries once responsive vertical rhythm is added in alcapone */\n@media screen and (max-height: 550px) {\n.icon-biometrics[data-v-1f3c287a] {\n    width: 5.75rem; /* 92px */\n    height: 5.5rem; /* 88px */\n}\nh1[data-v-1f3c287a] {\n    font-size: 1.25rem; /* 20px */\n    line-height: 1.75rem; /* 28px */\n}\n.responsive-subtitle[data-v-1f3c287a] {\n    font-size: 0.938rem; /* 15px */\n    line-height: 1.438rem; /* 23px */\n}\n.margin-bottom-fido[data-v-1f3c287a] {\n    margin-bottom: 1rem; /* 16px */\n}\n.styled-container[data-v-1f3c287a] {\n    margin-bottom: 1rem !important; /* 16px */\n}\n.styled-container--card[data-v-1f3c287a] .styled-container__item {\n    padding: 1rem !important; /* 16px */\n}\n}\n@media screen and (min-height: 550px) and (max-height: 750px) {\n.icon-biometrics[data-v-1f3c287a] {\n    width: 7.688rem; /* 123px */\n    height: 7.375rem; /* 118px */\n}\nh1[data-v-1f3c287a] {\n    font-size: 1.25rem; /* 20px */\n    line-height: 1.75rem; /* 28px */\n}\n.responsive-subtitle[data-v-1f3c287a] {\n    font-size: 0.938rem; /* 15px */\n    line-height: 1.438rem; /* 23px */\n}\n.margin-bottom-fido[data-v-1f3c287a] {\n    margin-bottom: 1rem; /* 16px */\n}\n.styled-container[data-v-1f3c287a] {\n    margin-bottom: 1rem !important; /* 16px */\n}\n.styled-container--card[data-v-1f3c287a] .styled-container__item {\n    padding: 1rem !important; /* 16px */\n}\n}\n",
    map: {
      "version": 3,
      "sources": ["/vol_01/sys_apps_01/jenkins/workspace/Alberta_BERT_tuxedo_master/src/components/fido/TuxFidoEnrollment.vue"],
      "names": [],
      "mappings": ";;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;AA8HA,6EAAA;AACA;EACA,iBAAA;AACA;AAEA;EACA,4BAAA;AACA;AAEA;EACA,eAAA,EAAA,UAAA;EACA,eAAA,EAAA,UAAA;AACA;AAEA;EACA,qBAAA,EAAA,SAAA;AACA;;AAEA,oFAAA;AACA;AACA;IACA,cAAA,EAAA,SAAA;IACA,cAAA,EAAA,SAAA;AACA;AAEA;IACA,kBAAA,EAAA,SAAA;IACA,oBAAA,EAAA,SAAA;AACA;AAEA;IACA,mBAAA,EAAA,SAAA;IACA,qBAAA,EAAA,SAAA;AACA;AAEA;IACA,mBAAA,EAAA,SAAA;AACA;AAEA;IACA,8BAAA,EAAA,SAAA;AACA;AAEA;IACA,wBAAA,EAAA,SAAA;AACA;AACA;AAEA;AACA;IACA,eAAA,EAAA,UAAA;IACA,gBAAA,EAAA,UAAA;AACA;AAEA;IACA,kBAAA,EAAA,SAAA;IACA,oBAAA,EAAA,SAAA;AACA;AAEA;IACA,mBAAA,EAAA,SAAA;IACA,qBAAA,EAAA,SAAA;AACA;AAEA;IACA,mBAAA,EAAA,SAAA;AACA;AAEA;IACA,8BAAA,EAAA,SAAA;AACA;AAEA;IACA,wBAAA,EAAA,SAAA;AACA;AACA",
      "file": "TuxFidoEnrollment.vue",
      "sourcesContent": ["<template>\n  <div class=\"container\">\n    <div class=\"row row-vertical-align-center\">\n      <div class=\"col-full align-center\">\n        <i class=\"margin-bottom-fido icon-biometrics\" />\n        <h1 class=\"margin-bottom-fido\">{{ $t(header.title) }}</h1>\n        <p class=\"margin-bottom-fido responsive-subtitle\">\n          {{ $t(header.subtitle) }}\n        </p>\n      </div>\n      <div class=\"row\">\n        <div class=\"col-full\">\n          <div class=\"tagline-container col-horizontal-justify-center margin-bottom-fido\">\n            <p class=\"margin-bottom-none margin-right-xs\">\n              {{ $t('fido.tagline') }}\n            </p>\n            <al-branding\n              :networks=\"['mastercard']\"\n              description=\"Secure Remote Commerce\"\n              without-src-logo />\n          </div>\n          <p v-if=\"recognized\" class=\"legal align-center\" data-test=\"recognized-legal-text\">\n            {{ $t('fido.enrollment.recognizedLegalText') }}\n          </p>\n          <tux-custom-consent\n            v-else\n            :key=\"termsConsentKey\"\n            name=\"legal-text\"\n            :consent-data=\"consentData\" />\n        </div>\n        <div class=\"col-full\">\n          <al-button\n            ref=\"primaryButton\"\n            class=\"margin-bottom-fido\"\n            uppercase\n            :loading=\"isLoading\"\n            :disabled=\"errors.any()\"\n            :label=\"$t(primaryCtaLabel)\"\n            name=\"primary-button\"\n            icon=\"icon-passkey\"\n            @click=\"confirm\" />\n          <button\n            :disabled=\"isLoading\"\n            class=\"btn--secondary fill\"\n            data-test=\"secondary-button\"\n            @click=\"cancel\">\n            {{ $t('fido.enrollment.secondaryCtaLabel') }}\n          </button>\n        </div>\n      </div>\n    </div>\n  </div>\n</template>\n\n<script>\nimport { AlBranding, AlButton } from '@mc-alberta/alcapone'\nimport TuxCustomConsent from '@/components/fido/TuxCustomConsent'\n\nexport default {\n  name: 'TuxFidoEnrollment',\n  components: { AlBranding, AlButton, TuxCustomConsent },\n  props: {\n    /**\n     * To style the button as loading or not\n     */\n    isLoading: {\n      type: Boolean,\n      default: false\n    },\n    /**\n     * Array of consent data objects.\n     */\n    consentData: {\n      type: Array,\n      required: true\n    },\n    /**\n     * Is the device recognized or not for Fido\n     */\n    recognized: {\n      type: Boolean,\n      default: false\n    }\n  },\n  data() {\n    return {\n      // assign a key to the custom consent component to force re-render\n      termsConsentKey: 0\n    }\n  },\n  computed: {\n    header() {\n      const title = this.recognized\n        ? 'fido.enrollment.recognizedTitle'\n        : 'fido.enrollment.unrecognizedTitle'\n      const subtitle = this.recognized\n        ? 'fido.enrollment.recognizedSubtitle'\n        : 'fido.enrollment.unrecognizedSubtitle'\n\n      return { title, subtitle }\n    },\n    primaryCtaLabel() {\n      return this.recognized\n        ? 'fido.enrollment.recognizedCtaLabel'\n        : 'fido.enrollment.unrecognizedCtaLabel'\n    }\n  },\n  watch: {\n    consentData: {\n      handler() {\n        this.termsConsentKey++\n      }\n    }\n  },\n  methods: {\n    confirm() {\n      this.$emit('continue')\n    },\n    cancel() {\n      this.$emit('cancel')\n    }\n  }\n}\n</script>\n\n<style scoped>\n/* TODO: Find a better solution than overriding right margin of al-branding */\n.tagline-container::v-deep .header__brand__item .card-brand-logo--mastercard {\n  margin-right: 0px;\n}\n\n.tagline-container::v-deep .header__brand__item {\n  margin-right: 0px !important;\n}\n\n.icon-biometrics {\n  width: 9.625rem; /* 154px */\n  height: 9.25rem; /* 148px */\n}\n\n.margin-bottom-fido {\n  margin-bottom: 1.5rem; /* 24px */\n}\n\n/* TODO: Remove media queries once responsive vertical rhythm is added in alcapone */\n@media screen and (max-height: 550px) {\n  .icon-biometrics {\n    width: 5.75rem; /* 92px */\n    height: 5.5rem; /* 88px */\n  }\n\n  h1 {\n    font-size: 1.25rem; /* 20px */\n    line-height: 1.75rem; /* 28px */\n  }\n\n  .responsive-subtitle {\n    font-size: 0.938rem; /* 15px */\n    line-height: 1.438rem; /* 23px */\n  }\n\n  .margin-bottom-fido {\n    margin-bottom: 1rem; /* 16px */\n  }\n\n  .styled-container {\n    margin-bottom: 1rem !important; /* 16px */\n  }\n\n  .styled-container--card::v-deep .styled-container__item {\n    padding: 1rem !important; /* 16px */\n  }\n}\n\n@media screen and (min-height: 550px) and (max-height: 750px) {\n  .icon-biometrics {\n    width: 7.688rem; /* 123px */\n    height: 7.375rem; /* 118px */\n  }\n\n  h1 {\n    font-size: 1.25rem; /* 20px */\n    line-height: 1.75rem; /* 28px */\n  }\n\n  .responsive-subtitle {\n    font-size: 0.938rem; /* 15px */\n    line-height: 1.438rem; /* 23px */\n  }\n\n  .margin-bottom-fido {\n    margin-bottom: 1rem; /* 16px */\n  }\n\n  .styled-container {\n    margin-bottom: 1rem !important; /* 16px */\n  }\n\n  .styled-container--card::v-deep .styled-container__item {\n    padding: 1rem !important; /* 16px */\n  }\n}\n</style>\n"]
    },
    media: undefined
  });
};
/* scoped */
const __vue_scope_id__$2 = "data-v-1f3c287a";
/* module identifier */
const __vue_module_identifier__$2 = undefined;
/* functional template */
const __vue_is_functional_template__$2 = false;
/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$4 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$2,
  staticRenderFns: __vue_staticRenderFns__$2
}, __vue_inject_styles__$2, __vue_script__$2, __vue_scope_id__$2, __vue_is_functional_template__$2, __vue_module_identifier__$2, false, createInjector, undefined, undefined);
var __vue_component__$5 = __vue_component__$4;

//
var script$1 = {
  name: 'TuxFidoError',
  components: {
    AlButton
  },
  props: {
    /**
     * Name of the merchant
     */
    merchantName: {
      type: String,
      default: ''
    },
    /**
     * Value used to determine the content to show
     */
    confirmPayment: {
      type: Boolean,
      required: true
    },
    /**
     * Used to determine whether to display enrollment error page or authentication Error page
     */
    isAuthError: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    title() {
      if (this.isAuthError) {
        return 'fido.error.authTitle';
      } else {
        return this.confirmPayment ? 'fido.error.paymentCompleteTitle' : 'fido.error.cardVerifiedTitle';
      }
    },
    subtitle() {
      return this.isAuthError ? 'fido.error.authSubtitle' : 'fido.error.subtitle';
    },
    primaryButtonLabel() {
      return this.isAuthError ? 'button.confirmAnotherWay' : 'button.confirm';
    }
  },
  methods: {
    confirm() {
      this.$emit('continue');
    },
    cancel() {
      this.$emit('cancel');
    }
  }
};

/* script */
const __vue_script__$1 = script$1;

/* template */
var __vue_render__$1 = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("div", {
    staticClass: "container"
  }, [!_vm.isAuthError ? _c("div", {
    staticClass: "row-banner margin-bottom-md",
    attrs: {
      "data-test": "row-banner"
    }
  }, [_c("div", {
    staticClass: "col-full"
  }, [_c("p", {
    staticClass: "info"
  }, [_c("i", {
    staticClass: "icon-info-inverse icon-size-xs"
  }), _vm._v("\n        " + _vm._s(_vm.$t("fido.error.notificationText")) + "\n      ")])])]) : _vm._e(), _vm._v(" "), _c("div", {
    staticClass: "row align-center"
  }, [_c("div", {
    staticClass: "col-full"
  }, [_c("i", {
    staticClass: "margin-bottom-md",
    class: _vm.isAuthError ? "icon-fido-error" : "icon-fido-verification",
    attrs: {
      "data-test": "error-icon"
    }
  })])]), _vm._v(" "), _c("div", {
    staticClass: "row"
  }, [_c("div", {
    staticClass: "col-full align-center"
  }, [_c("h1", {
    attrs: {
      "data-test": "title"
    }
  }, [_vm._v("\n        " + _vm._s(_vm.$t(_vm.title)) + "\n      ")]), _vm._v(" "), _vm.isAuthError || !_vm.confirmPayment ? _c("p", {
    staticClass: "margin-bottom-sm",
    attrs: {
      "data-test": "subtitle"
    }
  }, [_vm._v("\n        " + _vm._s(_vm.$t(_vm.subtitle, {
    merchant: _vm.$t(_vm.merchantName)
  })) + "\n      ")]) : _vm._e()])]), _vm._v(" "), _c("div", {
    staticClass: "row row-vertical-align-bottom"
  }, [_c("div", {
    staticClass: "col-full"
  }, [_c("al-button", {
    attrs: {
      uppercase: "",
      icon: _vm.isAuthError ? "icon-passkey" : "",
      label: _vm.$t(_vm.primaryButtonLabel),
      name: "primary-button"
    },
    on: {
      click: _vm.confirm
    }
  })], 1), _vm._v(" "), _vm.isAuthError ? _c("button", {
    staticClass: "btn--secondary fill margin-bottom-none",
    attrs: {
      "data-test": "secondary-button"
    },
    on: {
      click: _vm.cancel
    }
  }, [_vm._v("\n      " + _vm._s(_vm.$t("button.return")) + "\n    ")]) : _vm._e()])]);
};
var __vue_staticRenderFns__$1 = [];
__vue_render__$1._withStripped = true;

/* style */
const __vue_inject_styles__$1 = function (inject) {
  if (!inject) return;
  inject("data-v-65084dfe_0", {
    source: "\n.icon-fido-verification[data-v-65084dfe] {\n  width: 10.313rem;\n  height: 9.813rem;\n}\n.icon-fido-error[data-v-65084dfe] {\n  width: 9.875rem;\n  height: 9.688rem;\n}\n",
    map: {
      "version": 3,
      "sources": ["/vol_01/sys_apps_01/jenkins/workspace/Alberta_BERT_tuxedo_master/src/components/fido/TuxFidoError.vue"],
      "names": [],
      "mappings": ";AA4GA;EACA,gBAAA;EACA,gBAAA;AACA;AAEA;EACA,eAAA;EACA,gBAAA;AACA",
      "file": "TuxFidoError.vue",
      "sourcesContent": ["<template>\n  <div class=\"container\">\n    <div v-if=\"!isAuthError\" class=\"row-banner margin-bottom-md\" data-test=\"row-banner\">\n      <div class=\"col-full\">\n        <p class=\"info\">\n          <i class=\"icon-info-inverse icon-size-xs\" />\n          {{ $t('fido.error.notificationText') }}\n        </p>\n      </div>\n    </div>\n    <div class=\"row align-center\">\n      <div class=\"col-full\">\n        <i\n          class=\"margin-bottom-md\"\n          :class=\"isAuthError ? 'icon-fido-error' : 'icon-fido-verification'\"\n          data-test=\"error-icon\" />\n      </div>\n    </div>\n\n    <div class=\"row\">\n      <div class=\"col-full align-center\">\n        <h1 data-test=\"title\">\n          {{ $t(title) }}\n        </h1>\n        <p v-if=\"isAuthError || !confirmPayment\" class=\"margin-bottom-sm\" data-test=\"subtitle\">\n          {{ $t(subtitle, { merchant: $t(merchantName) }) }}\n        </p>\n      </div>\n    </div>\n\n    <div class=\"row row-vertical-align-bottom\">\n      <div class=\"col-full\">\n        <al-button\n          uppercase\n          :icon=\"isAuthError ? 'icon-passkey' : ''\"\n          :label=\"$t(primaryButtonLabel)\"\n          name=\"primary-button\"\n          @click=\"confirm\" />\n      </div>\n      <button\n        v-if=\"isAuthError\"\n        class=\"btn--secondary fill margin-bottom-none\"\n        data-test=\"secondary-button\"\n        @click=\"cancel\">\n        {{ $t('button.return') }}\n      </button>\n    </div>\n  </div>\n</template>\n\n<script>\nimport { AlButton } from '@mc-alberta/alcapone'\n\nexport default {\n  name: 'TuxFidoError',\n  components: { AlButton },\n  props: {\n    /**\n     * Name of the merchant\n     */\n    merchantName: {\n      type: String,\n      default: ''\n    },\n    /**\n     * Value used to determine the content to show\n     */\n    confirmPayment: {\n      type: Boolean,\n      required: true\n    },\n    /**\n     * Used to determine whether to display enrollment error page or authentication Error page\n     */\n    isAuthError: {\n      type: Boolean,\n      default: false\n    }\n  },\n  computed: {\n    title() {\n      if (this.isAuthError) {\n        return 'fido.error.authTitle'\n      } else {\n        return this.confirmPayment\n          ? 'fido.error.paymentCompleteTitle'\n          : 'fido.error.cardVerifiedTitle'\n      }\n    },\n    subtitle() {\n      return this.isAuthError ? 'fido.error.authSubtitle' : 'fido.error.subtitle'\n    },\n    primaryButtonLabel() {\n      return this.isAuthError ? 'button.confirmAnotherWay' : 'button.confirm'\n    }\n  },\n  methods: {\n    confirm() {\n      this.$emit('continue')\n    },\n    cancel() {\n      this.$emit('cancel')\n    }\n  }\n}\n</script>\n\n<style scoped>\n.icon-fido-verification {\n  width: 10.313rem;\n  height: 9.813rem;\n}\n\n.icon-fido-error {\n  width: 9.875rem;\n  height: 9.688rem;\n}\n</style>\n"]
    },
    media: undefined
  });
};
/* scoped */
const __vue_scope_id__$1 = "data-v-65084dfe";
/* module identifier */
const __vue_module_identifier__$1 = undefined;
/* functional template */
const __vue_is_functional_template__$1 = false;
/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$2 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$1,
  staticRenderFns: __vue_staticRenderFns__$1
}, __vue_inject_styles__$1, __vue_script__$1, __vue_scope_id__$1, __vue_is_functional_template__$1, __vue_module_identifier__$1, false, createInjector, undefined, undefined);
var __vue_component__$3 = __vue_component__$2;

//
var script = {
  name: 'TuxLocalePicker',
  components: {
    AlActionSheet,
    AlActionSheetItem,
    AlButton,
    AlDropdown,
    AlFlag,
    AlSearchableDropdownInput
  },
  provide() {
    return {
      localePickerProvider: this.localePickerProvider
    };
  },
  model: {
    prop: 'modelValue',
    event: 'update:modelValue'
  },
  props: {
    /**
     * A array of custom country configs. Each config contains the country code,
     * language codes and the default language for each country. When the prop is used,
     * the country and language dropdown will be populated from the array.
     */
    customCountryConfigs: {
      type: Array,
      default: null,
      validator: configArray => {
        return configArray.every(_ref => {
          let {
            countryCode,
            defaultLanguage,
            languageCodes
          } = _ref;
          return typeof countryCode === 'string' && countryCode !== '' && typeof defaultLanguage === 'string' && defaultLanguage !== '' && Array.isArray(languageCodes) && languageCodes.length > 0 && languageCodes.every(languageCode => typeof languageCode === 'string' && languageCode !== '');
        });
      }
    },
    descriptionTextPath: {
      type: String,
      default: 'localePicker.description'
    },
    languageOnly: {
      type: Boolean,
      default: false
    },
    legalTextPath: {
      type: String,
      default: 'localePicker.legal'
    },
    modelValue: {
      type: String,
      required: true
    },
    name: {
      type: String,
      required: true
    },
    /**
     * A callback function that returns a promise once all the asynchronous operations are completed
     */
    onBeforeDismiss: {
      type: Function,
      default: null
    }
  },
  data() {
    return {
      ACTION_SHEET: constants.ACTION_SHEET,
      previousLocale: '',
      currentCountryCode: '',
      currentLanguageCode: '',
      currentLocale: '',
      selectedCountryObject: {},
      selectedCountryCode: '',
      selectedLocale: '',
      isCountrySelectorFocused: {
        value: false
      },
      isLoading: {
        value: false
      }
    };
  },
  computed: {
    localePickerProvider() {
      return {
        getScrollOffsetTop: this.getCountryDropdownOffsetTop,
        isDisabled: this.isLoading,
        shouldScroll: this.isCountrySelectorFocused
      };
    },
    disableContinueButton() {
      const languageDropdown = this.errors?.collect('languageDropdown') || [];
      const countryDropdown = this.errors?.collect('countryDropdown') || [];
      const fieldErrors = [...languageDropdown, ...countryDropdown];
      const isValid = Object.values(this.fields).some(_ref2 => {
        let {
          valid
        } = _ref2;
        return valid;
      });
      return !isValid || fieldErrors.length > 0;
    },
    isCountrySelectorDisabled() {
      return this.errors?.collect('countryDropdown').length > 0;
    },
    translatedCountries() {
      const countryCodes = this.customCountryConfigs?.map(_ref3 => {
        let {
          countryCode
        } = _ref3;
        return countryCode;
      });
      const liveCountries = countryCodes || this.$i18nData.getLiveCountries();

      /*
       * If the live countries list does not contain the current locale
       * then update the current config with the first locale from the list
       */
      if (countryCodes && !liveCountries.includes(this.computedCountryCode)) {
        this.refreshCurrentConfig(liveCountries[0]);
      }
      if (this.languageOnly) {
        return [{
          value: this.computedCountryCode,
          label: this.$i18nData.getCountryName(this.computedCountryCode, this.currentLanguageCode)
        }];
      }
      const translatedCountries = this.$i18nData.getTranslatedCountries(this.currentLocale, liveCountries);
      return translatedCountries;
    },
    translatedLanguages() {
      if (!this.computedCountryConfig?.supportedLanguages?.length > 0) return [];
      const translatedLanguages = this.$i18nData.getTranslatedLanguages(this.currentLocale, this.computedCountryConfig.supportedLanguages);
      return translatedLanguages;
    },
    computedCountryCode() {
      return this.selectedCountryCode || this.currentCountryCode;
    },
    computedCountryConfig() {
      if (this.customCountryConfigs) {
        const {
          countryCode,
          languageCodes,
          defaultLanguage
        } = this.getCustomCountryConfig(this.computedCountryCode);
        return {
          supportedLanguages: languageCodes.map(languageCode => `${languageCode}-${countryCode}`),
          defaultLanguage: `${defaultLanguage}-${countryCode}`
        };
      }
      return this.$i18nData.getCountryConfig(this.computedCountryCode) || {};
    },
    computedCountryName() {
      return this.$i18nData.getCountryName(this.computedCountryCode, this.currentLocale) || '';
    },
    supportedLocale() {
      const locale = this.translatedLanguages.find(e => {
        const {
          languageCode
        } = this.$i18nData.getLocaleParts(e.value) || {};
        return languageCode === this.currentLanguageCode;
      });
      return locale?.value;
    }
  },
  watch: {
    '$i18n.locale': {
      immediate: true,
      handler(newLocale) {
        this.setLocaleValues(newLocale);
      }
    }
  },
  created() {
    if (this.modelValue) {
      this.setLocaleValues(this.modelValue);
      this.previousLocale = this.modelValue;
    } else {
      this.setLocaleValues(this.$i18n.locale);
      this.previousLocale = this.$i18n.locale;
    }
    this.selectedCountryObject = {
      value: this.computedCountryCode,
      label: this.computedCountryName
    };
    this.selectedLocale = this.currentLocale;
  },
  methods: {
    getCustomCountryConfig(locale) {
      return this.customCountryConfigs?.filter(country => country.countryCode === locale)?.[0];
    },
    getCountryDropdownOffsetTop() {
      return this.$refs.countryDropdown?.$el.offsetTop || 0;
    },
    handleFocus() {
      this.isCountrySelectorFocused.value = true;
    },
    handleBlur() {
      this.isCountrySelectorFocused.value = false;
    },
    handleCountryInput(val) {
      if (!val.value) return;
      this.selectedCountryCode = val.value;
      this.selectedCountryObject = {
        value: this.computedCountryCode,
        label: this.computedCountryName
      };
      this.selectedLocale = this.supportedLocale || this.computedCountryConfig.defaultLanguage;
      this.$emit('update:modelValue', this.selectedLocale);
    },
    handleLanguageInput(val) {
      this.selectedLocale = val;
      this.$emit('update:modelValue', this.selectedLocale);
    },
    handleOpen(eventPayload) {
      this.previousLocale = this.currentLocale;
      this.selectedCountryObject = {
        value: this.computedCountryCode,
        label: this.computedCountryName
      };
      this.selectedLocale = this.currentLocale;
      this.$emit('open', {
        ...eventPayload,
        currentLocale: this.currentLocale
      });
    },
    async handleCta(close) {
      this.$emit('update:modelValue', this.selectedLocale);
      this.$emit('confirm', this.selectedLocale);
      if (this.onBeforeDismiss) {
        this.isLoading.value = true;
        await this.onBeforeDismiss(this.selectedLocale);
        this.isLoading.value = false;
      }
      close();
      this.reset();
    },
    handleDismiss(eventPayload) {
      this.$emit('update:modelValue', this.previousLocale);
      this.$emit('dismiss', eventPayload);
      this.reset();
    },
    /**
     * Used to update stored values. When the stored current country
     * is missing from the custom country configs list, the stored value for
     * current country and selected country will be replaced by a country
     * from the custom country configs list.
     *
     * @param country - Code for the country that will be used to replace
     * the stored config values.
     */
    refreshCurrentConfig(country) {
      const {
        countryCode,
        defaultLanguage
      } = this.getCustomCountryConfig(country);
      const locale = `${defaultLanguage}-${countryCode}`;
      this.currentCountryCode = countryCode;
      this.currentLanguageCode = defaultLanguage;
      this.currentLocale = locale;
      this.selectedCountryCode = countryCode;
      this.selectedLocale = locale;
      this.selectedCountryObject = {
        value: this.computedCountryCode,
        label: this.computedCountryName
      };
    },
    reset() {
      this.selectedCountryObject = {};
      this.selectedCountryCode = '';
      this.selectedLocale = '';
    },
    setLocaleValues(locale) {
      const {
        languageCode,
        countryCode
      } = this.$i18nData.getLocaleParts(locale) || {};
      if (!languageCode && !countryCode) return;
      this.currentLocale = locale;
      this.currentCountryCode = countryCode || this.currentCountryCode;
      this.currentLanguageCode = languageCode || this.currentLanguageCode;
    }
  }
};

/* script */
const __vue_script__ = script;

/* template */
var __vue_render__ = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("al-action-sheet", {
    attrs: {
      name: _vm.name
    },
    on: {
      open: _vm.handleOpen,
      dismiss: _vm.handleDismiss
    }
  }, [_c("al-action-sheet-item", _vm._g({
    attrs: {
      "close-label": _vm.$t("accessibility.close"),
      label: "",
      name: _vm.ACTION_SHEET.CONFIRM_COUNTRY_AND_LANGUAGE
    },
    on: {
      dismiss: _vm.handleDismiss
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (ref) {
        var close = ref.close;
        return [_c("div", {
          staticClass: "row"
        }, [_c("div", {
          staticClass: "col-full margin-bottom-md margin-top-md align-center"
        }, [_c("i", {
          staticClass: "icon-globe-gears"
        })]), _vm._v(" "), _c("div", {
          staticClass: "col-full"
        }, [_c("p", {
          staticClass: "heading-xl"
        }, [_vm._v("\n          " + _vm._s(_vm.$t("localePicker.heading", _vm.selectedLocale)) + "\n        ")])]), _vm._v(" "), _c("div", {
          staticClass: "col-full"
        }, [_c("p", {
          attrs: {
            "data-test": "localePicker-description"
          }
        }, [_vm._v("\n          " + _vm._s(_vm.$t(_vm.descriptionTextPath, _vm.selectedLocale)) + "\n        ")])]), _vm._v(" "), _c("div", {
          staticClass: "col-full"
        }, [_c("al-searchable-dropdown-input", {
          ref: "countryDropdown",
          attrs: {
            name: "countryDropdown",
            label: _vm.$t("localePicker.countryLabel", _vm.selectedLocale),
            items: _vm.translatedCountries,
            disabled: _vm.isLoading.value
          },
          on: {
            input: _vm.handleCountryInput,
            focus: _vm.handleFocus,
            blur: _vm.handleBlur
          },
          scopedSlots: _vm._u([_vm.languageOnly || _vm.translatedCountries.length === 1 ? {
            key: "floatingLabel",
            fn: function (slotProps) {
              return [_vm._v("\n            " + _vm._s(slotProps.item.label) + "\n            "), _c("al-flag", {
                attrs: {
                  "country-code": slotProps.item.value
                }
              })];
            }
          } : {
            key: "datalistOption",
            fn: function (slotProps) {
              return [_vm._v("\n            " + _vm._s(slotProps.item.label) + "\n            "), _c("al-flag", {
                attrs: {
                  "country-code": slotProps.item.value
                }
              })];
            }
          }], null, true),
          model: {
            value: _vm.selectedCountryObject,
            callback: function ($$v) {
              _vm.selectedCountryObject = $$v;
            },
            expression: "selectedCountryObject"
          }
        })], 1), _vm._v(" "), _c("div", {
          staticClass: "col-full"
        }, [_c("al-dropdown", {
          directives: [{
            name: "validate",
            rawName: "v-validate",
            value: "required",
            expression: "'required'"
          }],
          attrs: {
            name: "languageDropdown",
            disabled: _vm.isLoading.value || _vm.isCountrySelectorDisabled,
            label: _vm.$t("localePicker.languageLabel", _vm.selectedLocale),
            options: _vm.translatedLanguages,
            value: _vm.selectedLocale
          },
          on: {
            input: _vm.handleLanguageInput
          }
        })], 1)]), _vm._v(" "), _c("div", {
          staticClass: "row-vertical-align-bottom"
        }, [_c("div", {
          staticClass: "col-full align-center"
        }, [_c("p", {
          staticClass: "legal"
        }, [_vm._v("\n          " + _vm._s(_vm.$t(_vm.legalTextPath, _vm.selectedLocale)) + "\n        ")])]), _vm._v(" "), _c("div", {
          staticClass: "col-full"
        }, [_c("al-button", {
          attrs: {
            uppercase: "",
            loading: _vm.isLoading.value,
            disabled: _vm.disableContinueButton,
            label: _vm.$t("localePicker.confirm", _vm.selectedLocale),
            name: "confirm-language-button"
          },
          on: {
            click: function ($event) {
              return _vm.handleCta(close);
            }
          }
        })], 1)])];
      }
    }])
  }, _vm.$listeners))], 1);
};
var __vue_staticRenderFns__ = [];
__vue_render__._withStripped = true;

/* style */
const __vue_inject_styles__ = function (inject) {
  if (!inject) return;
  inject("data-v-88e338da_0", {
    source: "\n.icon-globe-gears[data-v-88e338da] {\n  width: 120px;\n  height: 126px;\n}\n",
    map: {
      "version": 3,
      "sources": ["/vol_01/sys_apps_01/jenkins/workspace/Alberta_BERT_tuxedo_master/src/components/locale/TuxLocalePicker.vue"],
      "names": [],
      "mappings": ";AA8XA;EACA,YAAA;EACA,aAAA;AACA",
      "file": "TuxLocalePicker.vue",
      "sourcesContent": ["<template>\n  <al-action-sheet :name=\"name\" @open=\"handleOpen\" @dismiss=\"handleDismiss\">\n    <al-action-sheet-item\n      v-slot=\"{ close }\"\n      :close-label=\"$t('accessibility.close')\"\n      label=\"\"\n      :name=\"ACTION_SHEET.CONFIRM_COUNTRY_AND_LANGUAGE\"\n      v-on=\"$listeners\"\n      @dismiss=\"handleDismiss\">\n      <div class=\"row\">\n        <div class=\"col-full margin-bottom-md margin-top-md align-center\">\n          <i class=\"icon-globe-gears\"></i>\n        </div>\n        <div class=\"col-full\">\n          <p class=\"heading-xl\">\n            {{ $t('localePicker.heading', selectedLocale) }}\n          </p>\n        </div>\n        <div class=\"col-full\">\n          <p data-test=\"localePicker-description\">\n            {{ $t(descriptionTextPath, selectedLocale) }}\n          </p>\n        </div>\n        <div class=\"col-full\">\n          <al-searchable-dropdown-input\n            ref=\"countryDropdown\"\n            v-model=\"selectedCountryObject\"\n            name=\"countryDropdown\"\n            :label=\"$t('localePicker.countryLabel', selectedLocale)\"\n            :items=\"translatedCountries\"\n            :disabled=\"isLoading.value\"\n            @input=\"handleCountryInput\"\n            @focus=\"handleFocus\"\n            @blur=\"handleBlur\">\n            <template\n              v-if=\"languageOnly || translatedCountries.length === 1\"\n              #floatingLabel=\"slotProps\">\n              {{ slotProps.item.label }}\n              <al-flag :country-code=\"slotProps.item.value\" />\n            </template>\n            <template v-else #datalistOption=\"slotProps\">\n              {{ slotProps.item.label }}\n              <al-flag :country-code=\"slotProps.item.value\" />\n            </template>\n          </al-searchable-dropdown-input>\n        </div>\n        <div class=\"col-full\">\n          <al-dropdown\n            v-validate=\"'required'\"\n            name=\"languageDropdown\"\n            :disabled=\"isLoading.value || isCountrySelectorDisabled\"\n            :label=\"$t('localePicker.languageLabel', selectedLocale)\"\n            :options=\"translatedLanguages\"\n            :value=\"selectedLocale\"\n            @input=\"handleLanguageInput\" />\n        </div>\n      </div>\n      <div class=\"row-vertical-align-bottom\">\n        <div class=\"col-full align-center\">\n          <p class=\"legal\">\n            {{ $t(legalTextPath, selectedLocale) }}\n          </p>\n        </div>\n        <div class=\"col-full\">\n          <al-button\n            uppercase\n            :loading=\"isLoading.value\"\n            :disabled=\"disableContinueButton\"\n            :label=\"$t('localePicker.confirm', selectedLocale)\"\n            name=\"confirm-language-button\"\n            @click=\"handleCta(close)\" />\n        </div>\n      </div>\n    </al-action-sheet-item>\n  </al-action-sheet>\n</template>\n\n<script>\nimport {\n  AlActionSheet,\n  AlActionSheetItem,\n  AlButton,\n  AlDropdown,\n  AlFlag,\n  AlSearchableDropdownInput\n} from '@mc-alberta/alcapone'\nimport { ACTION_SHEET } from '@/constants'\n\nexport default {\n  name: 'TuxLocalePicker',\n  components: {\n    AlActionSheet,\n    AlActionSheetItem,\n    AlButton,\n    AlDropdown,\n    AlFlag,\n    AlSearchableDropdownInput\n  },\n  provide() {\n    return {\n      localePickerProvider: this.localePickerProvider\n    }\n  },\n  model: {\n    prop: 'modelValue',\n    event: 'update:modelValue'\n  },\n  props: {\n    /**\n     * A array of custom country configs. Each config contains the country code,\n     * language codes and the default language for each country. When the prop is used,\n     * the country and language dropdown will be populated from the array.\n     */\n    customCountryConfigs: {\n      type: Array,\n      default: null,\n      validator: (configArray) => {\n        return configArray.every(({ countryCode, defaultLanguage, languageCodes }) => {\n          return (\n            typeof countryCode === 'string' &&\n            countryCode !== '' &&\n            typeof defaultLanguage === 'string' &&\n            defaultLanguage !== '' &&\n            Array.isArray(languageCodes) &&\n            languageCodes.length > 0 &&\n            languageCodes.every(\n              (languageCode) => typeof languageCode === 'string' && languageCode !== ''\n            )\n          )\n        })\n      }\n    },\n    descriptionTextPath: {\n      type: String,\n      default: 'localePicker.description'\n    },\n    languageOnly: {\n      type: Boolean,\n      default: false\n    },\n    legalTextPath: {\n      type: String,\n      default: 'localePicker.legal'\n    },\n    modelValue: {\n      type: String,\n      required: true\n    },\n    name: {\n      type: String,\n      required: true\n    },\n    /**\n     * A callback function that returns a promise once all the asynchronous operations are completed\n     */\n    onBeforeDismiss: {\n      type: Function,\n      default: null\n    }\n  },\n  data() {\n    return {\n      ACTION_SHEET,\n      previousLocale: '',\n      currentCountryCode: '',\n      currentLanguageCode: '',\n      currentLocale: '',\n      selectedCountryObject: {},\n      selectedCountryCode: '',\n      selectedLocale: '',\n      isCountrySelectorFocused: { value: false },\n      isLoading: {\n        value: false\n      }\n    }\n  },\n  computed: {\n    localePickerProvider() {\n      return {\n        getScrollOffsetTop: this.getCountryDropdownOffsetTop,\n        isDisabled: this.isLoading,\n        shouldScroll: this.isCountrySelectorFocused\n      }\n    },\n    disableContinueButton() {\n      const languageDropdown = this.errors?.collect('languageDropdown') || []\n      const countryDropdown = this.errors?.collect('countryDropdown') || []\n      const fieldErrors = [...languageDropdown, ...countryDropdown]\n      const isValid = Object.values(this.fields).some(({ valid }) => valid)\n\n      return !isValid || fieldErrors.length > 0\n    },\n    isCountrySelectorDisabled() {\n      return this.errors?.collect('countryDropdown').length > 0\n    },\n    translatedCountries() {\n      const countryCodes = this.customCountryConfigs?.map(({ countryCode }) => {\n        return countryCode\n      })\n      const liveCountries = countryCodes || this.$i18nData.getLiveCountries()\n\n      /*\n       * If the live countries list does not contain the current locale\n       * then update the current config with the first locale from the list\n       */\n      if (countryCodes && !liveCountries.includes(this.computedCountryCode)) {\n        this.refreshCurrentConfig(liveCountries[0])\n      }\n\n      if (this.languageOnly) {\n        return [\n          {\n            value: this.computedCountryCode,\n            label: this.$i18nData.getCountryName(this.computedCountryCode, this.currentLanguageCode)\n          }\n        ]\n      }\n      const translatedCountries = this.$i18nData.getTranslatedCountries(\n        this.currentLocale,\n        liveCountries\n      )\n\n      return translatedCountries\n    },\n    translatedLanguages() {\n      if (!this.computedCountryConfig?.supportedLanguages?.length > 0) return []\n      const translatedLanguages = this.$i18nData.getTranslatedLanguages(\n        this.currentLocale,\n        this.computedCountryConfig.supportedLanguages\n      )\n      return translatedLanguages\n    },\n    computedCountryCode() {\n      return this.selectedCountryCode || this.currentCountryCode\n    },\n    computedCountryConfig() {\n      if (this.customCountryConfigs) {\n        const { countryCode, languageCodes, defaultLanguage } = this.getCustomCountryConfig(\n          this.computedCountryCode\n        )\n\n        return {\n          supportedLanguages: languageCodes.map((languageCode) => `${languageCode}-${countryCode}`),\n          defaultLanguage: `${defaultLanguage}-${countryCode}`\n        }\n      }\n\n      return this.$i18nData.getCountryConfig(this.computedCountryCode) || {}\n    },\n    computedCountryName() {\n      return this.$i18nData.getCountryName(this.computedCountryCode, this.currentLocale) || ''\n    },\n    supportedLocale() {\n      const locale = this.translatedLanguages.find((e) => {\n        const { languageCode } = this.$i18nData.getLocaleParts(e.value) || {}\n        return languageCode === this.currentLanguageCode\n      })\n\n      return locale?.value\n    }\n  },\n  watch: {\n    '$i18n.locale': {\n      immediate: true,\n      handler(newLocale) {\n        this.setLocaleValues(newLocale)\n      }\n    }\n  },\n  created() {\n    if (this.modelValue) {\n      this.setLocaleValues(this.modelValue)\n      this.previousLocale = this.modelValue\n    } else {\n      this.setLocaleValues(this.$i18n.locale)\n      this.previousLocale = this.$i18n.locale\n    }\n    this.selectedCountryObject = {\n      value: this.computedCountryCode,\n      label: this.computedCountryName\n    }\n    this.selectedLocale = this.currentLocale\n  },\n  methods: {\n    getCustomCountryConfig(locale) {\n      return this.customCountryConfigs?.filter((country) => country.countryCode === locale)?.[0]\n    },\n    getCountryDropdownOffsetTop() {\n      return this.$refs.countryDropdown?.$el.offsetTop || 0\n    },\n    handleFocus() {\n      this.isCountrySelectorFocused.value = true\n    },\n    handleBlur() {\n      this.isCountrySelectorFocused.value = false\n    },\n    handleCountryInput(val) {\n      if (!val.value) return\n\n      this.selectedCountryCode = val.value\n      this.selectedCountryObject = {\n        value: this.computedCountryCode,\n        label: this.computedCountryName\n      }\n\n      this.selectedLocale = this.supportedLocale || this.computedCountryConfig.defaultLanguage\n      this.$emit('update:modelValue', this.selectedLocale)\n    },\n    handleLanguageInput(val) {\n      this.selectedLocale = val\n      this.$emit('update:modelValue', this.selectedLocale)\n    },\n    handleOpen(eventPayload) {\n      this.previousLocale = this.currentLocale\n      this.selectedCountryObject = {\n        value: this.computedCountryCode,\n        label: this.computedCountryName\n      }\n      this.selectedLocale = this.currentLocale\n      this.$emit('open', { ...eventPayload, currentLocale: this.currentLocale })\n    },\n    async handleCta(close) {\n      this.$emit('update:modelValue', this.selectedLocale)\n      this.$emit('confirm', this.selectedLocale)\n\n      if (this.onBeforeDismiss) {\n        this.isLoading.value = true\n\n        await this.onBeforeDismiss(this.selectedLocale)\n\n        this.isLoading.value = false\n      }\n\n      close()\n      this.reset()\n    },\n    handleDismiss(eventPayload) {\n      this.$emit('update:modelValue', this.previousLocale)\n      this.$emit('dismiss', eventPayload)\n      this.reset()\n    },\n    /**\n     * Used to update stored values. When the stored current country\n     * is missing from the custom country configs list, the stored value for\n     * current country and selected country will be replaced by a country\n     * from the custom country configs list.\n     *\n     * @param country - Code for the country that will be used to replace\n     * the stored config values.\n     */\n    refreshCurrentConfig(country) {\n      const { countryCode, defaultLanguage } = this.getCustomCountryConfig(country)\n      const locale = `${defaultLanguage}-${countryCode}`\n\n      this.currentCountryCode = countryCode\n      this.currentLanguageCode = defaultLanguage\n      this.currentLocale = locale\n      this.selectedCountryCode = countryCode\n      this.selectedLocale = locale\n      this.selectedCountryObject = {\n        value: this.computedCountryCode,\n        label: this.computedCountryName\n      }\n    },\n    reset() {\n      this.selectedCountryObject = {}\n      this.selectedCountryCode = ''\n      this.selectedLocale = ''\n    },\n    setLocaleValues(locale) {\n      const { languageCode, countryCode } = this.$i18nData.getLocaleParts(locale) || {}\n      if (!languageCode && !countryCode) return\n\n      this.currentLocale = locale\n      this.currentCountryCode = countryCode || this.currentCountryCode\n      this.currentLanguageCode = languageCode || this.currentLanguageCode\n    }\n  }\n}\n</script>\n\n<style scoped>\n.icon-globe-gears {\n  width: 120px;\n  height: 126px;\n}\n</style>\n"]
    },
    media: undefined
  });
};
/* scoped */
const __vue_scope_id__ = "data-v-88e338da";
/* module identifier */
const __vue_module_identifier__ = undefined;
/* functional template */
const __vue_is_functional_template__ = false;
/* style inject SSR */

/* style inject shadow dom */

const __vue_component__ = /*#__PURE__*/normalizeComponent({
  render: __vue_render__,
  staticRenderFns: __vue_staticRenderFns__
}, __vue_inject_styles__, __vue_script__, __vue_scope_id__, __vue_is_functional_template__, __vue_module_identifier__, false, createInjector, undefined, undefined);
var __vue_component__$1 = __vue_component__;

var components = /*#__PURE__*/Object.freeze({
  __proto__: null,
  TuxAddressForm: TuxAddressForm,
  TuxAddressLabel: TuxAddressLabel,
  TuxCvcVerification: __vue_component__$x,
  TuxFidoAuthentication: __vue_component__$7,
  TuxFidoEnrollment: __vue_component__$5,
  TuxFidoError: __vue_component__$3,
  TuxFraudProtection: TuxFraudProtection,
  TuxCustomConsent: TuxCustomConsent,
  TuxGoogleConsent: TuxGoogleConsent,
  TuxLocalePicker: __vue_component__$1,
  TuxMdesVerificationOptions: __vue_component__$s,
  TuxMessage: __vue_component__$q,
  TuxProfileConfirmation: __vue_component__$o,
  TuxProvisionCreate: __vue_component__$e,
  TuxPushNotification: __vue_component__$c,
  TuxTermsConsent: TuxTermsConsent,
  TuxVerification: __vue_component__$a,
  TuxVerificationOptions: TuxVerificationOptions
});

/**
 * @deprecated
 * Vue plugin is deprecated. Should import individual components where needed for tree-shaking.
 *
 * @example
 * <template>
 *   <tux-provision-create />
 * </template>
 *
 * import { TuxProvisionCreate } from '@mc-alberta/Tuxedo'
 *
 * export default {
 *   name: 'SomeComponent',
 *   components: { TuxProvisionCreate }
 * }
 */
var index = {
  install(Vue) {
    Vue.mixin({
      components
    });
  }
};

export { TuxAddressForm, TuxAddressLabel, TuxCustomConsent, __vue_component__$x as TuxCvcVerification, __vue_component__$7 as TuxFidoAuthentication, __vue_component__$5 as TuxFidoEnrollment, __vue_component__$3 as TuxFidoError, TuxFraudProtection, TuxGoogleConsent, __vue_component__$1 as TuxLocalePicker, __vue_component__$s as TuxMdesVerificationOptions, __vue_component__$q as TuxMessage, __vue_component__$o as TuxProfileConfirmation, __vue_component__$e as TuxProvisionCreate, __vue_component__$c as TuxPushNotification, TuxTermsConsent, __vue_component__$a as TuxVerification, TuxVerificationOptions, index as default, setAutocompleteApiKey };
//# sourceMappingURL=index.esm.js.map
